const messages = {
  es: {
    translations: {
			contactWhatsappStatus: {
				online: "en línea",
				typing: "escribiendo...",
				recording: "grabando audio...",
				lastSeen: "últ. vez {{when}}",
				todayAt: "hoy a las {{time}}",
				yesterdayAt: "ayer a las {{time}}",
				dateAt: "el {{date}} a las {{time}}",
				stories: {
					open: "Ver estado",
					close: "Cerrar",
					previous: "Estado anterior",
					next: "Siguiente estado",
					loadError: "No se pudo cargar este estado.",
					retry: "Intentar de nuevo",
				},
			},
			ticketRatings: {
				title: "Evaluaciones de atención",
				subtitle: "Al finalizar una atención, el cliente da una nota de 0 a 10. Aquí sigues la satisfacción de la empresa y de cada agente.",
				disabledNotice: {
					admin: "Las evaluaciones están desactivadas: no se envía ninguna solicitud de nota. Actívalas en la pestaña Configuración.",
					user: "Las evaluaciones están desactivadas: no se envía ninguna solicitud de nota. Pide a un administrador que las active.",
				},
				tabs: {
					overview: "Panel",
					responses: "Respuestas",
					settings: "Configuración",
				},
				filters: {
					from: "Fecha inicial",
					to: "Fecha final",
					user: "Agente",
					connection: "Conexión",
					status: "Situación",
					all: "Todos",
					submit: "Actualizar",
				},
				status: {
					answered: "Respondida",
					no_answer: "Sin respuesta",
					waiting: "Esperando",
				},
				cards: {
					nps: "NPS",
					average: "Nota media",
					averageHint: "en una escala de 0 a {{max}}",
					responseRate: "Tasa de respuesta",
					responseRateHint: "{{answered}} de {{sent}} clientes respondieron",
					noAnswer: "Sin respuesta",
					waitingHint: "{{total}} aún dentro del plazo",
					noAnswers: "Todavía no hay notas en este período.",
				},
				zones: {
					critical: "Crítico",
					improvement: "Mejora",
					quality: "Calidad",
					excellence: "Excelencia",
				},
				groups: {
					promoter: {
						name: "Promotor",
						label: "Promotores (9 y 10)",
						description: "Clientes encantados, que recomendarían la empresa.",
					},
					passive: {
						name: "Neutro",
						label: "Neutros (7 y 8)",
						description: "Satisfechos, pero sin entusiasmo. No cuentan en el NPS.",
					},
					detractor: {
						name: "Detractor",
						label: "Detractores (0 a 6)",
						description: "Clientes insatisfechos. Conviene abrir la conversación y entender el motivo.",
					},
				},
				howToRead: {
					title: "Cómo leer las notas",
					subtitle: "Cada respuesta de 0 a {{max}} entra en uno de tres grupos:",
					formula: "NPS = % de promotores − % de detractores. Va de −100 (todos insatisfechos) a +100 (todos encantados).",
				},
				npsBlock: {
					title: "Termómetro del NPS",
					subtitle: "NPS {{nps}} — rango {{zone}}, con base en {{total}} respuestas.",
					split: "Cómo se dividen las respuestas",
				},
				charts: {
					distributionTitle: "Cuántas veces apareció cada nota",
					distributionSubtitle: "Las barras de la derecha (verde) son clientes encantados; las de la izquierda (rojo), insatisfechos.",
					rateAxis: "Nota",
					rateTooltip: "Nota {{rate}}",
					responses: "{{count}} respuesta",
					responses_plural: "{{count}} respuestas",
					average: "Media",
					timelineTitle: "Nota media por día",
					timelineSubtitle: "Los días sin respuesta quedan sin punto. Pasa el mouse para ver cuántas notas hubo ese día.",
				},
				ranking: {
					title: "Desempeño por agente",
					subtitle: "Ordenado por NPS. La barra muestra la mezcla de promotores, neutros y detractores de cada uno.",
					sent: "Solicitudes",
					answered: "Respondidas",
					split: "Composición",
				},
				table: {
					user: "Agente",
					sentAt: "Enviado el",
					contact: "Contacto",
					connection: "Conexión",
					rating: "Nota",
					answeredAt: "Respondido el",
					ticket: "Ticket",
					empty: "No hay evaluaciones en este período.",
				},
				responses: {
					title: "Todas las respuestas",
					subtitle: "Cada solicitud enviada en el período. \"Sin respuesta\": el cliente no respondió con un número dentro del plazo.",
				},
				settings: {
					title: "Pregunta enviada al cliente",
					enabled: "Enviar la pregunta de evaluación al finalizar la atención",
					message: "Pregunta de evaluación",
					messageHelp: "Pide al cliente que responda con un número de {{min}} a {{max}}. Usa {{firstName}} o {{name}} para el nombre del contacto.",
					thanksMessage: "Mensaje de agradecimiento",
					thanksMessageHelp: "Se envía después de que el cliente responde con la nota. Déjalo en blanco para no enviar.",
					windowHours: "Plazo para responder (horas)",
					windowHoursHelp: "De 1 a 168 horas. Después, la solicitud queda como \"Sin respuesta\".",
					save: "Guardar",
					saving: "Guardando...",
					saved: "Configuración de evaluación guardada.",
					howItWorks: "Cómo funciona",
					steps: {
						close: "El agente finaliza la atención en WhatsApp (QR o API oficial) y el cliente recibe la pregunta pidiendo una nota de {{min}} a {{max}}.",
						reply: "Si responde solo con el número en hasta {{hours}} h, la nota se guarda para el agente y recibe el agradecimiento.",
						noReply: "Si no responde, o escribe otra cosa, no se guarda nada: la atención aparece como \"Sin respuesta\" y la conversación sigue normalmente.",
					},
					preview: "Vista previa en WhatsApp",
				},
				dashboardColumn: {
					title: "Nota media (0 a 10)",
					hint: "Media de las notas de 0 a 10 recibidas en el período. Detalles en la pantalla Evaluaciones.",
					count: "({{total}})",
				},
			},
			connectionLogs: {
				title: "Registros de conexión — {{name}}",
				subtitle: "Auditoría de eventos de la sesión registrados por el servidor (visible solo para soporte)",
				currentState: "Estado actual:",
				chips: {
					database: "base de datos: {{value}}",
					memory: "memoria: {{value}}",
					reconnections: "reconexiones: {{value}}",
					code: "cód.: {{value}}",
				},
				timeline: "última reconexión: {{lastReconnect}} | próximo intento: {{nextRetry}} | último health check: {{lastHealthCheck}}",
				scheduler: "programador de reconexión (global): cola {{queued}} | snapshot a las {{generatedAt}}",
				hideQr: "Ocultar eventos de código QR",
				totalEvents: "{{count}} evento en total",
				totalEvents_plural: "{{count}} eventos en total",
				empty: "Ningún evento registrado para esta conexión.",
				user: "usuario: {{name}}",
				reload: "Recargar",
			},
			contactChat: {
				otherUsers: {
					intro: "Este contacto tiene {{count}} ticket(s) abierto(s) con otros agentes:",
					noQueue: "Sin cola",
					attendant: "Agente",
					assumeThis: "Asumir este ticket",
					assume: "Asumir ticket",
					anotherAttendant: "otro agente",
					belongsTo: "El ticket pertenece a otro agente ({{name}}).",
					dialogTitle: "Tickets existentes para este contacto",
					dialogIntro: "Este contacto tiene ticket(s) abierto(s) con otro(s) agente(s). Asuma un ticket para continuar la atención.",
					dialogIntroWithNew: "Este contacto tiene un ticket abierto con otro agente. Asuma el ticket o abra uno nuevo suyo para enviar el mensaje.",
					createNew: "Abrir nuevo ticket",
				},
				agent: {
					typing: "El agente \"{{name}}\" está escribiendo...",
					handling: "El ticket está siendo atendido por un agente ({{name}}).",
					fallbackName: "Agente #{{id}}",
				},
				connection: "Conexión: {{name}}",
				autoConnection: "Conexión automática (predeterminada del sistema)",
				errors: {
					connectionNotAssigned: "Este ticket pertenece a una conexión que no está asignada a su usuario.",
					conversationConnectionNotAssigned: "Esta conversación pertenece a una conexión que no está asignada a su usuario.",
					noQueueAccess: "No tiene acceso a la cola de este ticket",
					noQueuelessPermission: "No tiene permiso para asumir tickets sin cola (allTicket deshabilitado).",
				},
				toasts: {
					ticketAssumed: "¡Ticket asumido con éxito!",
				},
				connectionTooltip: "Conexión: {{name}} — haga clic para cambiar",
				chooseConnectionTooltip: "Haga clic para elegir la conexión",
				selectConnection: "Seleccionar conexión",
				callConnectionTitle: "¿Llamar por cuál conexión?",
				thisConnection: "esta conexión",
				groupElsewhere: "Grupo en atención en la conexión {{connection}} (#{{id}}): al enviar por {{target}} el ticket será movido.",
				history: {
					viewAll: "Ver todos los mensajes",
					selectTicket: "Seleccione un ticket",
					ticketOption: "Ticket #{{id}} • {{status}}",
					status: {
						open: "Atendiendo",
						pending: "Esperando",
						closed: "Resuelto",
					},
				},
				templatePicker: {
					title: "Enviar plantilla de mensaje",
					description: "Conexión vía API Oficial (Cloud API). Envíe una plantilla de mensaje aprobada para iniciar la conversación.",
					noTemplates: "No se encontró ninguna plantilla de mensaje aprobada. Cree plantillas y envíelas para aprobación en la página de Plantillas.",
					selectTemplate: "Seleccione una plantilla",
					preview: "Vista previa:",
					emptyBody: "(Sin texto en el cuerpo)",
					variables: "Variables:",
					variable: "Variable",
					send: "Enviar",
					sending: "Enviando...",
					sent: "¡Plantilla enviada con éxito!",
				},
			},
			tagsContainer: {
				placeholder: "Etiquetas del ticket",
			},
			connectionDisconnectedBanner: {
				message: "La conexión \"{{name}}\" de este ticket está desconectada. Las respuestas no se enviarán hasta que se reconecte o el ticket sea transferido a otra conexión.",
			},
			sentMessageOrigin: {
				labels: {
					campaign: "Campaña",
					schedule: "Agendamiento",
					external: "Envío externo",
				},
				noTicket: {
					campaign: "Mensaje de campaña enviado el {{date}} (sin ticket)",
					schedule: "Mensaje programado enviado el {{date}} (sin ticket)",
					external: "Envío externo el {{date}} (sin ticket)",
				},
			},
			messagePreview: {
				received: "Recibido",
				image: "Imagen",
				video: "Video",
				audio: "Audio",
				file: "Archivo",
				sticker: "Sticker",
				location: "Ubicación",
				contacts: "Varios contactos",
				contactSent: "Contacto enviado: {{name}}",
				catalogProduct: "🛍️ Producto del catálogo",
				orderReceived: "🛒 Pedido recibido",
				externalMessage: "Mensaje enviado externamente",
				reaction: "Reacción",
				deleted: "Mensaje eliminado",
				withoutContent: "Mensaje sin contenido",
				noMessages: "Sin mensajes",
			},
			sessionStatusIndicator: {
				extended: "Sesión prolongada",
				minutes: "{{minutes}}min",
				expiresIn: "La sesión expira en {{minutes}} minutos",
				noExpiry: "Las sesiones están configuradas para no expirar automáticamente",
			},
			deleteAccountModal: {
				title: "Eliminar mi cuenta",
				intro: "Esta acción es permanente. Esto es lo que ocurre al eliminar su cuenta:",
				userScope: {
					access: "Su acceso al sistema se cerrará de inmediato.",
					tickets: "Sus tickets abiertos volverán a la cola.",
				},
				companyScope: {
					intro: "Usted es el único administrador: la cuenta de la empresa también se cerrará.",
					company: "La empresa {{companyName}} será desactivada.",
					users: "{{total}} otro(s) usuario(s) perderán el acceso.",
					connections: "{{total}} conexión(es) de WhatsApp serán desconectadas.",
					subscription: "La suscripción recurrente será cancelada.",
					history: "El historial de tickets se conserva de forma anonimizada; el correo, el nombre de la empresa y el CNPJ quedan liberados para un nuevo registro.",
				},
				passwordLabel: "Confirme su contraseña",
				acknowledge: "Entiendo que esta acción no se puede deshacer.",
				buttons: {
					cancel: "Cancelar",
					confirm: "Eliminar mi cuenta",
				},
				toasts: {
					success: "Cuenta eliminada con éxito.",
				},
				loginBanner: "Su cuenta fue eliminada con éxito.",
			},
			documentTemplates: {
				title: "Modelos de Documentos",
				searchPlaceholder: "Buscar...",
				table: {
					name: "Nombre",
					description: "Descripción",
					active: "Activo",
					actions: "Acciones",
				},
				buttons: {
					add: "Nuevo modelo",
					save: "Guardar",
					cancel: "Cancelar",
					insertVariable: "Insertar variable",
					pageConfig: "Configurar página",
					send: "Generar y enviar",
				},
				toasts: {
					saved: "¡Modelo guardado con éxito!",
					deleted: "¡Modelo eliminado con éxito!",
					sent: "¡Documento enviado con éxito!",
				},
				confirmationModal: {
					deleteTitle: "Eliminar modelo",
					deleteMessage: "¡Esta acción es irreversible! ¿Desea continuar?",
				},
				editor: {
					name: "Nombre del modelo",
					description: "Descripción",
					active: "Activo",
					fontFamily: "Fuente",
					fontSize: "Tamaño",
					paperSize: "Papel",
					margins: "Márgenes (cm)",
					marginTop: "Superior",
					marginBottom: "Inferior",
					marginLeft: "Izquierda",
					marginRight: "Derecha",
					variableGroups: {
						system: "Sistema",
						contact: "Contacto",
						cliente: "Cliente",
						clienteCustom: "Campos personalizados",
					},
				},
				sendModal: {
					title: "Enviar documento",
					selectTemplate: "Modelo de documento",
					missingFields: "Complete la información pendiente",
					resolvedFields: "Datos completados automáticamente",
					noClienteLinked: "Este contacto no tiene un cliente vinculado — los campos del cliente deben completarse manualmente.",
					caption: "Mensaje (opcional)",
					preview: "Vista previa",
					previewTitle: "Vista previa del documento",
					send: "Generar y enviar",
					cancel: "Cancelar",
				},
				toolbar: {
					bold: "Negrita",
					italic: "Cursiva",
					underline: "Subrayado",
					alignLeft: "Alinear a la izquierda",
					alignCenter: "Centrar",
					alignRight: "Alinear a la derecha",
					justify: "Justificar",
					bulletList: "Lista con viñetas",
					orderedList: "Lista numerada",
					insertTable: "Insertar tabla",
					removeTable: "Eliminar tabla",
				},
			},
			languages: {
				pt: "Português",
				en: "English",
				es: "Español",
			},
			forgetPassword: {
				title: "Restablecer contraseña",
				toasts: {
					emailSent: "¡Correo enviado con éxito!",
					passwordReset: "Contraseña restablecida con éxito.",
					emailNotFound: "Correo no encontrado",
				},
				buttons: {
					signup: "¿No tiene una cuenta? ¡Regístrese!",
					resetPassword: "Restablecer contraseña",
					sendEmail: "Enviar correo",
				},
				form: {
					verificationCode: "Código de verificación",
					newPassword: "Nueva contraseña",
					confirmPassword: "Confirma la contraseña",
				},
				validation: {
					passwordRule: "Tu contraseña debe tener al menos 8 caracteres, con una letra mayúscula, una minúscula y un número.",
				},
			},
			kanban: {
				lanes: {
					open: "Abiertos",
				},
			},
			common: {
				dateTimeAt: "{{date}} a las {{time}}",
				yes: "Sí",
				no: "No",
				ok: "OK",
				cancel: "Cancelar",
				save: "Guardar",
				saving: "Guardando...",
				close: "Cerrar",
				delete: "Eliminar",
				edit: "Editar",
				add: "Agregar",
				new: "Nuevo",
				search: "Buscar",
				filter: "Filtrar",
				clear: "Limpiar",
				back: "Volver",
				next: "Siguiente",
				previous: "Anterior",
				confirm: "Confirmar",
				loading: "Cargando...",
				loadMore: "Cargar más",
				all: "Todos",
				none: "Ninguno",
				noRecords: "No se encontraron registros",
				noResults: "No se encontraron resultados",
				actions: "Acciones",
				name: "Nombre",
				email: "Correo",
				phone: "Teléfono",
				status: "Estado",
				type: "Tipo",
				date: "Fecha",
				startDate: "Fecha inicial",
				endDate: "Fecha final",
				from: "Desde",
				to: "Hasta",
				total: "Total",
				active: "Activo",
				inactive: "Inactivo",
				enabled: "Habilitado",
				disabled: "Deshabilitado",
				required: "Obligatorio",
				optional: "Opcional",
				export: "Exportar",
				exportExcel: "Exportar a Excel",
				print: "Imprimir",
				refresh: "Actualizar",
				select: "Seleccione",
				selected: "Seleccionado",
				description: "Descripción",
				notes: "Observaciones",
				createdAt: "Creado el",
				updatedAt: "Actualizado el",
				user: "Usuario",
				company: "Empresa",
				unknown: "Desconocido",
				error: "Error",
				success: "Éxito",
				notInformed: "No informado",
				featureNotEnabled: "¡Esta empresa no tiene permiso para acceder a esta página! Le estamos redirigiendo.",
				calendar: {
					today: "Hoy",
					previous: "Anterior",
					next: "Siguiente",
					month: "Mes",
					week: "Semana",
					day: "Día",
					agenda: "Agenda",
					date: "Fecha",
					time: "Hora",
					event: "Evento",
					allDay: "Todo el día",
					noEventsInRange: "No hay eventos en este período.",
					showMore: "+ Ver más ({{count}})",
				},
				time: {
					minutesAgo: "hace {{count}} minuto",
					minutesAgo_plural: "hace {{count}} minutos",
					hoursAgo: "hace {{count}} hora",
					hoursAgo_plural: "hace {{count}} horas",
					daysAgo: "hace {{count}} día",
					daysAgo_plural: "hace {{count}} días",
				},
			},
			validation: {
				required: "Obligatorio",
				tooShort: "Demasiado corto",
				tooLong: "Demasiado largo",
				invalidEmail: "Correo inválido",
				invalidPhone: "Teléfono inválido",
				invalidUrl: "URL inválida",
				invalidDate: "Fecha inválida",
				invalidNumber: "Número inválido",
				minLength: "Mínimo de {{count}} caracteres",
				maxLength: "Máximo de {{count}} caracteres",
				min: "Valor mínimo: {{min}}",
				max: "Valor máximo: {{max}}",
				positiveNumber: "Ingrese un número positivo",
				passwordsMustMatch: "Las contraseñas no coinciden",
				invalidCnpj: "CNPJ inválido",
				invalidCpf: "CPF inválido",
			},
			labels: {
				priority: {
					low: "Baja",
					medium: "Media",
					normal: "Normal",
					high: "Alta",
					urgent: "Urgente",
				},
				severity: {
					critical: "Crítico",
					high: "Alto",
					medium: "Medio",
					low: "Bajo",
					info: "Informativo",
				},
				weekdays: {
					monday: "Lunes",
					tuesday: "Martes",
					wednesday: "Miércoles",
					thursday: "Jueves",
					friday: "Viernes",
					saturday: "Sábado",
					sunday: "Domingo",
				},
			},
      signup: {
        title: "Registrarse",
        toasts: {
          success: "¡Usuario creado exitosamente! ¡Inicie sesión!",
          fail: "Error al crear usuario. Verifique los datos ingresados.",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          password: "Contraseña",
          acceptTermsPrefix: "He leído y acepto los",
          acceptTermsLink: "Términos y Condiciones de Uso",
          acceptTermsRequired: "Debe aceptar los Términos para registrarse",
          phone: "Teléfono (con código de área)",
          planOption: "{{name}} - Agentes: {{users}} - WhatsApp: {{connections}} - Colas: {{queues}} - R$ {{value}}",
          freeTrial: "¡Primer mes gratis! El cobro del plan elegido comienza a partir del segundo mes.",
        },
        buttons: {
          submit: "Registrarse",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
        validation: {
          planRequired: "Selecciona un plan",
        },
      },
      login: {
        title: "Iniciar sesión",
        form: {
          email: "Correo electrónico",
          password: "Contraseña",
          showHidePassword: "Mostrar/ocultar contraseña",
        },
        buttons: {
          submit: "Iniciar sesión",
          register: " ¡Crea tu cuenta en solo unos clics!",
        },
        licenseBlocked: {
          title: "Acceso bloqueado: la licencia de uso de esta empresa no es válida.",
          reason: "Motivo: {{reason}}",
          contact: "Ponte en contacto con Empsis para regularizar la licencia.",
        },
        sessionExpired: "Tu sesión ha expirado. Por favor, inicia sesión nuevamente.",
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campañas",
          schedules: "Programaciones",
          enabled: "Habilitadas",
          disabled: "Deshabilitadas",
          clear: "Cancelar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Sí",
          no: "No",
          money: "R$",
          queues: "Colas",
          value: "Precio",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          integrations: "Integraciones",
          whatsappQr: "WhatsApp vía código QR",
        },
        newPlan: "Nuevo Plan",
        restricted: {
          message: "Solo el usuario administrador principal puede gestionar planes.",
        },
        toasts: {
          saveError: "No fue posible realizar la operación. Verifica si ya existe un plan con el mismo nombre o si los campos se completaron correctamente",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "¡Empresa creada exitosamente!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
          subscriptionBlocked: "¡Ups! Tu suscripción venció el {{date}}. Regulariza el pago para volver a usar el sistema.",
          subscriptionExpiresInOneDay: "Tu suscripción vence en {{days}} día",
          subscriptionExpiresInDays: "Tu suscripción vence en {{days}} días",
          subscriptionExpired: "Tu suscripción venció el {{date}}. Regulariza el pago para evitar el bloqueo.",
        },
        token: "Token",
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Atenciones de hoy: ",
          },
          createdTickets: "Atenciones creadas: {{total}}",
          ticketsAxis: "Atenciones",
          conversations: {
            chartTitle: "Gráfico de conversaciones",
            total: "Total ({{total}})",
            start: "Inicio",
            end: "Fin",
            hourRange: "De {{hour}}:00 a {{hour}}:59",
            loadError: "Error al buscar la información de las atenciones",
          },
          conversationsByUser: {
            title: "Total de conversaciones por usuario",
            chartTitle: "Gráfico de conversaciones",
            dataset: "Conversaciones",
            loadError: "Error al obtener la información de la conversación",
          },
          messagesByUser: {
            title: "Mensajes por usuario",
            chartTitle: "Mensajes por usuario (recibidos × enviados)",
            received: "Recibidos",
            sent: "Enviados",
            loadError: "Error al obtener la información de mensajes por usuario",
          },
          messagesPerDay: {
            title: "Mensajes por día",
            chartTitle: "Gráfico de mensajes por día",
            loadError: "Error al obtener la información de mensajes por día",
          },
          ticketsPerDay: {
            title: "Atenciones por día",
            chartTitle: "Gráfico de atenciones por día",
            loadError: "Error al obtener la información de atenciones por día",
          },
          ticketsPerHour: {
            title: "Horarios de atención",
            chartTitle: "Gráfico de horarios de atención",
            loadError: "Error al obtener la información de horarios de atención",
          },
          ticketsPerWeekDay: {
            title: "Atenciones por día de la semana",
            chartTitle: "Gráfico de atenciones por día de la semana",
            loadError: "Error al obtener la información de atenciones por día de la semana",
          },
          volume: {
            low: "Menor volumen",
            mid: "Volumen medio",
            high: "Mayor volumen",
          },
          weekDayShort: {
            sun: "Dom",
            mon: "Lun",
            tue: "Mar",
            wed: "Mié",
            thu: "Jue",
            fri: "Vie",
            sat: "Sáb",
          },
        },
        conversions: {
          title: "Conversiones",
          chartTitle: "Conversiones (Sí × No)",
          yes: "Sí",
          no: "No",
          totalTickets: "Total de Tickets",
          totalConversions: "Total de Conversiones",
          conversionRate: "Porcentaje de Conversión",
          notApplicable: "No aplicable",
          dialog: {
            title: "¿Convertido?",
            message: "¿Esta atención resultó en una conversión?",
            yes: "Sí",
            no: "No",
            notApplicable: "No aplicable",
            cancel: "Cancelar",
          },
          loadError: "Error al obtener la información de conversiones",
        },
        noInteraction: {
          cardTitle: "Finalizadas sin interacción",
          chartTitle: "Finalizadas sin interacción por agente",
          subtitle: "Atenciones finalizadas por el agente sin ningún mensaje enviado al contacto.",
          empty: "Ninguna atención finalizada sin interacción en el período.",
          total: "Total en el período",
          user: "Agente",
          quantity: "Cantidad",
          detailsTitle: "Atenciones finalizadas sin interacción",
          view: "Ver",
          close: "Cerrar",
          table: {
            ticket: "Atención",
            contact: "Contacto",
            queue: "Cola",
            connection: "Conexión",
            user: "Agente",
            closedAt: "Finalizada el",
            open: "Abrir",
          },
        },
        ticketsByContactTag: {
          title: "Atenciones por etiqueta del contacto",
          chartTitle: "Atenciones abiertas por etiqueta del contacto",
          subtitle: "{{total}} atenciones abiertas en el período · {{untagged}} sin etiqueta",
          multiTagNote: "Una atención cuenta en todas las etiquetas del contacto, por eso la suma puede superar el total.",
          topNote: "El gráfico muestra las {{count}} etiquetas con más atenciones; la tabla lista todas.",
          loadError: "Error al obtener las atenciones por etiqueta del contacto",
          tag: "Etiqueta",
          quantity: "Cantidad",
          percent: "% del total",
          untagged: "Sin etiqueta",
          view: "Ver",
          close: "Cerrar",
          detailsTitle: "Atenciones de la etiqueta",
          detailsTitleUntagged: "Atenciones de contactos sin etiqueta",
          detailsEmpty: "No se encontraron atenciones.",
          showingLimit: "Mostrando las {{shown}} más recientes de {{total}}.",
          status: {
            open: "En atención",
            pending: "En espera",
            closed: "Finalizada",
            group: "Grupo",
          },
          table: {
            ticket: "Atención",
            contact: "Contacto",
            queue: "Cola",
            connection: "Conexión",
            user: "Agente",
            status: "Estado",
            openedAt: "Abierta el",
            open: "Abrir",
          },
        },
        filters: {
          title: "Filtros",
          invalid: "Configura el filtro",
        },
        cards: {
          inConversation: "En conversación",
          waiting: "Esperando",
          finished: "Finalizadas",
          newContacts: "Nuevos contactos",
          medianConversation: "Mediana de conversación",
          medianWait: "Mediana de espera",
        },
        attendantsTable: {
          avgSupportTime: "T.P. de atención",
          currentStatus: "Estado (actual)",
        },
      },
      connections: {
				subscription: {
					subscribed: "Suscrito",
					pending: "Pendiente",
				},
				typeTooltips: {
					cloudapi: "API Oficial de Meta",
					email: "Canal de correo (POP3/IMAP + SMTP)",
					sms: "Canal SMS",
					baileys: "Baileys (No Oficial)",
					publicLink: "Enlace público / alias personalizado",
				},
				publicLink: {
					title: "Enlace público",
					titleWithName: "Enlace público — {{name}}",
					defaultLink: "Enlace público predeterminado de esta conexión:",
					nicknameHelp: "Alias personalizado (enlace corto). Déjelo en blanco para eliminarlo.",
					nicknamePlaceholder: "ej.: sniperCMS",
					nicknameRules: "De 3 a 50 caracteres: letras, números, '-' o '_'.",
					activeLink: "Enlace personalizado activo:",
					copy: "Copiar",
					saveNickname: "Guardar alias",
				},
        title: "Conexiones",
        toasts: {
					instagramConnected: "¡Instagram conectado con éxito!",
					instagramConnectedAs: "¡Instagram (@{{username}}) conectado con éxito!",
					instagramFailed: "Error al conectar Instagram: {{reason}}",
					instagramSubscribed: "¡Webhooks de Instagram suscritos con éxito!",
					instagramSubscribeFailed: "Meta rechazó la suscripción de los webhooks. Intenta reconectar Instagram.",
					unknownError: "error desconocido",
					subscribed: "¡Conexión suscrita con éxito!",
					linkCopied: "¡Enlace copiado!",
					publicLinkCopied: "¡Enlace público copiado!",
					customLinkCopied: "¡Enlace personalizado copiado!",
					nicknameSaved: "¡Alias guardado!",
					nicknameRemoved: "Alias eliminado.",
					instagramAuthUrlMissing: "No se recibió la URL de autorización de Instagram.",
          deleted: "¡Conexión con WhatsApp eliminada exitosamente!",
          deletedByType: {
            cloudapi: "¡Conexión con WhatsApp (API Oficial) eliminada exitosamente!",
            email: "¡Conexión de correo electrónico eliminada exitosamente!",
            sms: "¡Conexión de SMS eliminada exitosamente!",
            instagram: "¡Conexión con Instagram eliminada exitosamente!",
          },
        },
        alerts: {
          offline:
            "La conexión {{name}} está fuera del aire. Sus mensajes pueden no ser enviados ni recibidos — avise al administrador del sistema.",
          offlineManager:
            "La conexión {{name}} está fuera del aire. Abra el menú Conexiones para reconectarla.",
          offlineMultiple:
            "{{total}} conexiones están fuera del aire ({{names}}). Sus mensajes pueden no ser enviados ni recibidos — avise al administrador del sistema.",
          offlineMultipleManager:
            "{{total}} conexiones están fuera del aire ({{names}}). Abra el menú Conexiones para reconectarlas.",
          recovered: "La conexión {{name}} volvió a funcionar.",
          ack: "OK",
          dismiss: "Cerrar aviso",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede deshacer.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "¿Estás seguro? Deberás volver a leer el código QR.",
        },
        buttons: {
					emailChannel: "Canal de correo",
					smsChannel: "Canal SMS",
					reconnectInstagram: "Reconectar Instagram",
					instagramSubscribe: "Suscribir webhooks",
					instagramConnected: "Conectado",
					subscribe: "Suscribir",
					subscribing: "Suscribiendo...",
					subscribed: "Suscrito",
          add: "Agregar Cuenta",
          disconnect: "desconectar",
          tryAgain: "Intentar de nuevo",
          qrcode: "CÓDIGO QR",
          newQr: "Nuevo CÓDIGO QR",
          connecting: "Conectando",
        },
        toolTips: {
          DISCONNECTED: {
            title: "Error al iniciar sesión en WhatsApp",
            content:
              "Asegúrate de que tu teléfono esté conectado a internet e inténtalo nuevamente, o solicita un nuevo código QR",
          },
          qrcode: {
            title: "Esperando lectura del código QR",
            content:
              "Haz clic en el botón 'CÓDIGO QR' y lee el código QR con tu teléfono para iniciar sesión",
          },
          CONNECTED: {
            title: "¡Conexión establecida!",
          },
          instagramReconnect: {
            title: "Token de Instagram expirado o revocado",
            content: "Haz clic en 'Reconectar Instagram' e inicia sesión en la cuenta para volver a enviar y recibir mensajes",
          },
          instagramSubscribe: {
            title: "Webhooks de Instagram no suscritos",
            content: "Es posible que los mensajes no lleguen. Haz clic en 'Suscribir webhooks' para corregirlo",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono",
            content:
              "Asegúrate de que tu teléfono esté conectado a internet y WhatsApp esté abierto, o haz clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
					number: "Número",
					type: "Tipo",
					subscription: "Suscripción",
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última actualización",
          default: "Predeterminado",
          actions: "Acciones",
          session: "Sesión",
        },
      },
whatsappModal: {
				connectionType: {
					title: "Tipo de Conexión",
					fixed: "Tipo de Conexión: {{type}}",
					baileys: "API No Oficial (Baileys)",
					cloudapi: "API Oficial (Meta)",
					email: "Canal de correo (POP3/IMAP + SMTP)",
					desc: {
						baileys: "Conexión por código QR usando la biblioteca Baileys. No requiere cuenta Business.",
						cloudapi: "API oficial de Meta/WhatsApp Business. Requiere credenciales de Meta Business Platform.",
						email: "Canal de envío y recepción de correos por POP3 o IMAP (recepción) y SMTP (envío) para abrir y responder tickets.",
						instagram: "Direct y comentarios de Instagram por la API oficial. Conecte su cuenta profesional con el inicio de sesión simplificado de abajo.",
						sms: "Envío de SMS mediante gateway (Witi.me, SMS Barato o SMSDev). Canal solo de envío (campañas): no recibe respuestas.",
					},
				},
				instagram: {
					title: "Conexión de Instagram",
					connectedAccount: "Cuenta conectada:",
					description: "Conecte su cuenta profesional de Instagram para recibir y responder Direct y comentarios. Haga clic en el botón de abajo, inicie sesión y autorice: la conexión se crea automáticamente.",
					notConfigured: "La aplicación de Meta no está configurada en este servidor. Contacte con soporte.",
					connect: "Conectar Instagram",
					reconnect: "Reconectar Instagram",
					redirecting: "Redirigiendo...",
				},
				kanban: {
					title: "Creación Automática de Tarjetas en el Kanban",
					description: "Configure si esta conexión debe crear automáticamente tarjetas en el Kanban cuando se inicien nuevas atenciones.",
					enable: "Habilitar creación automática de tarjetas",
					board: "Tablero de destino",
					boardPlaceholder: "Seleccione un tablero",
					boardHelp: "Tablero donde se crearán las tarjetas",
					column: "Columna de destino",
					columnPlaceholder: "Seleccione una columna",
					columnHelp: "Columna donde se crearán las tarjetas",
					user: "Usuario responsable (opcional)",
					userHelp: "Usuario que se vinculará a las tarjetas creadas automáticamente",
					prerequisiteLabel: "Requisito previo:",
					prerequisiteText: "El tablero seleccionado debe tener configurado el campo personalizado \"ticketId\" para que la creación automática funcione.",
					loadColumnsError: "Error al cargar las columnas del tablero",
				},
				cloudApi: {
					title: "Configuración de la API Oficial (Meta Cloud API)",
					appNotConfigured: "La aplicación de Meta no está configurada en este servidor, por lo que el inicio de sesión simplificado no está disponible. Contacte con soporte o complete los datos manualmente abajo.",
					quickTitle: "Conexión Rápida",
					quickDescription: "Registre un número nuevo en la API oficial: inicie sesión en Facebook y autorice el acceso. El número deja de funcionar en la app del celular; para mantener la app, use la opción de arriba.",
					connect: "Conectar WhatsApp",
					connecting: "Conectando...",
					coexistence: {
						title: "WhatsApp Business del celular",
						description: "Use en la API oficial el número que ya está en la app WhatsApp Business del celular. La app sigue funcionando y los mensajes aparecen en los dos lugares.",
						connect: "Conectar WhatsApp Business del celular",
						limits: {
							groups: "Los grupos no pasan por la API: solo conversaciones individuales.",
							calls: "Sin llamadas por la API en este número.",
							inactivity: "Abra la app en el celular al menos cada 14 días, o Meta desconecta el número.",
							pricing: "Lo que se envía desde la app sigue siendo gratis; por la API lo cobra Meta.",
							history: "La agenda y hasta 180 días de conversaciones del celular se importan una vez; las conversaciones antiguas entran como tickets cerrados.",
							appVersion: "Requiere la app WhatsApp Business 2.24.17 o más nueva (el WhatsApp común no sirve).",
						},
						status: {
							title: "Número también en la app WhatsApp Business del celular",
							inactivityReminder: "Abra la app en el celular al menos cada 14 días, o Meta desconecta el número.",
							contactsLabel: "Agenda del celular:",
							historyLabel: "Historial del celular:",
							disconnectedLabel: "Desconectado:",
							contactsReceived: "{{count}} contacto(s) importado(s).",
							historyImporting: "importando, {{percent}}% ({{count}} mensajes hasta ahora).",
							historyDone: "importado ({{count}} mensajes, en tickets cerrados).",
							historyDeclined: "el dueño rechazó compartir el historial en la app del celular.",
							waiting: "solicitado a Meta, esperando el envío.",
							notRequested: "se solicitará a Meta al guardar la conexión.",
							failed: "Meta rechazó la solicitud ({{error}}). Guarde la conexión para intentar de nuevo.",
							expired: "el plazo de 24h de Meta para importar ya pasó.",
						},
					},
					selectNumber: "Seleccione el número que desea conectar:",
					wabaConflictTitle: "Este número está en {{count}} cuentas de WhatsApp Business en Meta",
					wabaConflictHelp: "Meta informa una cuenta en el inicio de sesión, pero el número puede enviar (y cobrar) por otra. Elija abajo la cuenta por la que envía: normalmente la que ya tiene conexión en el CRM o plantillas aprobadas. En la cuenta equivocada, las plantillas creadas aquí no se encuentran al enviar (error 132001 de Meta).",
					wabaSuggested: "cuenta sugerida",
					wabaHasConnection: "ya usada en otra conexión",
					wabaApprovedTemplates: "{{count}} plantilla(s) aprobada(s)",
					orManual: "o configure manualmente",
					hideManual: "Ocultar campos manuales",
					showManual: "Mostrar campos manuales",
					phoneNumberIdHelp: "ID del número en Meta Business (ej.: 123456789012345)",
					wabaIdHelp: "ID de la cuenta de WhatsApp Business",
					validate: "Validar Credenciales",
					valid: "Válido",
					invalid: "Inválido",
					result: {
						number: "Número:",
						verifiedName: "Nombre verificado:",
						quality: "Calidad:",
						account: "Cuenta:",
					},
					credentialsSet: "Credenciales configuradas",
					appCredentialsLabel: "Credenciales de la aplicación de Meta:",
					appCredentialsText: "se configuran una sola vez en el servidor. Mientras eso no se haga, puede completarlas en la pestaña \"Cloud API\" de \"Configuración\".",
					toasts: {
						valid: "¡Conexión válida! Número: {{phone}} - {{name}}",
						invalid: "Credenciales inválidas: {{error}}",
						validateError: "Error al validar las credenciales",
						communicationError: "Error de comunicación",
						signupUnavailable: "Inicio de sesión simplificado no disponible: la aplicación de Meta no está configurada en el servidor. Contacte con soporte.",
						processing: "Procesando la autorización... Espere.",
						signupError: "Error en el Embedded Signup",
						connectedReview: "¡WhatsApp conectado con éxito! Revise los datos y haga clic en Guardar.",
						connectedNumber: "¡WhatsApp conectado! Número: {{phone}} ({{name}}). Haga clic en Guardar.",
						authorizedSelect: "¡Autorización completada! Seleccione el número que desea conectar.",
						authorizedNoNumber: "Autorización completada, pero no se encontró ningún número.",
						wabaConflict: "Este número está en {{count}} cuentas de Meta. Revise la cuenta sugerida antes de guardar.",
						timeout: "Meta tardó demasiado en responder. Es posible que la cuenta se haya creado: cierre y vuelva a abrir esta pantalla antes de intentarlo de nuevo.",
						processError: "Error al procesar el Embedded Signup",
						cancelled: "Embedded Signup cancelado",
						numberSelected: "Número seleccionado: {{phone}} ({{name}})",
					},
				},
				sms: {
					title: "Configuración del Gateway de SMS ({{provider}})",
					provider: "Proveedor de SMS",
					providers: {
						witime: "Witi.me — ideal para grandes volúmenes",
						smsbarato: "SMS Barato — ideal para volúmenes menores",
						smsdev: "SMSDev — ideal para volúmenes menores",
					},
					apiKey: "Clave de la API",
					apiKeyCurrent: "Clave actual: {{hint}}. Déjela en blanco para mantener la clave actual.",
					apiKeyHelpWitime: "Disponible en el panel de Witi.me en SMS > Configuración de SMS.",
					apiKeyHelp: "Disponible en el panel de {{provider}}.",
					apiKeyMissing: "Ingrese la clave de la API del gateway de SMS.",
					showHideApiKey: "Mostrar/ocultar clave de la API",
					route: "Ruta",
					routeHelp: "Opcional. Vacío usa la ruta predeterminada de la cuenta.",
					sendType: "Tipo de envío",
					sendTypes: {
						common: "Común (marketing / P2P)",
						token: "Token (OTP)",
						debug: "Debug (simulación, no se cobra)",
					},
					reference: "Referencia",
					referenceHelp: "Identificación de los envíos en el panel de {{provider}}.",
					webhookUrl: "URL de Webhook (DLR)",
					showHideWebhook: "Mostrar/ocultar URL de webhook",
					copyWebhook: "Copiar URL de webhook",
					webhookCopied: "URL de webhook copiada.",
					webhookCopyError: "No se pudo copiar la URL.",
					webhookHelp: "Registre esta URL en el panel de Witi.me para recibir la confirmación de entrega de las campañas. Contiene un token secreto: use el botón de copiar.",
					webhookAfterSave: "La URL de webhook para la confirmación de entrega se mostrará aquí después de guardar la conexión.",
					baseUrl: "URL del sistema",
					baseUrlHelp: "Opcional. Cada cuenta usa una dirección propia (sistemaNN): confirme la suya con el soporte de SMS Barato.",
					smsbaratoNote: "SMS Barato no acepta acentos ni saltos de línea (se convierten automáticamente al enviar) y limita cada mensaje a 160 caracteres. La confirmación de entrega se consulta automáticamente: no hay webhook que registrar.",
					smsdevNote: "SMSDev no entrega caracteres acentuados, por lo que los acentos se convierten automáticamente al enviar (ação → acao); los saltos de línea se mantienen. Los mensajes largos consumen 1 crédito por cada 160 caracteres. La confirmación de entrega se consulta automáticamente: no hay webhook que registrar.",
				},
				email: {
					title: "Configuración del Canal de Correo",
					user: "Usuario de correo",
					password: "Contraseña de correo",
					passwordKeep: "Déjela en blanco para mantener la contraseña actual.",
					showHidePassword: "Mostrar/ocultar contraseña del correo",
					fromName: "Nombre del remitente",
					inboundProtocol: "Protocolo de recepción",
					pop3Suggested: "POP3 (sugerido)",
					host: "Servidor {{protocol}}",
					port: "Puerto {{protocol}}",
					deleteAfterFetch: "Borrar del servidor después de descargar",
					deleteAfterFetchHelp: "Desactivado: los mensajes permanecen en el servidor y siguen visibles en su cliente de correo; el CRM controla lo que ya se importó. Activado: cada correo importado se borra del buzón.",
					mailbox: "Buzón",
					test: "Probar conexión {{protocol}}/SMTP",
					result: {
						ok: "Conexión validada",
						partial: "Validación parcial",
						failed: "Error en la validación",
						statusFailed: "Falló",
						noDetails: "Sin detalles",
					},
					toasts: {
						missingFields: "Complete el usuario/contraseña de correo y los servidores {{protocol}}/SMTP.",
						missingFieldsTest: "Complete el usuario/contraseña de correo y los servidores {{protocol}}/SMTP antes de probar.",
						missingServer: "Complete el usuario, la contraseña y el servidor {{protocol}}",
						validated: "Conexión {{protocol}}/SMTP validada con éxito.",
						partialDetail: "Validación parcial: {{protocol}}: {{inbound}} | SMTP: {{smtp}}",
						failedShort: "falló",
						partial: "Validación parcial de la conexión de correo.",
						failed: "Error al validar la conexión de correo.",
						testFailed: "Error al probar {{protocol}}",
					},
				},
  title: {
    add: "Agregar Conexión",
    edit: "Editar Conexión",
  },
  tabs: {
    general: "General",
    messages: "Mensajes",
    assessments: "Evaluaciones",
    integrations: "Integraciones",
    schedules: "Horario de expediente",
  },
  form: {
					timeToTransfer: "Transferir después de x (minutos)",
					transferQueue: "Cola de transferencia",
					showHideToken: "Mostrar/ocultar token",
					tokenCurrent: "Token actual: {{hint}}. Déjelo en blanco para mantener el token actual.",
					removeToken: "Eliminar token",
					undoRemoveToken: "Deshacer eliminación",
					tokenWillBeRemoved: "El token se eliminará al guardar; las integraciones que usan este token dejarán de funcionar.",
    name: "Nombre",
    default: "Predeterminado",
    onlineWhileViewing: "Mostrar \"escribiendo\" y \"en línea\" del contacto",
    onlineWhileViewingHelp: "El número aparece en línea mientras haya un agente con FaleCRM abierto. Durante ese tiempo el celular no notifica los mensajes.",
    sendIdQueue: "Fila",
    timeSendQueue: "Redireccionar a cola en X minutos",
    queueRedirection: "Redirección de cola",
    outOfHoursMessage: "Mensaje de fuera de expediente",
    queueRedirectionDesc: "Seleccione una fila para redirigir los contactos que no tienen cola",
    prompt: "Prompt",
    expiresTicket: "Cerrar chats abiertos después de X minutos",
    expiresInactiveMessage: "Mensaje de cierre por inactividad",
    greetingMessage: "Mensaje de saludo",
    complationMessage: "Mensaje de conclusión",
  },
  buttons: {
    okAdd: "Agregar",
    okEdit: "Guardar",
    cancel: "Cancelar",
  },
  success: "WhatsApp guardado con éxito.",
  successByType: {
    cloudapi: "Conexión con WhatsApp (API Oficial) guardada con éxito.",
    email: "Conexión de correo electrónico guardada con éxito.",
    sms: "Conexión de SMS guardada con éxito.",
    instagram: "Conexión con Instagram guardada con éxito.",
  },
},
qrCode: {
				title: "Use su WhatsApp:",
				methodPhone: "Número de teléfono",
				generatingQr: "Generando código QR...",
				qrSteps: {
					one: "1 - Abra WhatsApp en su teléfono",
					two: "2 - Toque Más opciones en Android o Configuración en iPhone",
					three: "3 - Toque Dispositivos vinculados y luego Vincular un dispositivo",
					four: "4 - Apunte su teléfono a esta pantalla para escanear el código QR",
					hint: "Si el código QR caduca, haga clic en \"Generar Nuevo Código QR\".",
				},
				phoneSteps: {
					one: "1 - Ingrese el número (código de país + código de área + número) y haga clic en \"Generar código\".",
					two: "2 - En el teléfono, abra WhatsApp → Dispositivos vinculados → Vincular un dispositivo",
					three: "3 - Toque \"Vincular con el número de teléfono\"",
					four: "4 - Escriba el código de 8 dígitos que aparece al lado",
					hint: "Use solo dígitos en el número, con código de país. Ej.: 5511999998888.",
				},
				error: {
					title: "Error al conectar",
					message: "No se pudo establecer la conexión con WhatsApp.",
					retry: "Intentar de Nuevo",
				},
				cooldown: {
					title: "Demasiados intentos de conexión",
					message: "Para proteger su número contra el bloqueo de WhatsApp, la generación de códigos QR se pausó. Se reanuda sola en aproximadamente",
					at: "(a las {{time}}).",
					hint: "Si lo prefiere, intente ahora, pero evite generar muchos códigos QR seguidos sin escanearlos.",
					retry: "Intentar ahora",
				},
				expired: {
					title: "Código QR caducado.",
					message: "Haga clic abajo para generar un nuevo código QR.",
					retry: "Generar Nuevo Código QR",
				},
				pairing: {
					enterCode: "Escriba este código en su WhatsApp:",
					number: "Número:",
					newCode: "Generar nuevo código",
					phoneLabel: "Número con código de país",
					generate: "Generar código",
					generating: "Generando...",
					invalidNumber: "Ingrese el número con código de país + código de área + número (ej.: 5511999998888).",
				},
  message: "Lea el código QR para iniciar sesión",
},
contacts: {
  title: "Contactos",
  toasts: {
    deleted: "Contacto eliminado con éxito!",
    deletedAll: "Todos los contactos eliminados con éxito!",
    exportEmpty: "Ningún contacto para exportar con la búsqueda actual.",
    exportLimited: "Exportación limitada a 5.000 contactos. Refina la búsqueda para exportar el resto.",
  },
  exportMenu: {
    xlsx: "Exportar XLSX",
    csv: "Exportar CSV",
  },
  searchPlaceholder: "Buscar...",
  confirmationModal: {
    deleteTitle: "Eliminar ",
    deleteAllTitle: "Eliminar Todos",
    importTitle: "Importar contactos",
    deleteMessage: "¿Seguro que desea eliminar este contacto? Se perderán todos los tickets relacionados.",
    deleteAllMessage: "¿Seguro que desea eliminar todos los contactos? Se perderán todos los tickets relacionados.",
    importMessage: "¿Desea importar todos los contactos del teléfono?",
  },
  buttons: {
    import: "Importar Contactos",
    add: "Agregar Contacto",
    export: "Exportar Contactos",
    delete: "Eliminar Todos Contactos",
  },
  importModal: {
    title: "Importar contactos",
    optionConnection: "De la conexión de WhatsApp",
    optionFile: "Desde archivo (CSV/XLS/XLSX)",
    message: "Elige de qué conexión de WhatsApp conectada quieres importar los contactos. Los contactos se crearán con los nombres guardados en el teléfono.",
    selectLabel: "Conexión de WhatsApp",
    importing: "Importando contactos... esto puede tardar un poco si hay muchos contactos.",
    noConnection: "Ninguna conexión de WhatsApp está conectada en este momento. Conecta un número en la página de conexiones primero.",
    success: "Importación finalizada: {{total}} contactos leídos del teléfono — {{imported}} nuevos, {{updated}} actualizados.",
    partialWarning: "No fue posible descargar la agenda completa del teléfono ahora. Solo se procesaron los {{total}} contactos recibidos desde el último reinicio del servidor ({{imported}} nuevos, {{updated}} actualizados) — algunos contactos pueden haber quedado fuera. Inténtalo de nuevo en unos minutos o importa desde una hoja de cálculo.",
    fileMessage: "Sube una planilla CSV, XLS o XLSX con las columnas de la plantilla de abajo. Completa \"numero\" o \"email\" — las demás columnas son opcionales y pueden quedar en blanco.",
    downloadTemplateXlsx: "Descargar plantilla XLSX",
    downloadTemplateCsv: "Descargar plantilla CSV",
    selectFile: "Seleccionar archivo",
    noFileSelected: "Ningún archivo seleccionado",
    uploading: "Importando planilla... esto puede tardar un poco si hay muchos contactos.",
    fileSuccess: "Importación finalizada: {{imported}} nuevos, {{updated}} actualizados, {{skipped}} ignorados, {{errors}} errores.",
    notValidatedWarning: "Los números fueron importados sin verificación en WhatsApp (ninguna conexión activa disponible).",
    invalidNumbersInfo: "{{count}} números no fueron encontrados en WhatsApp, pero fueron importados de todas formas.",
    closeAfterImport: "Cerrar",
  },
  table: {
    name: "Nombre",
    whatsapp: "WhatsApp",
    email: "Correo electrónico",
    actions: "Acciones",
  },
  linkedCliente: "Vinculado al cliente: {{name}}",
  connectionTooltip: {
    selected: "Conexión: {{name}}",
    selectedFallback: "Seleccionada",
    select: "Seleccionar conexión para nuevos tickets",
  },
  linkModal: {
    contactLabel: "Contacto: {{name}}",
    linkType: "Tipo de vínculo",
    existingCliente: "Cliente existente",
    newCliente: "Nuevo cliente",
    searchHelper: "Escribe nombre, correo, CPF o CNPJ",
    newClienteInfo: "Al continuar, se abrirá la pantalla de nuevo cliente con el nombre, celular y correo del contacto ya completados.",
    selectCliente: "Selecciona un cliente para vincular",
    invalidContact: "Contacto inválido para vincular",
  },
},
queueIntegrationModal: {
  title: {
    add: "Agregar proyecto",
    edit: "Editar proyecto",
  },
  form: {
    id: "ID",
    type: "Tipo",
    name: "Nombre",
    projectName: "Nombre del Proyecto",
    language: "Lenguaje",
    jsonContent: "JsonContent",
    urlN8N: "URL",
    typebotSlug: "Typebot - Slug",
    typebotExpires: "Tiempo en minutos para expirar una conversación",
    typebotKeywordFinish: "Palabra para finalizar el ticket",
    typebotKeywordRestart: "Palabra para reiniciar el flujo",
    typebotRestartMessage: "Mensaje al reiniciar la conversación",
    typebotUnknownMessage: "Mensaje de opción inválida",
    typebotDelayMessage: "Intervalo (ms) entre mensajes",
  },
  buttons: {
    okAdd: "Agregar",
    okEdit: "Guardar",
    cancel: "Cancelar",
    test: "Probar Bot",
  },
  messages: {
    testSuccess: "Integración probada con éxito!",
    addSuccess: "Integración agregada con éxito.",
    editSuccess: "Integración editada con éxito.",
  },
  languages: {
    ptBR: "Portugués",
    en: "Inglés",
    es: "Español",
  },
},
sideMenu: {
  name: "Menú Lateral Inicial",
  note: "Si está habilitado, el menú lateral se iniciará cerrado",
  options: {
    enabled: "Abierto",
    disabled: "Cerrado",
  },
},
promptModal: {
  form: {
					integrateHumanMessages: "Integrar mensajes humanos",
					integrateHumanMessagesTooltip: "Cuando está habilitado, el sistema envía a IAHub los mensajes intercambiados entre el cliente y el agente humano para mantener el contexto antes de que la IA tome el control.",
					signMessage: "Firmar respuestas con el nombre del agente",
					signMessageTooltip: "Cuando está habilitado, las respuestas de la IA llegan al cliente firmadas con el nombre del agente en la primera línea, igual que los mensajes firmados por los agentes. Desactivado, la respuesta se envía sin firma.",
    name: "Nombre",
    prompt: "Prompt",
    voice: "Voz",
    max_tokens: "Máximo de Tokens en la respuesta",
    temperature: "Temperatura",
    apikey: "API Key",
    max_messages: "Máximo de mensajes en el Historial",
    voiceKey: "Clave de la API de Voz",
    voiceRegion: "Región de Voz",
    aiHubAgentId: "ID del Agente AI Hub",
    aiHubBaseUrl: "URL Base de AI Hub",
    aiHubWebhookUrl: "URL Webhook de AI Hub",
    aiHubAgentIdHelper: "ID del agente en AI Hub (obligatorio)",
    aiHubBaseUrlLabel: "URL base de AI Hub",
    aiHubBaseUrlHelper: "URL base del hub de IA. Si está vacía, se usa AI_HUB_BASE_URL del servidor",
  },
  success: "Prompt guardado con éxito!",
  title: {
    add: "Agregar Prompt",
    edit: "Editar Prompt",
  },
  buttons: {
    okAdd: "Agregar",
    okEdit: "Guardar",
    cancel: "Cancelar",
  },
  validation: {
    nameTooShort: "¡Nombre muy corto! Mínimo de 5 caracteres.",
    nameTooLong: "¡Nombre muy largo! Máximo de 100 caracteres.",
    nameRequired: "El nombre es obligatorio",
    agentIdRequired: "El AI Hub Agent ID es obligatorio",
    invalidBaseUrl: "Debe ser una URL válida que comience con http:// o https://",
  },
  test: {
    title: "Probar agente",
    subtitle: "Usa la configuración guardada del agente",
    emptyTitle: "¡Prueba tu agente aquí!",
    emptyHint: "Envía un mensaje para iniciar la conversación",
    openAttachment: "Abrir adjunto",
    attachTooltip: "Adjuntar imagen o audio (el texto escrito se envía como leyenda)",
    inputPlaceholder: "Escribe tu mensaje...",
    processingError: "Lo sentimos, ocurrió un error al procesar tu solicitud. Por favor, inténtalo de nuevo.",
  },
  logs: {
    title: "Logs de prueba — Hub de IA",
    subtitle: "Solicitudes enviadas y callbacks recibidos del chat de prueba de este agente, en tiempo real",
    empty: "Aún no hay logs registrados.",
    emptyHint: "Envía un mensaje por el chat de prueba de un agente para generar logs.",
    sent: "ENVIADO",
    received: "RECIBIDO",
    error: "Error",
    response: "Respuesta",
    clear: "Limpiar logs",
    reload: "Recargar",
  },
},
prompts: {
				humanCooldown: {
					title: "Pausa de la IA tras la respuesta del agente",
					helper: "Vale para todos los agentes. En cuanto un agente responde — por FaleCRM o directamente desde el celular — la IA permanece en silencio en ese ticket durante este tiempo. Use 0 para desactivar la pausa.",
					label: "Minutos",
					save: "Guardar",
					saved: "¡Tiempo de pausa guardado!",
					invalid: "Ingrese un número de minutos igual o mayor que cero.",
				},
				integrations: {
					enabled: "Sí",
					disabled: "No",
				},
  title: "Prompts",
  table: {
					agentId: "Agent ID",
					integrateHumanMessages: "Integra mensajes humanos",
    name: "Nombre",
    queue: "Sector/Cola",
    max_tokens: "Máximo Tokens Respuesta",
    aiHub: "AI Hub",
    aiHubTooltip: {
      enabled: "AI Hub activo - Haz clic para desactivar",
      disabled: "AI Hub desactivado - Haz clic para activar (configura Agent ID primero)",
    },
    actions: "Acciones",
  },
  toasts: {
    aiHubEnabled: "¡AI Hub activado con éxito!",
    aiHubDisabled: "¡AI Hub desactivado con éxito!",
  },
  confirmationModal: {
    deleteTitle: "Eliminar",
    deleteMessage: "¿Está seguro? ¡Esta acción no se puede deshacer!",
  },
  buttons: {
    add: "Agregar Prompt",
  },
},
contactModal: {
  title: {
					editGroup: "Editar grupo",
    add: "Agregar contacto",
    edit: "Editar contacto",
  },
  form: {
    mainInfo: "Datos del contacto",
    extraInfo: "Información adicional",
    name: "Nombre",
    number: "Número de Whatsapp",
    email: "Email",
    extraName: "Nombre del campo",
    extraValue: "Valor",
    whatsapp: "Conexión Origen: ",
    tags: "Etiquetas del contacto",
    tagsPlaceholder: "Etiquetas",
    numberHelper: "Brasileño: DDD + número. Extranjero: usa + y el código del país (ej.: +1 415 555 2671)",
    emailPlaceholder: "Correo electrónico",
  },
  buttons: {
    addExtraInfo: "Agregar información",
    okAdd: "Agregar",
    okEdit: "Guardar",
    cancel: "Cancelar",
  },
  success: "Contacto guardado con éxito.",
  warnings: {
    whatsappValidationSkipped:
      "Contacto guardado, pero el número no pudo ser verificado en WhatsApp: no hay ninguna conexión de WhatsApp conectada. Las campañas de SMS no requieren esta validación.",
  },
},
queueModal: {
  title: {
    add: "Agregar cola",
    edit: "Editar cola",
  },
  form: {
    name: "Nombre",
    color: "Color",
    greetingMessage: "Mensaje de saludo",
    complationMessage: "Mensaje de conclusión",
    outOfHoursMessage: "Mensaje de fuera de horario",
    ratingMessage: "Mensaje de evaluación",
    token: "Token",
    orderQueue: "Orden de la cola (Bot)",
    integrationId: "Integración",
  },
  buttons: {
    okAdd: "Agregar",
    okEdit: "Guardar",
    cancel: "Cancelar",
  },
  tabs: {
    data: "Datos de la Cola",
    schedules: "Horarios de Atención",
  },
  toasts: {
    saved: "Cola guardada con éxito",
    schedulesPending: "Haga clic en guardar para registrar los cambios",
  },
},
userModal: {
  deleteAccount: {
    title: "Eliminar mi cuenta",
    hint:
      "Al eliminar tu cuenta, tu acceso al sistema será cerrado. Esta acción no se puede deshacer.",
    button: "Eliminar mi cuenta",
  },
  title: {
    add: "Agregar usuario",
    edit: "Editar usuario",
  },
  form: {
    name: "Nombre",
    email: "Email",
    password: "Contraseña",
    profile: "Perfil",
    whatsapp: "Conexión Predeterminada",
    whatsapps: "Conexiones que el usuario controla",
    salesGoal: "Meta de Ventas",

    allTicket: "Ticket Sin Cola [Invisible]",
    allTicketEnabled: "Habilitado",
    allTicketDesabled: "Deshabilitado",
  },
  buttons: {
    okAdd: "Agregar",
    okEdit: "Guardar",
    cancel: "Cancelar",
  },
  success: "Usuario guardado con éxito.",
},
scheduleModal: {
  title: {
    add: "Nuevo Agendamiento",
    edit: "Editar Agendamiento",
    PENDENTE: "Mensaje Pendiente",
    AGENDADA: "Mensaje Agendado",
    ENVIADA: "Mensaje Enviado",
    ERRO: "Error de Envío",
  },
  form: {
    body: "Mensaje",
    contact: "Contacto",
    sendAt: "Fecha de Agendamiento",
    sentAt: "Fecha de Envío",
    signMessage: "Firmar mensaje",
    whatsapp: "Conexión para el envío *",
    whatsappPlaceholder: "Seleccione una conexión",
    contactSearchPlaceholder: "Escriba para buscar un contacto (nombre o número)",
    contactMinChars: "Escriba al menos 2 caracteres para buscar...",
    contactNotFound: "Ningún contacto encontrado",
    contactLoading: "Buscando contactos...",
  },
  validation: {
    required: "Obligatorio",
    bodyMin: "Mensaje demasiado corto",
    sendAtPast:
      "No se permite agendar un mensaje en el pasado (tolerancia de 2 minutos).",
    whatsappRequired: "Seleccione una conexión",
  },
  confirmationModal: {
    deleteTitle: "Eliminar adjunto",
    deleteMessage: "¿Seguro que desea eliminar el adjunto de este agendamiento?",
  },
  toasts: {
    deleted: "Adjunto eliminado con éxito.",
  },
  buttons: {
    okAdd: "Agregar",
    okEdit: "Guardar",
    cancel: "Cancelar",
  },
  success: "Agendamiento guardado con éxito.",
},
tagModal: {
  title: {
    add: "Nueva Etiqueta",
    edit: "Editar Etiqueta",
  },
  form: {
    name: "Nombre",
    color: "Color",
    blockAi: "Bloquear IA",
  },
  buttons: {
    okAdd: "Agregar",
    okEdit: "Guardar",
    cancel: "Cancelar",
  },
  success: "Etiqueta guardada con éxito.",
},
chat: {
  noTicketMessage: "Seleccione un ticket para comenzar a conversar.",
},
internalChat: {
  actions: {
    reply: "Responder",
    copy: "Copiar",
  },
  reply: {
    you: "Tú",
    cancel: "Cancelar respuesta",
  },
  search: {
    open: "Buscar mensajes",
    title: "Buscar mensajes",
    placeholder: "Buscar",
    prompt: "Buscar mensajes en esta conversación.",
    close: "Cerrar búsqueda",
    loadMore: "Cargar más",
    noResults: "No se encontraron mensajes.",
  },
  copy: {
    success: "Mensaje copiado con éxito.",
    error: "No se pudo copiar el mensaje.",
    empty: "No hay nada para copiar en este mensaje.",
  },
  jump: {
    notFound: "No se pudo abrir este mensaje.",
    tooOld: "Este mensaje es demasiado antiguo para abrirse aquí.",
  },
  list: {
    title: "Conversaciones",
    new: "Nueva",
    empty: "Aún no hay conversaciones. Haga clic en \"Nueva\" para comenzar.",
  },
  tabs: {
    chats: "Conversaciones",
    messages: "Mensajes",
  },
  modal: {
    title: "Conversación",
    titleField: "Título",
    titleRequired: "Por favor, complete el título de la conversación.",
    usersRequired: "Por favor, seleccione al menos un usuario.",
  },
  messages: {
    empty: "Aún no hay mensajes en esta conversación.",
    inputPlaceholder: "Escriba un mensaje",
  },
  header: {
    edit: "Editar conversación",
    delete: "Eliminar conversación",
  },
  deleteConfirm: {
    title: "Eliminar Conversación",
    message: "Esta acción no se puede deshacer, ¿confirmar?",
  },
},
uploads: {
  titles: {
    titleUploadMsgDragDrop: "ARRASTRE Y SUELTE ARCHIVOS EN EL CAMPO ABAJO",
    titleFileList: "Lista de archivo(s)"
  },
},
ticketsManager: {
  buttons: {
    newTicket: "Nuevo",
  },
  emailSync: {
    tooltip: "Actualizar correos (buscar nuevos)",
    error: "No fue posible verificar los correos. Inténtelo de nuevo.",
    received: "{{count}} correo nuevo recibido.",
    received_plural: "{{count}} correos nuevos recibidos.",
    none: "No se encontraron correos nuevos.",
  },
  sorting: {
    title: "Ordenación",
  },
},
ticketsQueueSelect: {
  placeholder: "Colas",
},
ticketsWhatsappSelect: {
  placeholder: "Conexiones",
},
tickets: {
  muted: "Notificaciones silenciadas",
  inactiveConnection: {
    badge: "Conexión eliminada",
    tooltip: "Este ticket pertenece a una conexión eliminada el {{date}}. Disponible solo para consulta.",
    readOnly: "Ticket de una conexión eliminada — solo lectura. No se puede responder ni reabrir.",
    removedToast: "La conexión de este ticket fue eliminada. El ticket fue cerrado.",
  },
  toasts: {
    deleted: "La atención en la que estaba ha sido eliminada.",
    noQueueAccess: "No tiene acceso a la cola de este ticket",
    assumed: "¡Ticket asumido con éxito!",
  },
  notification: {
    message: "Mensaje de",
  },
  tabs: {
    open: { title: "Abiertas" },
    closed: { title: "Resueltos" },
    search: { title: "Búsqueda" },
  },
  search: {
    placeholder: "Buscar atención y mensajes",
  },
  buttons: {
    showAll: "Todos",
  },
  contactRemoved: "Contacto eliminado",
  closePreview: "Cerrar vista previa",
  dropFileHere: "Suelte el archivo aquí",
  advanced: {
    selectTicket: "Seleccionar Ticket",
    nav: {
      ticket: "Ticket",
      tickets: "Tickets",
    },
  },
  developmentRequest: {
    request: "Solicitar desarrollo",
    previewTicketNotFound: "Ticket no encontrado para generar la vista previa.",
    saveTicketNotFound: "Ticket no encontrado para guardar la solicitud.",
    created: "Solicitud de desarrollo registrada con éxito.",
  },
},
transferTicketModal: {
    title: "Transferir Ticket",
    bulkTitle: "Transferir {{count}} tickets",
    keepQueue: "Mantener la cola de cada ticket",
    keepConnection: "Mantener la conexión de cada ticket",
    fieldLabel: "Escribe para buscar usuarios",
    pendingUserHelper: "Opcional: déjalo en blanco para mantener el ticket en espera",
    openUserHelper: "Opcional: déjalo en blanco para devolver el ticket a espera en la cola elegida",
    fieldQueueLabel: "Transferir a cola",
    fieldQueuePlaceholder: "Seleccione una cola",
    noQueue: "Sin cola",
    offline: "desconectado",
    noOptions: "No se encontraron usuarios con ese nombre",
    buttons: {
      ok: "Transferir",
      cancel: "Cancelar",
    },
    selectConnection: "Seleccione una conexión",
    errors: {
      invalidTicket: "Ticket inválido para transferencia",
      selectUser: "Seleccione un usuario",
    },
  },
  ticketContextMenu: {
    selection: "Selección",
    select: "Seleccionar",
    selectAll: "Seleccionar Todos",
    clearSelection: "Limpiar Selección",
    selected: "seleccionados",
    selectedCount: "{{count}} seleccionado(s)",
    cancel: "Cancelar",
    actions: {
      title: "Acciones",
      accept: "Aceptar",
      close: "Finalizar",
      transfer: "Transferir",
      return: "Devolver a la Cola",
      resolve: "Resolver",
      schedule: "Crear Programación",
      markUnread: "Marcar como No Leído",
      markRead: "Marcar como Leído",
      resetAlarm: "Resetear Alarma",
      mute: "Silenciar notificaciones",
      muteFor8Hours: "8 horas",
      muteFor1Week: "1 semana",
      muteForever: "Siempre",
      unmute: "Reactivar sonido",
    },
    confirmAcceptTitle: "Confirmar Aceptar",
    confirmAcceptMessage: "¿Desea aceptar {{count}} ticket(s)?",
    confirmCloseTitle: "Confirmar Finalizar",
    confirmCloseMessage: "¿Desea finalizar {{count}} ticket(s)?",
    confirmReturnTitle: "Confirmar Devolver",
    confirmReturnMessage: "¿Desea devolver {{count}} ticket(s) a la cola?",
    confirmResolveTitle: "Confirmar Resolver",
    confirmResolveMessage: "¿Desea resolver {{count}} ticket(s)?",
    confirmMarkUnreadTitle: "Confirmar Marcar como No Leído",
    confirmMarkUnreadMessage: "¿Desea marcar {{count}} ticket(s) como no leído?",
    confirmMarkReadTitle: "Confirmar Marcar como Leído",
    confirmMarkReadMessage: "¿Desea marcar {{count}} ticket(s) como leído?",
    bulkActionSuccess: "{{count}} ticket(s) - acción '{{action}}' realizada con éxito!",
    bulkActionFail: "{{count}} ticket(s) fallaron en la acción.",
    bulkActionCancelled: "Acción cancelada: {{count}} ticket(s) no fueron modificados.",
    errors: {
      transferTicketNotFound: "No fue posible identificar el ticket para transferir",
    },
  },
  ticketsSearch: {
    sections: {
      contacts: "Contactos",
      commonGroups: "Grupos en común",
      messages: "Mensajes",
    },
    alsoInGroup: "~{{name}} también está en este grupo",
    showMore: "Ver más",
    noResults: "Ningún resultado encontrado",
    noResultsHint: "Nada corresponde a \"{{term}}\" en esta pestaña.",
    searchedUntil: "Buscado hasta {{date}}",
    searchOlder: "Buscar en mensajes más antiguos",
  },
  ticketsList: {
    pendingHeader: "Pendiente",
    assignedHeader: "Atendiendo",
    contactsHeader: "Contactos",
    noTicketsTitle: "¡Nada aquí!",
    noTicketsMessage:
      "No se encontraron tickets con este estado o término de búsqueda",
    buttons: {
      accept: "Aceptar",
      closed: "Finalizar",
      reopen: "Reabrir"
    },
    sorting: {
      oldestFirst: "Más antiguos primero",
      newestFirst: "Más recientes primero",
      longestWaitFirst: "Mayor tiempo de espera",
      shortestWaitFirst: "Menor tiempo de espera",
      unreadFirst: "No leídos primero",
      autoReorder: "Reordenación automática"
    },
    filters: {
      title: "Filtros",
      searchMode: "Modo de búsqueda",
      contactNameOnly: "Buscar solo por nombre del contacto",
      queues: "Colas",
      whatsapp: "Conexión WhatsApp",
      tags: "Etiquetas",
      contactTags: "Etiquetas del contacto",
      contactTagsPlaceholder: "Filtrar por etiquetas del contacto",
      users: "Usuarios",
    },
    noConnection: {
      title: "Ninguna conexión asignada",
      message: "El filtro por conexión está activo y su usuario no tiene ninguna conexión asignada. Pida al administrador que le asigne una conexión en su registro.",
    },
    item: {
      comment: "Comentario",
      queueLabel: "Cola: {{name}}",
      attendantLabel: "Agente: {{name}}",
      aiAgentLabel: "Agente de IA: {{name}}",
    },
  },
  contactsListPanel: {
				newContact: "Nuevo contacto",
    noContacts: "No se encontraron contactos",
    noContactsText: "Usa la búsqueda para encontrar contactos o agrega nuevos en la página de contactos",
  },
  newTicketModal: {
    title: "Crear Ticket",
    fieldLabel: "Escribe para buscar el contacto",
    add: "Agregar",
    noQueue: "Sin cola",
    selectQueue: "Seleccione la cola",
    buttons: {
      ok: "Guardar",
      cancel: "Cancelar",
    },
    selectConnection: "Seleccionar conexión",
    selectConnectionDialogTitle: "Seleccionar la conexión para el ticket",
    errors: {
      selectConnection: "Seleccione una conexión",
      selectWhatsappConnection: "Seleccione una conexión de WhatsApp",
      connectionNotConnected: "La conexión seleccionada no está conectada. Por favor, seleccione una conexión activa.",
    },
    existingTicket: {
      title: "El ticket ya existe",
      message: "Ya existe un ticket abierto para este contacto.",
      unknownUser: "Usuario desconocido",
      attendantLabel: "Agente:",
      queueLabel: "Cola:",
      connectionLabel: "Conexión:",
      groupSingleTicket: "Este grupo ya tiene un ticket en curso. Un grupo tiene un único ticket, en cualquier conexión: abra el existente.",
      canCreateNew: "Puede abrir el ticket existente o crear un nuevo ticket en la conexión seleccionada.",
      canCreateNewWithConnection: "Puede abrir el ticket existente o crear un nuevo ticket en la conexión seleccionada ({{connection}}).",
      sameConnection: "El ticket existente ya está en la conexión seleccionada. ¿Desea abrir este ticket?",
      createNew: "Crear nuevo ticket",
      openExisting: "Abrir ticket existente",
    },
    templatePicker: {
      title: "Ventana de 24 horas expirada",
      description: "La ventana de 24 horas expiró. Envíe una plantilla de mensaje para iniciar una nueva conversación.",
      noTemplates: "No se encontró ninguna plantilla de mensaje aprobada. Cree plantillas y envíelas para aprobación en la página de Plantillas.",
      selectTemplate: "Seleccione una plantilla",
      preview: "Vista previa:",
      emptyBody: "(Sin texto en el cuerpo)",
      variables: "Variables:",
      variable: "Variable",
      send: "Enviar",
      sending: "Enviando...",
      sent: "¡Plantilla enviada con éxito!",
    },
  },
  mainDrawer: {
    listItems: {
					ticketRatings: "Evaluaciones",
					ticketsConference: "Revisión de tickets",
					messagesReport: "Informe de Mensajes",
					attendanceMonitor: "Monitoreo",
					kanban: "Flujos",
					kanbanAll: "Todos los flujos",
					clientCentral: "Central de Clientes",
					usageReport: "Informes",
					clientes: "Clientes",
					followUp: "Follow-up",
					tagPhrases: "Frases que generan Etiqueta",
					forbiddenWords: "Términos prohibidos",
					forbiddenWordsRegister: "Registro de términos",
					forbiddenWordsReport: "Informe de términos",
					development: "Desarrollo",
					campaignsList: "Listado",
					contactLists: "Listas de Contactos",
					campaignsConfig: "Configuraciones",
					messageTemplates: "Plantillas de Mensaje",
					management: "Gestión",
					documentTemplates: "Modelos de Documentos",
      perfis: "Perfiles de Usuario",
      dashboard: "Tablero",
      connections: "Conexiones",
      tickets: "Tickets",
      pendingMessages: "Pendientes",
      catalog: "Catálogo de Productos",
      quickMessages: "Respuestas Rápidas",
      contacts: "Contactos",
      queues: "Colas y Chatbot",
      tags: "Etiquetas",
      administration: "Administración",
      users: "Usuarios",
      settings: "Configuraciones",
      helps: "Ayuda",
      messagesAPI: "API",
      schedules: "Agendamientos",
      campaigns: "Campañas",
      annoucements: "Anuncios",
      chats: "Chat Interno",
      financeiro: "Financiero",
      files: "Lista de archivos",
      prompts: "Open.Ai",
      queueIntegration: "Integraciones",
    },
    appBar: {
					tooltips: {
						darkMode: "Alternar tema claro/oscuro",
						volume: "Volumen de las notificaciones",
						tickets: "Notificaciones de tickets",
						announcements: "Anuncios",
						internalChat: "Chat interno",
						account: "Mi cuenta",
					},
					refresh: "Actualizar página",
					clearCache: {
						tooltip: "Limpiar caché",
						title: "¿Limpiar caché y datos del CRM?",
						message: "Esto borra la caché, las cookies y los datos del CRM guardados en este navegador, cierra su sesión y recarga el sistema en la versión más reciente. Los mensajes que aún no se enviaron se perderán. Después solo tiene que iniciar sesión de nuevo.",
					},
					openFollowUp: "Abrir popup de follow-up",
					greeting: {
						hello: "Hola",
						welcome: "Bienvenido a",
						activeUntil: "Activo hasta {{date}}",
					},
					toasts: {
						popupBlocked: "El navegador bloqueó el popup de follow-up. Permita popups e intente de nuevo.",
					},
      notRegister:"Sin notificaciones",
      user: {
						language: "Idioma",
        profile: "Perfil",
        logout: "Salir",
      },
    },
  },
  queueIntegration: {
				toasts: {
					deleted: "Integración eliminada con éxito.",
				},
    title: "Integraciones",
    table: {
      id: "ID",
      type: "Tipo",
      name: "Nombre",
      projectName: "Nombre del Proyecto",
      language: "Idioma",
      lastUpdate: "Última actualización",
      actions: "Acciones",
    },
    buttons: {
      add: "Agregar Proyecto",
    },
    searchPlaceholder: "Buscar...",
    confirmationModal: {
      deleteTitle: "Eliminar",
      deleteMessage:
        "¿Estás seguro? ¡Esta acción no se puede deshacer! y se eliminará de las colas y conexiones vinculadas",
    },
  },
  files: {
    title: "Lista de archivos",
    table: {
      name: "Nombre",
      contacts: "Contactos",
      actions: "Acción",
    },
    toasts: {
      deleted: "¡Lista eliminada correctamente!",
      deletedAll: "¡Todas las listas se han eliminado correctamente!",
    },
    buttons: {
      add: "Agregar",
      deleteAll: "Eliminar Todos",
    },
    confirmationModal: {
      deleteTitle: "Eliminar",
      deleteAllTitle: "Eliminar Todos",
      deleteMessage: "¿Estás seguro de que deseas eliminar esta lista?",
      deleteAllMessage: "¿Estás seguro de que deseas eliminar todas las listas?",
    },
  },
  messagesAPI: {
    title: "API",
    textMessage: {
      number: "Número",
      body: "Mensaje",
      token: "Token registrado",
    },
    mediaMessage: {
      number: "Número",
      body: "Nombre del archivo",
      media: "Archivo",
      token: "Token registrado",
    },
    showHideToken: "Mostrar/ocultar token",
    buttons: {
      send: "Enviar",
    },
    toasts: {
      sent: "Mensaje enviado correctamente",
    },
    doc: {
      title: "Documentación para el envío de mensajes",
      methods: "Métodos de envío",
      textMessages: "Mensajes de texto",
      mediaMessages: "Mensajes multimedia",
      instructions: "Instrucciones",
      importantNotes: "Observaciones importantes",
      tokenNote: "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes.",
      tokenNoteHowTo: "Para registrarlo, accede al menú \"{{menu}}\", haz clic en el botón editar de la conexión e ingresa el token en el campo correspondiente.",
      numberFormat: "El número de destino no debe tener máscara ni caracteres especiales y debe estar compuesto por:",
      countryCode: "Código del país",
      areaCode: "Código de área",
      textInfo: "A continuación, la información necesaria para enviar mensajes de texto:",
      mediaInfo: "A continuación, la información necesaria para enviar mensajes multimedia:",
      method: "Método",
      headers: "Authorization (Bearer token) y Content-Type ({{contentType}})",
      fileValue: "archivo",
      sendTest: "Prueba de envío",
    },
  },
  notifications: {
    noTickets: "No hay notificaciones.",
  },
  catalog: {
    title: "Catálogo de Productos",
    searchPlaceholder: "Buscar producto o SKU",
    connection: "Conexión",
    collection: "Colección",
    allCollections: "Todas",
    empty: "Ningún producto en el catálogo de esta conexión. Use Sincronizar para traer los productos de WhatsApp.",
    table: {
      image: "Imagen",
      name: "Producto",
      sku: "SKU",
      price: "Precio",
      status: "Situación",
      actions: "Acciones",
    },
    status: {
      published: "Publicado",
      hidden: "Oculto",
      localOnly: "Solo en el CRM",
    },
    buttons: {
      sync: "Sincronizar",
      add: "Nuevo producto",
    },
    toasts: {
      synced: "Catálogo sincronizado: {{created}} nuevos, {{updated}} actualizados, {{removed}} eliminados.",
      deleted: "Producto eliminado con éxito.",
    },
    confirmationModal: {
      deleteTitle: "Eliminar producto",
      deleteMessage: "¿Seguro que desea eliminar este producto? También se eliminará del catálogo de WhatsApp.",
    },
    modal: {
      addTitle: "Nuevo producto",
      editTitle: "Editar producto",
      name: "Nombre",
      description: "Descripción",
      price: "Precio",
      currency: "Moneda",
      retailerId: "SKU (código del producto)",
      retailerIdHint: "Identificador que WhatsApp usa al enviar el producto. Si queda vacío, el proveedor genera uno.",
      productUrl: "Enlace del producto",
      addImage: "Agregar imagen",
      changeImage: "Cambiar imagen",
      isHidden: "Ocultar en el catálogo público",
      hint: "El producto se crea en el catálogo de WhatsApp y queda disponible para enviar en el chat.",
      save: "Guardar",
      cancel: "Cancelar",
      saved: "Producto guardado con éxito.",
      validation: {
        nameRequired: "Informe el nombre del producto.",
        nameShort: "Nombre demasiado corto.",
        priceRequired: "Informe el precio.",
        priceInvalid: "Precio inválido.",
      },
    },
    picker: {
      title: "Enviar producto del catálogo",
      searchPlaceholder: "Buscar producto",
      empty: "Ningún producto encontrado. Sincronice el catálogo en la pantalla Catálogo de Productos.",
      mode: "Cómo enviar",
      modeSingle: "Un producto",
      modeList: "Lista de productos",
      modeCatalog: "Catálogo completo",
      message: "Mensaje (opcional)",
      header: "Título de la lista",
      footer: "Pie de página (opcional)",
      send: "Enviar",
      cancel: "Cancelar",
      sent: "Producto enviado.",
      selectOne: "Seleccione al menos un producto.",
    },
  },
  quickMessages: {
    title: "Respuestas Rápidas",
    searchPlaceholder: "Buscar...",
    noAttachment: "Sin adjunto",
    confirmationModal: {
      deleteTitle: "Eliminación",
      deleteMessage: "¡Esta acción es irreversible! ¿Quieres continuar?",
    },
    buttons: {
      add: "Agregar",
      attach: "Adjuntar Archivo(s)",
      cancel: "Cancelar",
      edit: "Editar",
    },
    toasts: {
      success: "¡Atajo agregado correctamente!",
      deleted: "¡Atajo eliminado correctamente!",
    },
    attachments: {
      title: "Adjuntos",
      maxReached: "Límite de {{max}} adjuntos por respuesta rápida alcanzado.",
      rejected: "Archivo(s) no permitido(s): {{files}}",
      notFound: "No se encontraron adjuntos de esta respuesta rápida en el servidor.",
      deleteAllMessage:
        "El adjunto de esta respuesta rápida será eliminado. ¿Deseas continuar?",
    },
    dialog: {
      title: "Mensaje Rápido",
      shortcode: "Atajo",
      message: "Respuesta",
      save: "Guardar",
      cancel: "Cancelar",
      geral: "Permitir editar",
      add: "Agregar",
      edit: "Editar",
      visao: "Permitir vista",
      mediaAlt: "Archivo del mensaje",
    },
    modal: {
      title: "Mensajes Rápidos",
      search: "Buscar mensajes rápidos...",
      empty: "No hay mensajes rápidos registrados",
      noResults: "No se encontraron mensajes",
      viewMessage: "Ver mensaje",
      close: "Cerrar",
      useMessage: "Usar mensaje",
      hasMedia: "Medios",
    },
    table: {
      shortcode: "Atajo",
      message: "Mensaje",
      actions: "Acciones",
      mediaName: "Nombre del Archivo",
      filesSuffix: "archivos",
      status: "Estado",
    },
  },
  messageVariablesPicker: {
    label: "Variables disponibles",
    vars: {
      contactFirstName: "Primer Nombre",
      contactName: "Nombre",
      greeting: "Saludo",
      protocolNumber: "Protocolo",
      date: "Fecha",
      hour: "Hora",
    },
  },
  contactLists: {
    title: "Listas de Contactos",
    table: {
      name: "Nombre",
      contacts: "Contactos",
      actions: "Acciones",
    },
    buttons: {
      add: "Nueva Lista",
      downloadSample: "Descargar hoja de cálculo de ejemplo",
    },
    dialog: {
      name: "Nombre",
      company: "Empresa",
      okEdit: "Editar",
      okAdd: "Agregar",
      add: "Agregar",
      edit: "Editar",
      cancel: "Cancelar",
    },
    confirmationModal: {
      deleteTitle: "Eliminar",
      deleteMessage: "Esta acción no se puede deshacer.",
    },
    toasts: {
					saved: "Lista guardada con éxito.",
      deleted: "Registro eliminado",
    },
    searchPlaceholder: "Buscar por ID o nombre",
    pagination: {
      rowsPerPage: "Elementos por página",
      displayedRows: "{{from}}-{{to}} de {{total}}",
    },
  },
  contactListItems: {
    title: "Contactos",
    searchPlaceholder: "Búsqueda",
    buttons: {
      add: "Nuevo",
      lists: "Listas",
      import: "Importar",
      importing: "Importando…",
    },
    dialog: {
      name: "Nombre",
      number: "Número",
      whatsapp: "Whatsapp",
      email: "Correo electrónico",
      okEdit: "Editar",
      okAdd: "Agregar",
      add: "Agregar",
      edit: "Editar",
      cancel: "Cancelar",
    },
    importProgress: {
      uploading: "Enviando hoja de cálculo… {{percent}}%",
      processing: "Procesando hoja de cálculo…",
      importing: "Importando contactos: {{processed}} de {{total}}",
    },
    validation: {
      queued: "En cola para validación en WhatsApp…",
      progress: "Validando números en WhatsApp: {{checked}} de {{total}}",
      done: "Validación concluida: {{valid}} válidos y {{invalid}} inválidos.",
      doneWithPending:
        "Validación concluida: {{valid}} válidos, {{invalid}} inválidos y {{unvalidated}} sin validar.",
      unavailable:
        "Validación en WhatsApp no disponible (ninguna conexión de WhatsApp conectada). Los contactos se importaron y el envío no se ve afectado; importe la hoja de cálculo de nuevo para intentar validar los pendientes.",
      error:
        "Error al validar los números en WhatsApp. Los contactos se importaron; importe la hoja de cálculo de nuevo para intentar validar los pendientes.",
    },
    table: {
      name: "Nombre",
      number: "Número",
      whatsapp: "Whatsapp",
      email: "Correo electrónico",
      actions: "Acciones",
      validWhatsapp: "WhatsApp válido",
      invalidWhatsapp: "WhatsApp inválido",
      notValidated: "Número no validado en WhatsApp",
    },
    confirmationModal: {
      deleteTitle: "Eliminar",
      deleteMessage: "Esta acción no se puede deshacer.",
      importMessage: "¿Desea importar los contactos de esta hoja de cálculo?",
      importTitlte: "Importar",
      downloadSample: "Haz clic aquí para descargar la hoja de cálculo de ejemplo.",
    },
    toasts: {
      deleted: "Registro eliminado",
      imported:
        "{{created}} contactos importados ({{duplicates}} ya estaban en la lista, {{invalid}} filas sin número válido).",
    },
  },
  campaigns: {
    title: "Campañas",
    searchPlaceholder: "Búsqueda",
    buttons: {
      add: "Nueva Campaña",
      contactLists: "Listas de Contactos",
    },
    table: {
      name: "Nombre",
      whatsapp: "Conexión",
      contactList: "Lista de Contactos",
      status: "Estado",
      scheduledAt: "Programada",
      completedAt: "Completada",
      confirmation: "Confirmación",
      actions: "Acciones",
      noContactList: "No definida",
      noWhatsapp: "No definida",
      notScheduled: "Sin programación",
      notCompleted: "No concluida",
      confirmationEnabled: "Habilitada",
      confirmationDisabled: "Deshabilitada",
    },
    dialog: {
      new: "Nueva Campaña",
      update: "Editar Campaña",
      readonly: "Solo Lectura",
      form: {
        name: "Nombre",
        message1: "Mensaje 1",
        message2: "Mensaje 2",
        message3: "Mensaje 3",
        message4: "Mensaje 4",
        message5: "Mensaje 5",
        confirmationMessage1: "Mensaje de Confirmación 1",
        confirmationMessage2: "Mensaje de Confirmación 2",
        confirmationMessage3: "Mensaje de Confirmación 3",
        confirmationMessage4: "Mensaje de Confirmación 4",
        confirmationMessage5: "Mensaje de Confirmación 5",
        messagePlaceholder: "Contenido del mensaje",
        whatsapp: "Conexión",
        status: "Estado",
        scheduledAt: "Programada",
        confirmation: "Confirmación",
        contactList: "Lista de Contacto",
        tagList: "Lista de Etiquetas",
        fileList: "Lista de Archivos",
        none: "Ninguna",
        whatsappConnection: "Conexión de WhatsApp",
        responseQueue: "Cola para respuestas de la campaña",
        responseQueueHelper: "Si seleccionas una cola, el plazo de respuesta en minutos se vuelve obligatorio.",
        responseWindow: "Plazo de respuesta (minutos)",
        responseWindowHelper: "Obligatorio. Envía a la cola si el contacto responde dentro de este plazo.",
        responseWindowDisabledHelper: "Selecciona una cola para habilitar este campo.",
        dispatchType: "Inicio de la campaña",
        dispatchImmediate: "Iniciar inmediatamente",
        dispatchScheduled: "Programar para fecha/hora",
      },
      buttons: {
        add: "Agregar",
        edit: "Actualizar",
        okadd: "Ok",
        cancel: "Cancelar",
        restart: "Reiniciar envíos",
        close: "Cerrar",
        attach: "Adjuntar Archivo",
      },
      validation: {
        integerMinutes: "Usa un número entero de minutos",
        minWindow: "El plazo mínimo es 1 minuto",
        maxWindow: "El plazo máximo es 10080 minutos (7 días)",
        queueAndWindow: "Selecciona la cola y el plazo para habilitar el enrutamiento",
        windowRequired: "Ingresa el plazo en minutos",
        responseQueueRequired: "Selecciona una cola de respuesta",
      },
      toasts: {
        missingVariables: "Completa todas las variables de la plantilla antes de guardar:",
        smsMessageRequired: "Escribe el mensaje de texto de la campaña de SMS.",
        smsBaratoTooLong: "El mensaje tiene {{length}} caracteres después de la conversión al formato de SMS Barato; el límite del proveedor es {{max}}.",
        templateRequired: "Selecciona una plantilla para la campaña.",
        scheduledAtRequired: "Completa la fecha/hora de programación.",
        responseWindowRequired: "Ingresa el plazo de respuesta en minutos (mínimo 1) para la cola seleccionada.",
      },
      sms: {
        sectionTitle: "MENSAJE - Para SMS",
        messageLabel: "Mensaje del SMS *",
        messagePlaceholder: "Texto que se enviará. Usa {{variable}} para personalizarlo.",
        helperSmsBarato: "{{length}}/{{max}} caracteres · SMS Barato envía 1 SMS por mensaje, sin acentos ni saltos de línea",
        helperSegments: "{{length}} caracteres · {{encoding}} · {{segments}} segmento(s) cobrado(s) · {{perSegment}} caracteres por segmento",
        overLimit: "El mensaje supera el límite de {{max}} caracteres de SMS Barato: reduce el texto para guardar la campaña.",
        willBeSentAs: "Se enviará como:",
        ucs2Warning: "El mensaje contiene caracteres fuera del estándar GSM-7 (emojis, símbolos y, en Witi.me, acentos). Esto reduce el límite de 160 a 70 caracteres por segmento y encarece el envío.",
      },
      template: {
        sectionTitle: "PLANTILLA - Para Cloud API",
        label: "Plantilla",
        selectConnection: "Selecciona una conexión Cloud API para cargar las plantillas.",
        selected: "Plantilla seleccionada:",
        category: "Categoría:",
        language: "Idioma:",
        text: "Texto:",
      },
      variables: {
        title: "Configuración de Variables de la Plantilla",
        description: "Configura cómo se completará cada variable de la plantilla con datos de los contactos o valores fijos.",
        variable: "Variable",
        buttonUrlRequired: "{{component}} - Botón URL (obligatorio)",
        buttonType: "Botón {{type}}",
        contactData: "Dato del contacto",
        fixedValue: "Valor fijo",
        contactField: "Campo del contacto",
        fixedValuePlaceholder: "Ingresa el valor que se usará para todos los contactos",
      },
    },
    confirmationModal: {
      deleteTitle: "Eliminar",
      deleteMessage: "Esta acción no se puede deshacer.",
    },
    toasts: {
      success: "Operación realizada correctamente",
      cancel: "Campaña cancelada",
      restart: "Campaña reiniciada",
      deleted: "Registro eliminado",
    },
    statuses: {
      inactive: "Inactiva",
      scheduled: "Programada",
      inProgress: "En curso",
      canceled: "Cancelada",
      finished: "Finalizada",
    },
    actions: {
      stop: "Detener campaña",
      start: "Iniciar campaña",
      startNow: "Iniciar ahora",
      viewReport: "Ver informe",
    },
    pagination: {
      rowsPerPage: "Elementos por página",
      displayedRows: "{{from}}-{{to}} de {{total}}",
      moreThan: "más de {{value}}",
    },
  },
  announcements: {
    active: 'Activo',
    inactive: 'Inactivo',
    title: "Informativos",
    searchPlaceholder: "Búsqueda",
    buttons: {
      add: "Nuevo Informativo",
      contactLists: "Listas de Informativos",
    },
    table: {
      priority: "Prioridad",
      title: "Título",
      text: "Texto",
      mediaName: "Archivo",
      status: "Estado",
      actions: "Acciones",
    },
    dialog: {
      edit: "Editar Informativo",
      add: "Nuevo Informativo",
      update: "Editar Informativo",
      readonly: "Solo Lectura",
      form: {
        priority: "Prioridad",
        title: "Título",
        text: "Texto",
        mediaPath: "Archivo",
        status: "Estado",
      },
      buttons: {
        add: "Agregar",
        edit: "Actualizar",
        okadd: "Ok",
        cancel: "Cancelar",
        close: "Cerrar",
        attach: "Adjuntar Archivo",
      },
    },
    confirmationModal: {
      deleteTitle: "Eliminar",
      deleteMessage: "Esta acción no se puede deshacer.",
    },
    toasts: {
      success: "Operación realizada correctamente",
      deleted: "Registro eliminado",
    },
  },
  campaignsConfig: {
    title: "Configuraciones de Campañas",
    toasts: {
      saved: "Configuración guardada",
    },
    intervals: {
      title: "Intervalos",
      baileysOnly: "La aleatoriedad de los intervalos de envío se aplica solo a las conexiones Baileys.",
      messageInterval: "Intervalo aleatorio de envío",
      longerIntervalAfter: "Intervalo mayor después de",
      greaterInterval: "Intervalo de envío mayor",
      noInterval: "Sin intervalo",
      notDefined: "No definido",
      seconds: "{{count}} segundo",
      seconds_plural: "{{count}} segundos",
    },
    buttons: {
      addVariable: "Agregar variable",
      saveSettings: "Guardar configuración",
    },
    variables: {
      shortcut: "Atajo",
      content: "Contenido",
    },
  },
  queues: {
    title: "Colas y Chatbot",
    table: {
      id:"ID",
      name: "Nombre",
      color: "Color",
      greeting: "Mensaje de bienvenida",
      actions: "Acciones",
      orderQueue: "Orden de la cola (bot)",
    },
    buttons: {
      add: "Agregar cola",
    },
    confirmationModal: {
      deleteTitle: "Eliminar",
      deleteMessage:
        "¿Estás seguro? ¡Esta acción no se puede deshacer! Los tickets de esta cola seguirán existiendo pero ya no tendrán ninguna cola asignada.",
    },
    toasts: {
      deleted: "Cola eliminada correctamente.",
      hasPrompts: "No se puede eliminar la cola. Hay prompts asociados a esta cola. Por favor, reasigna o elimina los prompts antes de eliminar esta cola.",
    },
  },
  queueSelect: {
    inputLabel: "Colas",
    selectQueue: "Selecciona una cola",
  },
  users: {
    title: "Usuarios",
    table: {
	  id: "ID",
      name: "Nombre",
      email: "Email",
      profile: "Perfil",
      queues: "Colas",
      defaultConnection: "Conexion Predeterminada",
      allTicket: "Ticket Sin Cola",
      actions: "Acciones",
    },
    buttons: {
      add: "Agregar usuario",
      salesReport: "Informe de Metas",
    },
    toasts: {
      deleted: "Usuario eliminado correctamente.",
    },
    confirmationModal: {
      deleteTitle: "Eliminar",
      deleteMessage:
        "Todos los datos del usuario se perderán. Los tickets abiertos de este usuario se moverán a la cola.",
    },
    salesReport: {
      title: "Informe de Metas de Ventas",
      period: "Período",
      user: "Usuario",
      salesGoal: "Meta ($)",
      totalSales: "Total Vendido ($)",
      achievement: "Logro",
      actions: "Acciones",
      viewDetails: "Ver detalles de ventas",
      noData: "No se encontraron ventas en el período",
      filters: {
        startDate: "Fecha Inicial",
        endDate: "Fecha Final",
        allUsers: "Todos los Usuarios",
        filter: "Filtrar",
      },
      details: {
        title: "Detalles de Ventas",
        totalSales: "Total de Ventas",
        salesCount: "Cantidad de Ventas",
        date: "Fecha",
        clientName: "Cliente",
        value: "Valor",
        observations: "Observaciones",
        total: "TOTAL",
        noSales: "No se encontraron ventas para este usuario en el período",
      },
    },
  },
  helps: {
    title: "Centro de Ayuda",
    form: {
      title: "Título",
      video: "Código del video",
    },
    table: {
      video: "Video",
    },
    toasts: {
      saveError: "No fue posible realizar la operación. Verifica si ya existe una ayuda con el mismo título o si los campos se completaron correctamente",
    },
  },
  schedules: {
    title: "Agendamientos",
    confirmationModal: {
      deleteTitle: "¿Estás seguro que quieres eliminar este Agendamiento?",
      deleteMessage: "Esta acción no se puede deshacer.",
    },
    table: {
      contact: "Contacto",
      body: "Mensaje",
      sendAt: "Fecha de Agendamiento",
      sentAt: "Fecha de Envío",
      status: "Estado",
      actions: "Acciones",
    },
    buttons: {
      add: "Nuevo Agendamiento",
    },
    toasts: {
      deleted: "Agendamiento eliminado correctamente.",
    },
    calendar: {
      yesterday: "Ayer",
      tomorrow: "Mañana",
      noEventsInRange: "No hay agendamientos en el período.",
      showMore: "+{{total}} más",
      eventFallback: "Agendamiento",
    },
  },
  tags: {
    title: "Etiquetas",
    confirmationModal: {
      deleteTitle: "¿Estás seguro que quieres eliminar esta Etiqueta?",
      deleteMessage: "Esta acción no se puede deshacer.",
	  deleteAllMessage: "¿Estás seguro que quieres eliminar todas las Etiquetas?",
	  deleteAllTitle: "Eliminar Todas",
    },
    table: {
      name: "Nombre",
      color: "Color",
      tickets: "Tickets Etiquetados",
      contacts: "Contactos",
      actions: "Acciones",
    },
    buttons: {
      add: "Nueva Etiqueta",
	  deleteAll: "Eliminar Todas",
      viewContacts: "Ver contactos con esta etiqueta",
    },
    toasts: {
	  deletedAll: "¡Todas las Etiquetas se han eliminado correctamente!",
      deleted: "Etiqueta eliminada correctamente.",
    },
  },
  tagContactsModal: {
    title: "Contactos con la etiqueta",
    count: "{{count}} contacto(s)",
    search: "Buscar por nombre, número o CNPJ del cliente...",
    empty: "Ningún contacto con esta etiqueta.",
    minChars: "Escribe al menos {{count}} caracteres para buscar.",
    close: "Cerrar",
  },
  settings: {
    success: "Configuraciones guardadas correctamente.",
    title: "Configuraciones",
    tabs: {
      options: "Opciones",
      kanban: "Kanban",
      schedules: "Horarios",
      companies: "Empresas",
      plans: "Planes",
      email: "Correo",
      cloudApi: "Cloud API",
      customFields: "Campos personalizados",
      requiredFields: "Campos obligatorios",
      help: "Ayuda",
      empsis: "Empsis",
      templateCredits: "Créditos de Plantilla",
      aiCredits: "Créditos de IA",
      instagramWebhooks: "Webhooks IG",
      systemAlerts: "Alertas del Sistema",
    },
    companiesManager: {
      fields: {
        name: "Nombre",
        cnpj: "CNPJ",
        email: "Correo electrónico",
        adminPassword: "Contraseña del administrador",
        phone: "Teléfono",
        plan: "Plan",
        status: "Estado",
        campaigns: "Campañas",
        dueDate: "Fecha de vencimiento",
        recurrence: "Recurrencia",
        empsisToken: "Token Empsis",
        empsisTokenHelper: "Se usa para validar la licencia en Empsis",
        customValue: "Valor personalizado (R$)",
        customUsers: "Usuarios (personalizado)",
        customConnections: "Conexiones (personalizado)",
      },
      options: {
        active: "Activa",
        inactive: "Inactiva",
        enabled: "Habilitadas",
        disabled: "Deshabilitadas",
      },
      recurrence: {
        MENSAL: "Mensual",
        BIMESTRAL: "Bimestral",
        TRIMESTRAL: "Trimestral",
        SEMESTRAL: "Semestral",
        ANUAL: "Anual",
      },
      validation: {
        cnpjInvalid: "CNPJ inválido",
        cnpjRequired: "CNPJ obligatorio",
        passwordRequired: "Contraseña obligatoria",
        passwordMin: "Mínimo de 5 caracteres",
        empsisTokenRequired: "Token de Empsis obligatorio",
      },
      customization: "Personalización (cliente con precio/límites propios — deja en blanco para usar el plan)",
      buttons: {
        clear: "Limpiar",
        delete: "Eliminar",
        addDueDate: "+ Vencimiento",
        user: "Usuario",
        save: "Guardar",
        generateToken: "Generar token",
        recheckLicense: "Revalidar licencia",
      },
      tokenVisibility: {
        show: "Mostrar token",
        hide: "Ocultar token",
      },
      restricted: {
        title: "Acceso restringido",
        message: "Solo el usuario administrador principal puede gestionar empresas.",
        hint: "Ponte en contacto con el administrador del sistema si necesitas hacer cambios.",
      },
      license: {
        section: "Licencia Empsis",
        column: "Licencia",
        columnMonitor: "Licencia (monitor)",
        monitorTooltip: "Modo monitor: el estado se consulta en Empsis, pero ninguna empresa se bloquea.",
        status: {
          noCnpj: "Bloqueada: sin CNPJ",
          exemptInvalid: "Exenta (licencia inválida)",
          exempt: "Exenta",
          valid: "Válida",
          invalid: "Inválida",
          unchecked: "No verificada",
        },
        checkedAt: "Consultada el {{date}}",
        token: {
          autoRenew: "Renovación automática del token",
          noAutoRenew: "Token sin renovación automática",
          missing: "Sin token de Empsis",
        },
        exemptLabel: "Exenta de la validación de licencia",
        exemptNoCnpjHint: "Sin CNPJ la empresa queda bloqueada aunque esté exenta. Registra el CNPJ para liberarla.",
      },
      tokenDialog: {
        title: "Generar token de Empsis",
        description: "Usuario y contraseña de acceso a Empsis. Se guardan cifrados para que FaleCRM genere otro token por su cuenta cuando este venza (30 días).",
        user: "Usuario de Empsis",
        password: "Contraseña de Empsis",
        cancel: "Cancelar",
        generate: "Generar",
      },
      grid: {
        createdAt: "Creada el",
        dueDate: "Vencimiento",
        reactivate: "Reactivar empresa",
        deactivate: "Desactivar empresa",
      },
      toasts: {
        tokenGeneratedPending: "Token generado. Se guardará junto con la empresa.",
        tokenGeneratedSaved: "Token generado y guardado para la empresa.",
        licenseUnavailable: "Empsis no dio una respuesta definitiva ({{reason}}). Se mantuvo el último estado.",
        noDetails: "sin detalles",
        licenseRechecked: "Licencia revalidada: {{status}}.",
        licenseRecheckedWithReason: "Licencia revalidada: {{status}} ({{reason}}).",
        exemptOn: "Empresa marcada como exenta de la validación de licencia.",
        exemptOff: "Exención de licencia eliminada.",
        loadError: "No fue posible cargar la lista de registros",
        success: "¡Operación realizada con éxito!",
        error: "No fue posible realizar la operación",
        reactivated: "¡Empresa reactivada con éxito!",
        deactivated: "Empresa desactivada. Los usuarios no podrán iniciar sesión y las conexiones de WhatsApp fueron desconectadas.",
        statusError: "No fue posible cambiar el estado de la empresa",
      },
      showInactive: "Ver inactivas ({{count}})",
      confirm: {
        deleteTitle: "Eliminar registro",
        deleteMessage: "¿Realmente deseas eliminar este registro?",
        reactivateTitle: "¿Reactivar la empresa {{name}}?",
        deactivateTitle: "¿Desactivar la empresa {{name}}?",
        reactivateMessage: "Los usuarios recuperarán el acceso y las conexiones de WhatsApp con sesión guardada se reconectarán automáticamente.",
        deactivateMessage: "Los usuarios de esta empresa ya no podrán iniciar sesión y las conexiones de WhatsApp se desconectarán (la sesión guardada se conserva para una futura reactivación).",
      },
    },
    empsis: {
      title: "Integración Empsis",
      description: "El token de Empsis se usa para consultar los activos fijos (campos de Patrimonio de los tableros de alquiler) y para validar la licencia de uso. Para generarlo, informa el CNPJ, el usuario y la contraseña de acceso a Empsis. FaleCRM guarda el token y almacena el usuario y la contraseña cifrados para generar otro por su cuenta cuando este venza. Cada token de Empsis es válido por 30 días.",
      docsLink: "Documentación de la API",
      fields: {
        cnpj: "CNPJ",
        user: "Usuario de Empsis",
        password: "Contraseña de Empsis",
        token: "Token de la API de Empsis",
        tokenPlaceholder: "Ningún token generado todavía",
        tokenHelper: "Solo lectura. Para cambiar el token, usa Generar y guardar arriba.",
      },
      buttons: {
        generate: "Generar y guardar",
        generating: "Generando...",
        test: "Probar conexión",
        testing: "Probando...",
      },
      autoRenew: {
        active: "Renovación automática activa · usuario {{user}}",
        generatedAt: " · token generado el {{date}}",
        inactive: "Renovación automática desactivada: genera el token aquí para que FaleCRM lo renueve por su cuenta.",
      },
      currentToken: "Token actual",
      toasts: {
        generated: "Token generado y guardado. Se renovará automáticamente cuando venza.",
        generatedNoRenew: "Token generado y guardado, pero sin renovación automática.",
      },
      errors: {
        serverUnreachable: "No fue posible comunicarse con el servidor.",
      },
      testResult: {
        ok: "Conexión OK: {{count}} ítem(s) de activo fijo encontrados.",
        okEmpty: "Conexión OK, pero Empsis no devolvió ningún ítem activo.",
        failed: "Falló la conexión: {{reason}}",
      },
    },
    options: {
      loading: "Actualizando...",
      sections: {
        integrations: "INTEGRACIONES",
        asaas: "ASAAS",
        aiTransferNotify: "AVISO DE TRANSFERENCIA DE LA IA",
      },
      messages: {
        updated: "Operación actualizada correctamente.",
        updateError: "Error al actualizar la configuración.",
      },
      fields: {
        userRating: {
          label: "Evaluaciones",
          options: {
            enabled: "Habilitadas",
            disabled: "Deshabilitadas",
          },
        },
        crmConvertedQuestion: {
          label: "Pregunta de Conversión (CRM)",
          helper: "Pregunta \"¿Convertido?\" al cerrar la atención",
          options: {
            enabled: "Habilitada",
            disabled: "Deshabilitada",
          },
        },
        scheduleType: {
          label: "Gestión de horario",
          options: {
            disabled: "Deshabilitado",
            queue: "Cola",
            company: "Empresa",
          },
        },
        checkMsgIsGroup: {
          label: "Ignorar mensajes de grupos",
          options: {
            enabled: "Activado",
            disabled: "Desactivado",
          },
        },
        callType: {
          label: "Aceptar llamadas",
          options: {
            enabled: "Aceptar",
            disabled: "No aceptar",
          },
        },
        chatbotType: {
          label: "Tipo de chatbot",
          options: {
            text: "Texto",
          },
        },
        sendGreetingAccepted: {
          label: "Enviar saludo al aceptar el ticket",
          options: {
            enabled: "Habilitado",
            disabled: "Deshabilitado",
          },
        },
        sendMsgTransfTicket: {
          label: "Enviar mensaje de transferencia de cola/agente",
          options: {
            enabled: "Habilitado",
            disabled: "Deshabilitado",
          },
        },
        sendGreetingMessageOneQueues: {
          label: "Enviar saludo cuando haya solo 1 cola",
          options: {
            enabled: "Habilitado",
            disabled: "Deshabilitado",
          },
        },
        autoManageConnection: {
          label: "Auto gestión de conexión",
          options: {
            enabled: "Habilitado",
            disabled: "Deshabilitado",
          },
        },
        sidebarBehavior: {
          label: "Comportamiento del menú lateral",
          options: {
            expanded: "Siempre expandido",
            collapsed: "Contraído (con hover)",
            collapsed_no_hover: "Contraído (sin hover)",
          },
        },
        sidebarSubmenuBehavior: {
          label: "Comportamiento de los submenús",
          options: {
            expanded: "Siempre expandidos",
            collapsible: "Colapsables",
          },
        },
        unifyTicketsByContact: {
          label: "Ticket de contacto con varias conexiones",
          helper: "Uno por contacto: el contacto tiene un único ticket, en cualquier conexión. Uno por conexión: cada conexión tiene su propio ticket con el contacto; enviar o reenviar sin elegir la conexión usa la del agente, y asumir no cambia el ticket de conexión.",
          options: {
            enabled: "Uno por contacto (cualquier conexión)",
            disabled: "Uno por conexión",
          },
        },
        groupTicketUnify: {
          label: "Ticket de grupo con varias conexiones",
          helper: "Uno por grupo: cuando más de una conexión participa del mismo grupo existe un único ticket (la conexión elegida al enviar pasa a ser la del ticket). Uno por conexión: cada conexión tiene su propio ticket del grupo y todos muestran la conversación completa.",
          options: {
            enabled: "Uno por grupo (cualquier conexión)",
            disabled: "Uno por conexión",
          },
        },
        notifyGroupMessages: {
          label: "Notificar mensajes de grupo",
          helper: "Reproduce el sonido y muestra el aviso también para mensajes de grupo, con la misma regla de los tickets individuales (En espera: quien puede abrir el ticket; con agente: solo el agente). Cada grupo se puede silenciar individualmente.",
          options: {
            disabled: "Deshabilitado (los grupos no avisan)",
            enabled: "Habilitado",
          },
        },
        notifyPhoneUnreadMessages: {
          label: "Avisar al celular de mensajes sin leer",
          helper: "Vale para conexiones con \"Mostrar escribiendo y en línea del contacto\" activado. Con un agente usando FaleCRM el número queda en línea y el celular no notifica; si un mensaje de cliente queda algunos minutos (por defecto 3) sin abrir, el número sale de línea por unos segundos para que el celular notifique.",
          options: {
            enabled: "Habilitado",
            disabled: "Deshabilitado (el celular solo notifica cuando nadie está usando FaleCRM)",
          },
        },
        messageHistory: {
          label: "Historial de mensajes",
          helper: "Contacto: historial completo | Ticket: solo de la atención | Conexión: solo de la misma conexión",
          options: {
            contact: "Por contacto (todos los mensajes)",
            ticket: "Por ticket (aislado)",
            whatsapp: "Por Conexión (misma conexión)",
          },
        },
        ticketConnectionScope: {
          label: "Restringir atenciones a las conexiones del usuario",
          helper: "Cuando está habilitado, cada usuario (excepto admin) solo ve atenciones de las conexiones que controla (conexión predeterminada + conexiones asignadas en el registro del usuario). Sin conexión asignada, no ve ninguna atención. Deshabilitado: comportamiento actual (todos ven todo por cola).",
          options: {
            enabled: "Habilitado",
            disabled: "Deshabilitado",
          },
        },
        ticketCloseWithoutInteraction: {
          label: "Finalizar atención sin interacción",
          helper: "Controla qué ocurre cuando el agente finaliza una atención sin haber enviado ningún mensaje al contacto (los mensajes automáticos y de sistema no cuentan). En cualquier modo la atención entra en la métrica \"Finalizadas sin interacción\" del Dashboard.",
          options: {
            allowed: "Permitido",
            warn: "Avisar y pedir confirmación",
            blocked: "Bloquear",
          },
        },
        askCompletionMessageOnClose: {
          label: "Preguntar antes de enviar el mensaje de conclusión",
          helper: "Al finalizar una atención cuya conexión tiene un mensaje de conclusión configurado, pregunta al agente si debe enviarse. Los cierres automáticos (inactividad, chatbot, API) siempre lo envían.",
          options: {
            disabled: "Deshabilitado (siempre envía)",
            enabled: "Habilitado (pregunta al finalizar)",
          },
        },
        transferPendingTickets: {
          label: "Transferir tickets en espera",
          helper: "Muestra el botón Transferir en los tickets que aún no fueron aceptados. Sin usuario, el ticket sigue en espera en la nueva cola/conexión.",
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
          },
        },
        transferToOfflineUser: {
          label: "Transferir a usuario desconectado",
          helper: "Deshabilitado, el ticket solo puede transferirse a quien está conectado (también vale para la IA). Tomar el ticket para uno mismo sigue permitido.",
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
          },
        },
        clientImport: {
          label: "Importación de clientes",
          helper: "Cuando está habilitado, permite importar clientes desde una base de datos externa",
          options: {
            enabled: "Habilitado",
            disabled: "Deshabilitado",
          },
        },
        whatsappConnectionType: {
          label: "Tipo de conexión de WhatsApp",
          helper: "Define qué tipos de conexión puede usar la empresa",
          options: {
            both: "Ambos (Baileys + Cloud API)",
            baileys: "Solo Baileys (No oficial)",
            cloudapi: "Solo Cloud API (Meta oficial)",
          },
        },
        attendanceAlarmMinutes: {
          label: "Alarma de retraso en monitoreo (minutos)",
          helper: "Tiempo máximo sin respuesta antes de que el ticket entre en alarma. Predeterminado: 10 minutos.",
          errors: {
            invalid: "Ingresa un valor válido en minutos (mínimo 1).",
          },
        },
        outOfHoursMessageInterval: {
          label: "Intervalo del mensaje fuera de horario (minutos)",
          helper: "Envía el aviso una vez por conversación cada X minutos. 0 = en cada mensaje. Predeterminado: 60.",
          errors: {
            invalid: "Ingresa un valor en minutos entre 0 y 1440.",
          },
        },
        attendanceAlarmEnabled: {
          label: "Activar alarmas en monitoreo",
          helper: "Cuando está activado, los tickets sin respuesta entran en alarma visual después del tiempo configurado.",
          options: {
            enabled: "Habilitado",
            disabled: "Deshabilitado",
          },
        },
        attendanceAlarmResetEnabled: {
          label: "Permitir resetear alarma",
          helper: "Cuando está activado, agrega la opción 'Resetear Alarma' en el menú del ticket para dar OK a la alarma sin enviar mensaje al cliente.",
          options: {
            enabled: "Habilitado",
            disabled: "Deshabilitado",
          },
        },
        transcriptionApiKey: {
          label: "Clave OpenAI p/ transcripción de audios",
          helper: "Con la clave configurada, los audios recibidos se transcriben automáticamente (Whisper) y se muestran debajo del reproductor. Deje vacío para desactivar. Cada audio genera una llamada a la API de OpenAI.",
          showHide: "Mostrar/ocultar clave de la API",
        },
        aiTransferNotifyEnabled: {
          label: "Aviso de transferencia de la IA",
          helper: "Cuando la IA transfiera un ticket, envía por WhatsApp un aviso con el resumen de la conversación a los números configurados. En el agente de IA, active también \"Notificar Transferencia\".",
          options: {
            enabled: "Habilitado",
            disabled: "Deshabilitado",
          },
        },
        aiTransferNotifyConnectionId: {
          label: "Conexión que envía el aviso",
          helper: "Solo conexiones API No Oficial (Baileys). La conexión debe estar conectada.",
          none: "Ninguna",
        },
        aiTransferNotifyNumbers: {
          label: "Números que reciben el aviso",
          helper: "Código de país + área + número, ej.: 5542999999999. Varios números: separe con punto y coma.",
          errors: {
            invalid: "Número inválido. Use código de país + área + número, ej.: 5542999999999.",
          },
        },
        asaasToken: {
          label: "Token de Asaas",
        },
      },
    },
    requiredFields: {
      title: "Campos obligatorios de registro",
      description: "Define qué campos serán obligatorios en el registro de clientes y contactos (/contacts).",
      sections: {
        cliente: "Registro de Clientes",
        contacts: "Registro de Contactos (/contacts)",
      },
      buttons: {
        save: "Guardar configuración",
        saving: "Guardando...",
      },
      messages: {
        saved: "La configuración de campos obligatorios se guardó correctamente.",
        error: "Error al guardar la configuración de campos obligatorios.",
      },
      fields: {
        cliente: {
          NOMECLI: "Razón Social / Nombre",
          NOMEFANTASIA: "Nombre Fantasía",
          PESSOA: "Tipo de persona",
          STATUS: "Estado",
          USUARIO_RESPONSAVEL: "Usuario responsable",
          INSCESTCLI: "Inscripción estatal",
          insc_municipal: "Inscripción municipal",
          suframa: "SUFRAMA",
          contribuinte_icms: "Contribuyente ICMS",
          DDDCLI: "DDD (Teléfono)",
          E_MAIL: "Correo",
          FONECLI: "Teléfono",
          DDDCELULAR: "DDD (Celular)",
          CELULAR: "Celular",
          site: "Sitio web",
          CEPCLI: "CEP",
          ENDCLI: "Dirección",
          NUMERO: "Número",
          BAIRROCLI: "Barrio",
          CIDADECLI: "Ciudad",
          ESTADOCLI: "Estado",
          LIMITE: "Límite de crédito",
          metas_vendas: "Metas de ventas",
          potencial_vendas: "Potencial de ventas",
          acoes_vendas: "Acciones de ventas",
          OBS: "Observaciones",
          CGCCLI: "CNPJ",
          CPFCLI: "CPF",
        },
        contacts: {
          name: "Nombre",
          number: "Número",
          email: "Correo",
        },
      },
    },
    kanban: {
      title: "Configuración de Kanban",
      description: "Administra las reglas de creación de tarjetas, agendamiento y tiempo sin interacción.",
      loading: "Actualizando...",
      options: {
        enabled: "Habilitado",
        disabled: "Deshabilitado",
      },
      requireSchedule: {
        label: "Agendamiento obligatorio al crear tarjeta",
        helper: "Cuando está habilitado, las tarjetas solo se mueven entre columnas con agendamiento definido.",
      },
      creationMode: {
        label: "Creación de tarjetas al cerrar ticket",
        helper: "Define cómo se comporta el sistema al cerrar una atención.",
        options: {
          optional: "Opcional",
          mandatory: "Obligatorio",
          hidden: "Oculto",
        },
      },
      duplicateContact: {
        label: "Tarjeta duplicada del mismo contacto",
        helper: "Define qué ocurre cuando el contacto ya tiene tarjeta al crearla desde la atención.",
        options: {
          disabled: "Desactivado",
          warn: "Avisar",
          blocked: "Bloquear",
        },
      },
      duplicateContactScope: {
        label: "Dónde buscar la tarjeta del contacto",
        helper: "Define el alcance de la verificación de tarjeta duplicada.",
        options: {
          column: "Misma columna del tablero",
          board: "Cualquier columna del tablero",
          any: "Cualquier tablero",
        },
      },
      codcli: {
        label: "Enviar CODCLI en contratos de Kanban",
        helper: "Cuando está habilitado, envía el CODCLI del cliente vinculado para generar contratos.",
      },
      contactMethods: {
        title: "Medios de contacto en el relacionamiento",
        description: "Define qué medios de contacto estarán disponibles al registrar relacionamiento en Kanban.",
        helper: "Estas opciones aparecerán en los formularios de relacionamiento del Kanban.",
        placeholder: "Ej.: Prospección",
        addButton: "Agregar medio de contacto",
        removeButton: "Eliminar medio de contacto",
        options: {
          visit: "Visita",
          budget: "Presupuesto",
          followUp: "Follow-up",
          negotiation: "Negociación",
          afterSales: "Posventa",
          complaint: "Reclamo",
          referral: "Indicación",
        },
      },
      inactivity: {
        title: "Tiempo sin interacción de las tarjetas",
        description: "Define en cuántos días la tarjeta cambia de clase visual y el color de cada nivel.",
        rules: "Todos los tiempos se expresan en días. El color de Alerta se aplica al alcanzar el límite de Alerta, el color Crítico al alcanzar el límite Crítico y el color Urgente al alcanzar el límite Urgente.",
        enableLabel: "Resaltar tarjetas por inactividad",
        enableHelper: "Cuando está deshabilitado, las tarjetas no reciben destaque visual por tiempo sin interacción.",
        noPermission: "No tienes permiso para cambiar las reglas de tiempo sin interacción.",
        warningDays: "Alerta (días)",
        warningColor: "Alerta (color)",
        warningDaysHelper: "Ej.: 1",
        dangerDays: "Crítico (días)",
        dangerColor: "Crítico (color)",
        dangerDaysHelper: "Ej.: 3",
        criticalDays: "Urgente (días)",
        criticalColor: "Urgente (color)",
        criticalDaysHelper: "Ej.: 5",
      },
      messages: {
        scheduleSaved: "La configuración de agendamiento se actualizó correctamente.",
        creationModeSaved: "El modo de creación de tarjetas se actualizó correctamente.",
        duplicateContactSaved: "La verificación de tarjeta duplicada se actualizó correctamente.",
        codcliSaved: "La configuración de CODCLI se actualizó correctamente.",
        contactMethodsSaved: "Los medios de contacto del relacionamiento se actualizaron correctamente.",
        inactivitySaved: "La configuración de tiempo sin interacción se actualizó correctamente.",
      },
      errors: {
        update: "Error al actualizar la configuración.",
        contactMethodsEmpty: "Selecciona al menos un medio de contacto.",
        invalidDays: "Ingresa un valor de días válido (0 o mayor).",
        invalidDaysOrder: "El orden de días debe ser: Alerta <= Crítico <= Urgente.",
        invalidColor: "Ingresa un color hexadecimal válido (p. ej., #ff0000).",
      },
    },
    settings: {
					clientImport: {
						name: "Importación de clientes",
						note: "Habilita o deshabilita la importación de clientes desde la base de datos externa. Cuando está deshabilitado, el botón 'Importar clientes' queda oculto.",
						options: {
							enabled: "Activado",
							disabled: "Desactivado",
						},
					},
					webhookKommoSendCodcli: {
						name: "Enviar CODCLI en contratos del Kanban",
						note: "Cuando está habilitado, al mover una tarjeta a la columna de generación de contratos, el sistema envía el CODCLI del cliente vinculado a la tarjeta. Si está deshabilitado o no hay cliente, usa el CODCLI predeterminado (1).",
						options: {
							enabled: "Activado",
							disabled: "Desactivado",
						},
					},
      userCreation: {
        name: "Creación de usuario",
        options: {
          enabled: "Habilitado",
          disabled: "Deshabilitado",
        },
      },
      unifyTicketsByContact: {
        name: "Unificar conversaciones por contacto",
        note: "Cuando está habilitado, todas las conversaciones de un contacto se unifican independientemente del número. Cuando está deshabilitado, cada número de WhatsApp tendrá una conversación separada.",
        options: {
          enabled: "Habilitado",
          disabled: "Deshabilitado",
        },
      },
      groupTicketUnify: {
        name: "Ticket de grupo con varias conexiones",
        note: "Uno por grupo: un único ticket por grupo, en cualquier conexión. Uno por conexión: cada conexión tiene su propio ticket del grupo y todos muestran la conversación completa.",
        options: {
          enabled: "Uno por grupo (cualquier conexión)",
          disabled: "Uno por conexión",
        },
      },
    },
    email: {
      title: "Configuración de correo electrónico (SMTP)",
      description: "Configure los datos del servidor SMTP para el envío de correos electrónicos desde el sistema",
      fields: {
        host: "Servidor SMTP",
        hostPlaceholder: "smtp.ejemplo.com",
        port: "Puerto",
        user: "Usuario SMTP",
        userPlaceholder: "usuario@ejemplo.com",
        password: "Contraseña SMTP",
        from: "Correo del remitente",
        fromPlaceholder: "noreply@empresa.com",
        fromName: "Nombre del remitente",
        fromNamePlaceholder: "Sistema CRM",
        secure: "Usar SSL/TLS (recomendado para el puerto 465)",
        active: "Configuración activa",
      },
      buttons: {
        update: "Actualizar",
        test: "Probar correo",
      },
      testDialog: {
        title: "Enviar correo de prueba",
        description: "Ingrese una dirección de correo válida para recibir el correo de prueba:",
        email: "Correo de prueba",
        emailPlaceholder: "prueba@ejemplo.com",
        send: "Enviar",
      },
      toasts: {
        requiredFields: "Por favor, complete todos los campos obligatorios",
        updated: "¡Configuración de correo actualizada con éxito!",
        saved: "¡Configuración de correo guardada con éxito!",
        saveError: "Error al guardar la configuración de correo",
        fillBeforeTest: "Por favor, complete la configuración antes de probar",
        invalidEmail: "Por favor, ingrese una dirección de correo válida",
        testError: "Error al enviar el correo de prueba",
      },
    },
    instagram: {
      title: "Configuración de Instagram (Instagram Login)",
      info: {
        beforeProduct: "Credenciales del producto",
        afterProduct: "de su app en Meta. Se usan en el inicio de sesión simplificado (OAuth) y en la verificación de la firma de los webhooks. Obtenga el App ID y el App Secret de Instagram en",
        path: "> su app > Instagram > Configuración de la API.",
      },
      managedByServer: {
        title: "La aplicación de Meta ya está configurada en este servidor.",
        description: "Las credenciales de abajo se ignoran: el inicio de sesión simplificado usa las variables del servidor (IG_APP_ID, IG_APP_SECRET, IG_REDIRECT_URI). Los campos siguen disponibles solo para instalaciones que aún no migraron.",
      },
      fields: {
        appIdHelper: "ID de la app de Instagram (producto Instagram de la app de Meta)",
        appIdPlaceholder: "Ej.: 123456789012345",
        appSecretHelper: "Se usa en OAuth y en la verificación HMAC del webhook",
        verifyTokenHelper: "Token definido por usted para verificar el webhook en el panel de Meta",
        graphVersion: "Versión de la Graph API",
        latest: "Más reciente",
        redirectUriHelper: "Debe ser idéntica a la URI registrada en la app de Meta (Instagram > Configuración de la API > Business Login)",
      },
      webhookUrl: "URL del Webhook (configúrela en el panel de Meta, producto Instagram > Webhooks, campos messages y comments):",
      suggestedRedirectUri: "Redirect URI OAuth sugerida:",
      save: "Guardar configuración",
      toasts: {
        loadError: "Error al cargar la configuración de Instagram",
        saved: "¡Configuración de Instagram guardada con éxito!",
        saveError: "Error al guardar la configuración de Instagram",
      },
    },
    instagramWebhooks: {
      title: "Monitor de Webhooks de Instagram",
      description: "Siga en tiempo real los webhooks que Meta envía a este sistema. Use el botón \"Probar\" en el panel de Meta (o \"Simular\" abajo) y vea aquí si el evento llegó, en qué formato, si la firma es válida y si el backend reconoce el campo para procesarlo.",
      status: {
        processed: "Procesado",
        received: "Recibido",
        ignored: "Ignorado",
        error: "Error",
      },
      simulated: "simulado",
      recognized: "Reconocido",
      recognizedTooltip: "Hay procesamiento dedicado en el backend",
      unhandled: "Sin handler",
      unhandledTooltip: "El webhook llega, pero aún sin procesamiento dedicado",
      signatureInvalid: "inválida",
      signatureInvalidTooltip: "Firma HMAC inválida",
      signatureValidTooltip: "Firma HMAC verificada",
      payload: "Payload recibido",
      legend: {
        recognized: "reconocido (procesado por el backend)",
        unhandled: "sin handler dedicado (llega, pero aún no se procesa)",
      },
      simulateAll: "Simular todos los campos",
      table: {
        receivedAt: "Recibido el",
        field: "Campo",
        signature: "Firma",
        connection: "Conexión",
        detail: "Detalle",
      },
      empty: "Aún no se recibió ningún webhook. Haga clic en \"Simular\" o dispare una prueba en el panel de Meta.",
      toasts: {
        loadError: "No se pudieron cargar los eventos de webhook.",
        cleared: "Eventos borrados.",
        clearError: "Error al borrar los eventos.",
        simulated: "Eventos simulados generados (uno por campo).",
        simulateError: "Error al simular eventos.",
      },
    },
    onSpace: {
      title: "Integración OnSpace",
      description: "Cada vez que un contacto envíe un mensaje por WhatsApp, ChatCRM notificará automáticamente a OnSpace para registrar el lead en la Conferencia de Citas.",
      fields: {
        url: "URL de OnSpace",
        urlPlaceholder: "https://mionspace.com",
        urlHelper: "URL base del sistema OnSpace (sin barra al final)",
        salaoId: "ID del salón",
        salaoIdPlaceholder: "Ej.: 123",
        salaoIdHelper: "ID del salón/clínica en OnSpace (obligatorio)",
        apiKey: "API Key de OnSpace",
        apiKeyPlaceholder: "Déjelo en blanco si no utiliza autenticación",
        apiKeyHelper: "Enviada en el header x-api-key (opcional)",
      },
      toasts: {
        salaoIdInvalid: "El ID del salón es obligatorio y debe ser un número entero.",
        saved: "¡Configuración de OnSpace guardada con éxito!",
        saveError: "Error al guardar la configuración de OnSpace.",
      },
    },
    schedulesUpdated: "Horarios actualizados con éxito.",
    systemAlerts: {
      title: "Alertas del sistema por WhatsApp",
      description: "Avisa por WhatsApp cuando el sistema detecta congestión en el acceso a la base de datos, la señal que antecede a los bloqueos de atención. Esta configuración vale para toda la instalación: la alerta cubre todas las empresas y la conexión elegida puede ser de cualquiera de ellas. El aviso se envía como máximo una vez cada 15 minutos, y un segundo mensaje confirma cuando todo se normaliza.",
      enabled: "Enviar alertas por WhatsApp",
      connection: "Conexión de envío",
      noConnection: "Ninguna",
      connectionHint: "Cualquier conexión del sistema, de cualquier empresa. Prefiera una que no sea la principal de atención.",
      numbers: "Números de destino",
      numbersHint: "Separe con punto y coma, con código de país y de área.",
      validNumbers: "{{count}} número válido.",
      validNumbers_plural: "{{count}} números válidos.",
      invalidEntries: "{{count}} entrada se ignorará porque no parece un número.",
      invalidEntries_plural: "{{count}} entradas se ignorarán porque no parecen un número.",
      sendTest: "Enviar alerta de prueba",
      testHint: "La prueba ignora el intervalo mínimo y usa la configuración ya guardada: guarde antes de probar.",
      toasts: {
        loadError: "No se pudo cargar la configuración de alertas.",
        saved: "Configuración de alertas guardada.",
        saveError: "No se pudo guardar la configuración de alertas.",
        testSent: "Alerta de prueba enviada a {{count}} número.",
        testSent_plural: "Alerta de prueba enviada a {{count}} números.",
        testNotSent: "No se pudo enviar: {{reason}}.",
        unknownError: "error desconocido",
        testError: "Error al disparar la alerta de prueba.",
      },
    },
    cloudApi: {
      title: "Configuración global de Meta Cloud API",
      info: "Esta configuración es global y se comparte entre todas las conexiones Cloud API. El App Secret y el Verify Token se definen en el panel de apps de Meta y son únicos por aplicación.",
      managedByServer: "Las credenciales de abajo se ignoran: el inicio de sesión simplificado usa las variables del servidor (META_APP_ID, META_APP_SECRET, META_CONFIG_ID). Los campos siguen disponibles solo para instalaciones que aún no migraron.",
      embeddedSignup: {
        title: "Embedded Signup (conexión con 1 clic)",
        description: "Configura el Facebook App ID y el Config ID para que los usuarios conecten WhatsApp Business con un solo clic, sin tener que ingresar manualmente el WABA ID, el Phone Number ID y el Token. Obtén estos valores en",
      },
      globalSection: "Configuración global",
      fields: {
        appIdHelper: "ID de la app de Meta (menú Configuración > Básica en el panel de apps)",
        configIdHelper: "ID de la configuración de WhatsApp Embedded Signup (WhatsApp > Configuración de la API > Embedded Signup)",
        appSecretHelper: "Secret de la app de Meta (menú Configuración > Básica en el panel de apps)",
        apiVersion: "Versión de la API",
      },
      webhookUrl: "URL del Webhook (configúrala en el panel de apps de Meta):",
      toasts: {
        loadError: "Error al cargar la configuración de Cloud API",
        saved: "¡Configuración de Cloud API guardada con éxito!",
        saveError: "Error al guardar la configuración de Cloud API",
      },
    },
  },
  messagesList: {
				queueFailed: {
					message: "Mensaje no enviado: \"{{preview}}\". {{reason}}",
					genericReason: "Intenta enviarlo de nuevo.",
				},
				system: {
					ratedHidden: "El cliente evaluó la atención el {{date}} (Ticket #{{ticket}})",
					rated: "El cliente evaluó la atención con nota {{rate}} de {{max}} el {{date}} (Ticket #{{ticket}})",
					closedBy: "Atención finalizada por {{user}} el {{date}} (Ticket #{{ticket}})",
					takenBy: "Ticket asumido por ({{user}}) - {{date}}",
					transferredBy: "Ticket transferido por ({{user}}) - De {{from}} a {{to}} - {{date}}",
					transferredFromTo: "Ticket transferido de {{from}} a {{to}} - {{date}}",
					transferredToPendingQueue: "Ticket transferido por ({{user}}) - De {{from}} a Pendiente en la cola {{queue}} - {{date}}",
					transferredToPendingNoQueue: "Ticket transferido por ({{user}}) - De {{from}} a Pendiente sin cola - {{date}}",
					started: "Inicio del ticket - {{queue}} ({{user}}) - {{date}}",
					systemUser: "Sistema",
					adminQueue: "ADMINISTRATIVO",
					queueFallback: "Cola",
				},
				chips: {
					unknownDate: "fecha desconocida",
					ticketMissing: "Ticket #{{ticket}} (no encontrado) — mensajes a partir de {{date}}",
					openedExternal: "Ticket abierto por mensaje enviado externamente el {{date}} (Ticket #{{ticket}})",
					openedByAgent: "Atención iniciada por {{user}} el {{date}} (Ticket #{{ticket}})",
					openedByCustomer: "Ticket abierto por mensaje del cliente el {{date}} (Ticket #{{ticket}})",
					openedByImport: "Historial importado del celular desde el {{date}} (Ticket #{{ticket}})",
				},
    header: {
      assignedTo: "Asignado a:",
      buttons: {
        return: "Volver",
        resolve: "Resolver",
        reopen: "Reabrir",
        accept: "Aceptar",
      },
    },
    emptyChat: "¡Saluda a tu nuevo contacto!",
    transcription: {
      label: "Transcripción:",
      processing: "Transcribiendo audio…",
      retry: "Intentar de nuevo",
    },
    media: {
      downloading: "Descargando archivo…",
      downloadingShort: "Descargando…",
      failed: "No se pudo descargar este archivo.",
      retry: "Intentar de nuevo",
      unavailable: "Archivo no disponible",
      download: "Descargar",
    },
    mediaViewer: {
      open: "Abrir en el visor",
      goToMessage: "Ir al mensaje",
      zoomIn: "Ampliar",
      zoomOut: "Reducir",
    },
    jumpNotFound: "El mensaje seleccionado no se encontró en el historial de este ticket.",
    jumpTooOld: "El mensaje es demasiado antiguo para el salto directo. Desplaza el historial para llegar a él.",
    jumpToQuoted: "Ir al mensaje citado",
    documentCard: {
      label: "Documento",
      open: "Abrir",
      download: "Descargar",
    },
    interactive: {
      viewOptions: "Ver opciones",
      poll: "Encuesta",
      pollSelectOne: "Selecciona una opción",
      pollSelectMany: "Selecciona una o más opciones",
    },
    catalog: {
      productTitle: "Producto",
      productsTitle: "Productos",
      orderTitle: "Pedido",
      orderTotal: "Total",
      orderLoading: "Cargando artículos del pedido…",
      orderFailed: "No fue posible cargar los artículos de este pedido.",
      sku: "SKU",
      unnamedProduct: "Producto sin nombre",
    },
    forwardSelection: {
      selectedSingle: "{{count}} mensaje seleccionado",
      selectedMultiple: "{{count}} mensajes seleccionados",
      forwardMessages: "Reenviar mensajes",
      cancelSelection: "Cancelar selección",
    },
    forwarded: {
      label: "Reenviado",
      frequently: "Reenviado muchas veces",
    },
    instagram: {
      postTooltip: "Publicación: {{caption}}",
      openCommentedPost: "Abrir la publicación comentada",
      commentedPostAlt: "Publicación comentada",
      comment: "Comentario",
      publicReply: "Respuesta pública",
      viewPost: "ver publicación",
      reply: "Responder",
      replyPublic: "Responder en la publicación (público)",
      replyDm: "Responder por DM",
      dm: {
        storyMention: "Te mencionó en su historia",
        storyReply: "Respondió a tu historia",
        reel: "Reel",
        post: "Publicación",
        shared: "Contenido compartido",
        watchHere: "Ver aquí",
        closePlayer: "Cerrar reproductor",
        openInInstagram: "Abrir en Instagram",
        downloadMedia: "Descargar archivo",
        storyExpired: "El archivo de la historia no se descargó a tiempo; las historias caducan en 24h.",
        reelPlayerTitle: "Reel de Instagram",
      },
    },
    contactFallback: "Contacto",
    you: "Tú",
    mention: {
      noNumber: "No fue posible iniciar una conversación directa: el participante no tiene un número disponible.",
      dialogTitle: "Participante mencionado",
      dialogText: "Usted mencionó a este participante en el grupo.",
      name: "Nombre:",
      number: "Número:",
      notAvailable: "No disponible",
      chatPrivately: "Conversar en privado",
    },
    sharedContact: {
      unnamed: "Contacto sin nombre",
      startMissingNumber: "No fue posible iniciar la conversación: no se encontró un número en el contacto compartido.",
      startSaveFailed: "No fue posible iniciar la conversación: error al guardar el contacto compartido.",
      alreadyExists: "El contacto ya existe en la base de datos.",
      saved: "¡Contacto guardado con éxito!",
      saveMissingNumber: "No fue posible guardar: no se encontró un número en el contacto compartido.",
      saveFailed: "No fue posible guardar el contacto compartido.",
      shared: "Contacto compartido",
      quotedWithNumber: "Contacto: {{name}} - {{number}}",
      quotedName: "Contacto: {{name}}",
      quotedMultiple: "Contactos compartidos: {{count}}",
      summaryOthers: "{{name}} y {{count}} contacto más",
      summaryOthers_plural: "{{name}} y {{count}} contactos más",
      count: "{{count}} contacto",
      count_plural: "{{count}} contactos",
      viewAll: "Ver todos",
      chat: "Conversar",
    },
    delivery: {
      failedWithCode: "Error en el envío: {{error}} (código Meta: {{code}})",
      failedWithError: "Error en el envío: {{error}}",
      failed: "Error al enviar el mensaje",
    },
    pendingAck: {
      timeoutHandled: "Timeout de callback ya tratado con reenvío manual de plantilla.",
      timeoutHandledShort: "Timeout ya tratado con reenvío.",
      timeoutMinutes: "Sin confirmación de estado de Meta desde hace más de {{minutes}} minutos. {{reason}}",
      timeoutLong: "Sin confirmación de estado de Meta durante mucho tiempo. {{reason}}",
      defaultReason: "El mensaje fue aceptado en el envío inicial, pero no recibimos el callback de sent/delivered/read/failed.",
      awaitingMeta: "Mensaje enviado a Meta y en espera de confirmación de estado (sent/delivered/read). Esto puede ocurrir por un retraso en el callback del webhook.",
      processing: "Mensaje en procesamiento. Aún no recibimos confirmación de estado.",
    },
    reactions: {
      allTab: "Todas {{total}}",
      empty: "Ninguna reacción en esta categoría.",
      clickToRemove: "Haga clic para quitar",
      react: "Reaccionar",
      search: "Buscar reacción",
      notFound: "No se encontró ningún emoji",
      categories: {
        search: "Resultados",
        recent: "Reacciones recientes",
        people: "Caritas y personas",
        nature: "Animales y naturaleza",
        foods: "Comidas y bebidas",
        activity: "Actividades",
        places: "Viajes y lugares",
        objects: "Objetos",
        symbols: "Símbolos",
        flags: "Banderas",
        custom: "Personalizados",
      },
    },
    connectionBadge: {
      withDetails: "Conexión: {{details}}",
      withId: "Conexión #{{id}}",
    },
    historyLoaded: "HISTORIAL - Todas las conversaciones anteriores fueron cargadas",
    deleted: {
      byAgent: "Este mensaje fue eliminado por el agente",
      byContact: "Este mensaje fue eliminado por el contacto",
      hide: "Ocultar mensaje",
      show: "Ver mensaje",
    },
    quoted: {
      statusAuthor: "{{author}} • Estado",
    },
    callLog: {
      call: "Llamada",
      started: "Iniciada",
      video: "Videollamada",
      voice: "Llamada de voz",
      fallback: "{{call}} {{status}} el {{date}}",
    },
    edited: {
      label: "Editado",
      original: "Original: {{body}}",
    },
    openTicketFailed: "No fue posible abrir la conversación. No se encontraron los datos del ticket.",
    existingTicket: {
      title: "Conversación ya existente",
      text: "Ya existe una conversación abierta con este contacto. ¿Desea abrir la conversación existente?",
      agent: "Agente:",
      queue: "Cola:",
      open: "Abrir conversación",
    },
    goToBottom: "Ir al final de la conversación",
  },
  forwardMessageModal: {
				windowClosed: "La ventana de 24 h de {{name}} está cerrada. Abra el ticket con ese contacto y envíe una plantilla para reabrirla antes de reenviar.",
    title: "Reenviar mensajes",
    selectedCount: "Mensajes seleccionados: {{count}}",
    previewPrefix: "Vista previa",
    previewContactWithNumber: "Contacto: {{name}} - {{number}}",
    previewContactWithName: "Contacto: {{name}}",
    previewContactWithNumberOnly: "Contacto: {{number}}",
    previewSharedContact: "Contacto compartido",
    previewSharedLocation: "Ubicación compartida",
    previewMedia: "Medio ({{mediaType}})",
    previewFile: "archivo",
    searchContactLabel: "Buscar contacto (nombre o número)",
    loadMoreContacts: "Cargar más contactos",
    forwarding: "Reenviando...",
    forward: "Reenviar",
    cancel: "Cancelar",
    successSingle: "Mensaje reenviado a {{name}}",
    successMultiple: "{{count}} mensajes reenviados a {{name}}",
    stoppedOnError: "El reenvío se detuvo por un error en uno de los mensajes.",
  },
  messagesInput: {
				recordingPaused: "En pausa",
    placeholderOpen: "Escribe un mensaje",
    placeholderClosed:
      "Reabra o acepte este ticket para enviar un mensaje.",
    placeholderReopen: "Escribe para reabrir y enviar mensaje...",
    signMessage: "Firmar",
    tooltips: {
					pauseRecording: "Pausar grabación",
					resumeRecording: "Continuar grabación",
      emojiPicker: "Emoji",
      moreActions: "Más acciones",
      attachFile: "Adjuntar archivo",
      sendContact: "Enviar contacto",
      quickMessages: "Respuestas rápidas",
      stickers: "Stickers",
      sendTemplate: "Enviar plantilla",
      signMessage: "Firmar mensajes",
      sendMessage: "Enviar mensaje",
      voiceMessage: "Mensaje de voz",
    },
    failedAudio: {
      title: "Audio no enviado",
      resend: "Reenviar audio",
      discard: "Descartar audio",
    },
    errors: {
      ticketIdNotFound: "ID del ticket no encontrado",
      noQueueAccess: "No tiene acceso a la cola de este ticket",
      otherOpenTicketSentHere: "Este contacto ya tiene otra atención en curso. El mensaje se envió en este ticket, que permanece como está.",
      noQueueAccessNewTicket: "No tiene acceso a la cola de este ticket. El mensaje se envió en un ticket nuevo suyo.",
    },
    replyPreview: {
      contactWithNumber: "Contacto: {{name}} - {{number}}",
      contact: "Contacto: {{value}}",
      sharedContact: "Contacto compartido",
    },
    attachedFile: "Archivo adjunto",
    mentionFallbackName: "Contacto",
    connection: {
      selectedTooltip: "Conexión: {{name}}",
      selectedFallback: "Seleccionada",
      select: "Seleccionar conexión",
    },
    cloudApi: {
      windowExpiredPlaceholder: "Ventana de 24h expirada — envíe una plantilla con el botón naranja al lado",
      windowExpiredInline: "Ventana de 24h expirada. Use el botón de plantilla para enviar un mensaje.",
      windowExpiredTitle: "Ventana de 24 horas expirada",
      windowExpiredText: "La ventana de 24 horas expiró. Envíe una plantilla de mensaje para iniciar una nueva conversación.",
      noTemplates: "No se encontró ninguna plantilla de mensaje aprobada. Cree y envíe plantillas para aprobación en la página de Plantillas.",
      selectTemplate: "Seleccione una plantilla",
      preview: "Vista previa:",
      emptyBody: "(Sin texto en el cuerpo)",
      variables: "Variables:",
      variableLabel: "Variable {{name}}",
      templateSent: "¡Plantilla enviada con éxito!",
      sending: "Enviando...",
      send: "Enviar",
    },
    stickers: {
      removed: "Sticker eliminado de la biblioteca.",
      openTicketToPull: "Abra un ticket para traer stickers de la conversación.",
      pulled: "Stickers traídos de WhatsApp: {{count}}.",
      pullFromWhatsApp: "Traer de WhatsApp",
      empty: "No se encontraron stickers en la conversación de WhatsApp de este ticket.",
      favorites: "Favoritos",
      library: "Biblioteca",
      removeFromLibrary: "Quitar de la biblioteca",
      removeTitle: "Eliminar sticker",
      removeConfirm: "Este sticker se eliminará de la biblioteca para todos los usuarios de la empresa.",
    },
    media: {
      dropHere: "Suelte el archivo aquí para enviarlo",
      filesSelected: "{{count}} archivo seleccionado",
      filesSelected_plural: "{{count}} archivos seleccionados",
      captionPlaceholder: "Escriba un pie de foto (opcional)...",
    },
    instagram: {
      replyingPublic: "Respondiendo en la publicación (público)",
      replyingDm: "Respondiendo por DM",
    },
  },
  messageSearchDrawer: {
    title: "Buscar mensajes",
    placeholder: "Buscar",
    prompt: "Buscar mensajes en esta conversación.",
    noResults: "No se encontraron mensajes.",
    previousTicket: "Ticket anterior",
    loadMore: "Cargar más",
    you: "Tú",
    contact: "Contacto",
  },
  contactDrawer: {
				shared: {
					mediaTab: "Multimedia",
					docsTab: "Documentos",
					linksTab: "Enlaces",
					loadMore: "Cargar más",
					loading: "Cargando...",
					previewAlt: "Vista previa",
					image: "Imagen",
					video: "Video",
					document: "Documento",
					link: "Enlace",
					empty: {
						media: "No hay multimedia compartida en este chat.",
						docs: "No hay documentos compartidos en este chat.",
						links: "No hay enlaces compartidos en este chat.",
					},
				},
    header: "Datos del contacto",
    headerGroup: "Datos del grupo",
    buttons: {
      edit: "Editar contacto",
      merge: "Unificar contacto",
    },
    favorites: {
      title: "Mensajes favoritos",
      none: "Ninguno",
      noMessages: "No hay mensajes favoritos para este contacto.",
      loadMore: "Cargar más",
      loading: "Cargando...",
      previewAlt: "Vista previa del medio",
      ticketLabel: "Ticket",
      senderYou: "Tú",
      senderContact: "Contacto",
      messageDeleted: "Mensaje eliminado",
      image: "Imagen",
      media: "Medio",
      messageWithoutContent: "Mensaje sin contenido",
      ticketNotFound: "No se pudo ubicar el ticket de este mensaje.",
      messageFromAnotherTicket: "Este mensaje pertenece a otro ticket. Abre ese ticket para navegar hasta él."
    },
    extraInfo: "Información adicional",
    toasts: {
      merged: "Contacto unificado con éxito. La actualización se aplicará automáticamente.",
    },
    members: {
      title: "Miembros del grupo",
      count: "{{count}} miembro",
      count_plural: "{{count}} miembros",
      groupLabel: "Grupo",
      updated: "Actualizado {{when}}",
      syncTooltip: "Actualizar miembros manualmente",
      syncing: "Actualizando miembros...",
      synced: "¡Miembros del grupo actualizados!",
      loadError: "No fue posible cargar los miembros. Verifique que WhatsApp esté conectado e intente sincronizar nuevamente.",
      admin: "Admin",
      startConversation: "Iniciar conversación",
      participantNotLinked: "Este participante no está vinculado a un contacto registrado.",
      alreadyAttended: "Este contacto ya está siendo atendido por {{name}}.",
      anotherAttendant: "otro agente",
      lastSync: {
        now: "ahora",
        minutes: "hace {{count}} min",
        hours: "hace {{count}} h",
      },
    },
  },
  mergeContactModal: {
    title: "Unificar Contactos",
    currentContact: "Contacto actual:",
    searchPlaceholder: "Buscar contacto por nombre o número...",
    noContactsFound: "No se encontraron contactos",
    searchHint: "Escriba al menos 2 caracteres para buscar",
    warning: "¡Esta acción no se puede deshacer!",
    mergeInfoTitle: "Lo que se unificará:",
    mergeInfo1: "Todos los tickets se moverán al contacto principal",
    mergeInfo2: "Todos los mensajes serán migrados",
    mergeInfo3: "El contacto duplicado será eliminado",
    success: "¡Contactos unificados exitosamente!",
    buttons: {
      cancel: "Cancelar",
      merge: "Unificar",
      merging: "Unificando...",
    },
    selectContact: "Selecciona un contacto para unificar",
  },
  fileModal: {
    title: {
      add: "Agregar lista de archivos",
      edit: "Editar lista de archivos",
    },
    buttons: {
      okAdd: "Guardar",
      okEdit: "Editar",
      cancel: "Cancelar",
      fileOptions: "Agregar archivo",
    },
    form: {
      name: "Nombre de la lista de archivos",
      message: "Detalles de la lista",
      fileOptions: "Lista de archivos",
      extraName: "Mensaje para enviar con archivo",
      extraValue: "Valor de la opción",
    },
    success: "Lista de archivos guardada correctamente!",
    validation: {
      nameTooShort: "Nombre demasiado corto",
    },
  },
    ticketActionButtons: {
      mandatoryKanbanCard: "La tarjeta de Kanban es obligatoria",
      mandatoryKanbanCardMessage: "Debes crear una tarjeta de Kanban antes de cerrar este ticket.",
      optionalKanbanCard: "¿Crear una tarjeta de Kanban?",
      optionalKanbanCardMessage: "¿Te gustaría crear una tarjeta de Kanban para este ticket?",
      confirmKanbanCard: "¿Crear una tarjeta de Kanban antes de cerrar?",
      createCard: "Crear Tarjeta",
      skip: "Saltar",
      withoutInteractionTitle: "¿Finalizar sin interacción?",
      withoutInteractionMessage:
        "No has enviado ningún mensaje al contacto en esta atención. ¿Deseas finalizarla de todos modos? La atención se contabilizará como finalizada sin interacción.",
      completionMessageTitle: "¿Enviar mensaje de conclusión?",
      completionMessageText: "La conexión de esta atención está configurada para enviar el siguiente mensaje al contacto cuando se finaliza la atención:",
      completionMessageBatchHint: "La respuesta vale para todas las atenciones seleccionadas.",
      completionMessageSend: "Enviar",
      completionMessageSkip: "No enviar",
      tooltips: {
        searchMessages: "Buscar mensajes",
        createKanbanCard: "Crear tarjeta en el Kanban",
        call: "Llamar por WhatsApp",
        inCall: "En llamada con este contacto",
      },
    },
  calls: {
    status: {
      dialing: "Iniciando llamada…",
      ringing: "Llamando…",
      answering: "Conectando…",
      incoming: "Llamada entrante",
      connected: "En llamada · {{time}}",
      endedReasons: {
        ended: "Llamada finalizada",
        rejected: "Llamada rechazada",
        missed: "No contestada",
        mediaFailed: "Falló la conexión de audio",
      },
    },
    actions: {
      answer: "Contestar",
      ignore: "Ignorar",
      hangUp: "Colgar",
      mute: "Silenciar micrófono",
      unmute: "Activar micrófono",
      openTicket: "Abrir ticket",
      close: "Cerrar",
    },
    permission: {
      title: "Llamar por WhatsApp",
      noPermission: "{{name}} aún no autorizó recibir llamadas de este número. Envía una solicitud de permiso: el cliente recibe un botón en WhatsApp para aceptar (vale 7 días).",
      waitingReply: "Solicitud enviada. En cuanto el cliente acepte, el botón de llamar se habilita aquí.",
      windowClosed: "La ventana de 24 horas está cerrada, así que la solicitud no puede enviarse ahora. Espera a que el cliente escriba o envía una plantilla de permiso de llamada desde el selector de plantillas.",
      requestLimit: "Se alcanzó el límite de solicitudes de permiso para este contacto (1 por día, 2 por semana). Se libera el {{date}}.",
      callLimit: "Se alcanzó el límite de llamadas para este contacto. Se libera el {{date}}.",
      granted: "{{name}} autorizó recibir llamadas.",
      callingDisabled: "Las llamadas no están habilitadas en esta conexión. Un administrador puede habilitarlas en Conexiones → editar la conexión → Llamadas.",
      lookupFailed: "No fue posible consultar ahora el permiso de llamada de este contacto.",
      staleCall: "Tienes una llamada anterior que todavía figura en curso. Finalízala para poder llamar.",
      request: "Pedir permiso",
      requestAgain: "Pedir de nuevo",
      requested: "Solicitud de permiso enviada al contacto.",
      callNow: "Llamar ahora",
      callAnyway: "Intentar llamar",
      endStaleCall: "Finalizar llamada anterior",
    },
    errors: {
      alreadyInCall: "Ya estás en una llamada.",
      microphone: "No fue posible usar el micrófono. Permite el acceso al micrófono en el navegador e inténtalo de nuevo.",
      insecureContext: "El navegador solo permite el micrófono en páginas HTTPS. Accede al sistema por la dirección con https.",
    },
    warnings: {
      otherOpenTicketCalledHere: "Este contacto ya tiene otra atención en curso. La llamada se hará en este ticket, que sigue como está.",
      noQueueAccessNewTicket: "No tienes acceso a la cola de este ticket. La llamada se hará en un ticket nuevo tuyo.",
    },
    settings: {
      title: "Llamadas (WhatsApp Calling)",
      help: "Permite hacer y contestar llamadas de voz en el navegador. Requiere un número con límite de al menos 2.000 conversaciones por día y el campo de webhook “calls” suscrito en la app de Meta. Las llamadas hechas por la empresa las cobra Meta por minuto. Las llamadas entrantes siguen la configuración “Aceptar Llamada”.",
      status: "Llamadas en este número",
      enabled: "Habilitadas",
      disabled: "Deshabilitadas",
      iconVisibility: "Icono de llamada para el cliente",
      iconDefault: "Visible",
      iconHidden: "Oculto",
      callbackPermission: "Quien llama a la empresa ya autoriza la devolución",
      save: "Guardar llamadas",
      saved: "Configuración de llamadas guardada.",
      loadError: "No fue posible leer la configuración de llamadas de este número.",
    },
  },
  linkClienteModal: {
    title: "Vincular contacto a cliente",
    contact: "Contacto",
    searchLabel: "Buscar cliente",
    searchHelper: "Busque por nombre de fantasía, razón social o CNPJ",
    newCliente: "Crear nuevo cliente",
    success: "¡Contacto vinculado al cliente con éxito!",
    alreadyLinked: "Este contacto ya está vinculado a este cliente.",
    buttons: {
      cancel: "Cancelar",
      link: "Vincular",
    },
  },
  ticketOptionsMenu: {
    schedule: "Programación",
    delete: "Eliminar",
    transfer: "Transferir",
    linkCliente: "Vincular a cliente",
    agents: "Agentes",
    registerAppointment: "Observaciones del Contacto",
    appointmentsModal: {
      title: "Observaciones del Contacto",
      textarea: "Observación",
      placeholder: "Inserta aquí la información que deseas registrar",
    },
    confirmationModal: {
      title: "Eliminar el ticket",
	  titleFrom: "del contacto ",
      message:
        "¡Atención! Todos los mensajes relacionados con el ticket se perderán.",
    },
    buttons: {
      delete: "Eliminar",
      cancel: "Cancelar",
    },
  },
  ticketAIAgentModal: {
    title: "Agentes",
    searchLabel: "Seleccionar agente de IA",
    searchPlaceholder: "Buscar por nombre del agente",
    noOptions: "No se encontraron agentes",
    none: "Ninguno",
    currentAgent: "Agente actual: {{agent}}",
    clearHumanAttendant: "Quitar al atendente humano actual de esta conversación",
    buttons: {
      cancel: "Cancelar",
      remove: "Quitar agente",
      save: "Guardar",
    },
    success: {
      assigned: "Agente de IA asignado con éxito.",
      removed: "Agente de IA quitado con éxito.",
    },
    errors: {
      invalidTicket: "Ticket inválido para asignar agente.",
      selectAgent: "Seleccione un agente para continuar.",
    },
    warnings: {
      humanAttendantLinked: "Atención: mientras haya un agente humano vinculado, la IA no responde a los mensajes.",
    },
  },
  confirmationModal: {
    buttons: {
      confirm: "Ok",
      cancel: "Cancelar",
    },
  },
  messageOptionsMenu: {
				edit: "Editar",
				details: "Detalles del mensaje",
				editModal: {
					title: "Editar mensaje",
					body: "Nuevo mensaje",
					cancel: "Cancelar",
					confirm: "Guardar",
				},
				editErrors: {
					tooOld: "Este mensaje ya no se puede editar (límite de 15 minutos).",
					cannotEdit: "No se pudo editar el mensaje.",
					notFromMe: "Solo puede editar mensajes enviados por usted.",
					deleted: "Los mensajes eliminados no se pueden editar.",
					media: "Los mensajes multimedia no se pueden editar.",
				},
    delete: "Eliminar",
    deleteForEveryone: "Eliminar para todos",
    deleteForMe: "Eliminar para mí",
    copy: "Copiar mensaje",
    copyImage: "Copiar imagen",
    saveImage: "Guardar imagen",
    favorite: "Marcar mensaje como favorito",
    unfavorite: "Quitar de favoritos",
    markPending: "Marcar como pendiente",
    unmarkPending: "Quitar pendiente",
    reply: "Responder",
    replyPrivate: "Responder en privado",
    forward: "Reenviar",
    copySuccess: "Mensaje copiado correctamente.",
    copyImageUrlSuccess: "URL de imagen copiada correctamente.",
    copyError: "No se pudo copiar el mensaje.",
    replyPrivateError: "No se pudo identificar el número del remitente.",
    confirmationModal: {
      title: "¿Eliminar mensaje?",
      titleDeleteForEveryone: "¿Eliminar para todos?",
      titleDeleteForMe: "¿Eliminar para mí?",
      message: "Esta acción no se puede deshacer.",
      messageDeleteForEveryone: "Este mensaje se eliminará para ti y para el destinatario.",
      messageDeleteForMe: "Este mensaje solo se eliminará para ti. El destinatario aún podrá verlo.",
    },
    stickerNoMedia: "Este sticker no tiene contenido multimedia para guardar.",
    stickerAdded: "Sticker agregado a mis stickers.",
    imageFilename: "imagen",
    addToMyStickers: "Agregar a mis stickers",
  },
  pendingMessages: {
    title: "Mensajes Pendientes",
    rowsPerPage: "Filas por página",
    filters: {
      search: "Buscar mensaje",
      contact: "Contacto",
      dateFrom: "Pendiente desde",
      dateTo: "Pendiente hasta",
      pendingUser: "Creado por",
      whatsapp: "Canal WhatsApp",
      status: "Estado",
      all: "Todos"
    },
    table: {
      pendingAt: "Fecha/Hora pendiente",
      contact: "Contacto",
      pendingUser: "Usuario",
      whatsapp: "WhatsApp",
      status: "Estado",
      message: "Mensaje",
      actions: "Acciones",
      removePending: "Quitar pendiente",
      viewMessages: "Ver mensajes",
      messageDeleted: "Mensaje eliminado",
      messageWithoutContent: "Mensaje sin contenido",
      image: "Imagen",
      video: "Video",
      audio: "Audio",
      document: "Documento",
      sticker: "Sticker",
      fileTypePrefix: "Archivo"
    },
    statuses: {
      none: "Sin estado",
      aguardando: "Esperando",
      em_analise: "En Análisis",
      em_producao: "En Producción",
      retornar_cliente: "Devolver al Cliente",
      finalizado: "Finalizado",
      atrasado: "Atrasado"
    },
    toasts: {
      removed: "Pendiente eliminado correctamente",
      statusUpdated: "Estado actualizado",
      ticketNotFound: "Ticket no encontrado para este mensaje.",
      loadConversationFailed: "No fue posible cargar la conversación de este ticket.",
    }
  },
  backendErrors: {
				ERR_CALL_NO_PERMISSION: "El contacto aún no autorizó recibir llamadas de este número.",
				ERR_CALL_NOT_ENABLED: "Las llamadas no están habilitadas en este número en Meta.",
				ERR_CALL_RECEIVER_UNCALLABLE: "Este contacto no puede recibir llamadas de WhatsApp.",
				ERR_CALL_DUPLICATE: "Ya hay una llamada en curso con este contacto.",
				ERR_CALL_LIMIT_REACHED: "Se alcanzó el límite de llamadas de este número. Inténtalo más tarde.",
				ERR_CALL_PERMISSION_REQUEST_LIMIT: "Se alcanzó el límite de solicitudes de permiso para este contacto (1 por día, 2 por semana).",
				ERR_CALL_BUSINESS_INITIATED_UNAVAILABLE: "Las llamadas hechas por la empresa no están disponibles para este número.",
				ERR_CALL_TEMPORARILY_DISABLED: "Meta suspendió temporalmente las llamadas de este número por baja calidad.",
				ERR_CALL_CANNOT_BE_ENABLED: "No se pueden habilitar las llamadas: el número necesita un límite de al menos 2.000 conversaciones por día.",
				ERR_CALL_PERMANENT_PERMISSION_EXISTS: "El contacto ya autorizó llamadas sin plazo; no hace falta pedirlo de nuevo.",
				ERR_CALL_PREREQUISITES_MISSING: "Faltan requisitos: suscribe el campo de webhook “calls” en la app de Meta.",
				ERR_CALL_RECIPIENT_NOT_ALLOWED: "Número de prueba: el contacto no está en la lista de destinatarios permitidos.",
				ERR_CALL_PERMISSION_LOOKUP_RATE_LIMIT: "Demasiadas consultas de permiso en poco tiempo. Espera un momento.",
				ERR_CALL_FAILED: "Meta rechazó la llamada. Inténtalo de nuevo en unos instantes.",
				ERR_CALL_BAILEYS_FAILED: "La llamada no salió por esta conexión. Inténtalo de nuevo en unos instantes.",
				ERR_CALL_ENGINE_FAILED: "El motor de llamadas de esta conexión no inició. Inténtalo de nuevo en unos instantes.",
				ERR_CALL_LINE_BUSY: "Esta conexión ya está en otra llamada.",
				ERR_CALL_CONNECTION_OFFLINE: "La conexión de WhatsApp no está conectada.",
				ERR_CALL_INVALID_SDP: "El navegador no pudo preparar el audio de la llamada.",
				ERR_CALL_ALREADY_IN_PROGRESS: "Ya tienes una llamada en curso.",
				ERR_CALL_ALREADY_ANSWERED: "Otro agente ya contestó esta llamada.",
				ERR_CALL_NOT_FOUND: "Esta llamada ya finalizó.",
				ERR_CALL_NOT_YOURS: "Esta llamada está con otro agente.",
				ERR_CALL_GROUP_UNSUPPORTED: "No es posible llamar a grupos.",
				ERR_CALL_PROVIDER_UNAVAILABLE: "Las llamadas solo están disponibles en conexiones de la API oficial.",
				ERR_CALL_PERMISSION_WINDOW_CLOSED: "La ventana de 24 horas está cerrada: la solicitud de permiso solo puede enviarse con una plantilla aprobada.",
				ERR_CALL_INVALID_SETTINGS: "Configuración de llamadas inválida.",
				ERR_RATING_MESSAGE_REQUIRED: "Escribe la pregunta de evaluación.",
				ERR_RATING_INVALID_WINDOW: "El plazo para responder debe ser de 1 a 168 horas.",
				ERR_INVALID_PASSWORD: "Contraseña incorrecta.",
				ERR_CLOUDAPI_WINDOW_CLOSED: "La ventana de 24 horas expiró. Envíe una plantilla de mensaje para iniciar una nueva conversación.",
				ERR_CLOUDAPI_REVOKE_UNSUPPORTED: "Meta se negó a eliminar este mensaje para el destinatario: la función \"eliminar para todos\" aún no está disponible para números de la API Oficial. El mensaje NO fue eliminado en el dispositivo del cliente.",
				ERR_META_SEND_TEMPLATE: "Error al enviar la plantilla por WhatsApp Cloud API.",
				ERR_CANNOT_EDIT_CLOUDAPI_MESSAGE: "Las conexiones de la API Oficial (Meta) no permiten editar mensajes ya enviados. El mensaje sigue igual en el dispositivo del cliente.",
				ERR_USER_NO_QUEUE_ACCESS: "No tiene acceso a la cola de este ticket.",
				ERR_TICKETS_FROM_OTHER_USERS: "Este contacto tiene tickets abiertos con otros agentes. Tome uno de los tickets existentes antes de enviar mensajes.",
				ERR_PENDING_TICKET_WITH_AGENT: "Este ticket está pendiente con un agente de IA vinculado. Tome el ticket para quitar la IA antes de enviar mensajes.",
				ERR_TRANSFER_USER_OFFLINE: "Este usuario está desconectado. La transferencia a usuarios desconectados está deshabilitada en la configuración.",
				ERR_APPLYING_REACTION: "No se pudo aplicar la reacción.",
				ERR_POLL_UNSUPPORTED_CHANNEL: "Esta conexión no permite votar en encuestas.",
				ERR_POLL_INVALID: "Este mensaje no es una encuesta válida.",
				ERR_POLL_INVALID_OPTION: "Opción no válida para esta encuesta.",
				ERR_POLL_TOO_MANY_OPTIONS: "Esta encuesta no permite elegir tantas opciones.",
				ERR_POLL_SECRET_NOT_FOUND: "No se pudo votar: la clave de esta encuesta ya no está disponible.",
				ERR_SENDING_POLL_VOTE: "No se pudo enviar el voto.",
				ERR_BILLING_ADDONS_NOT_CONFIGURED: "Los complementos de facturación no están configurados.",
				ERR_CAMPAIGN_MESSAGE_OR_TEMPLATE_REQUIRED: "Ingrese un mensaje o una plantilla para la campaña.",
				ERR_CAMPAIGN_NOT_FOUND: "Campaña no encontrada.",
				ERR_CAMPAIGN_RESPONSE_QUEUE_INVALID: "La cola de respuesta de la campaña es inválida.",
				ERR_CAMPAIGN_RESPONSE_QUEUE_NOT_FOUND: "No se encontró la cola de respuesta de la campaña.",
				ERR_CAMPAIGN_RESPONSE_ROUTING_INCOMPLETE: "La configuración de enrutamiento de respuestas de la campaña está incompleta.",
				ERR_CAMPAIGN_RESPONSE_WINDOW_INVALID: "La ventana de respuesta de la campaña es inválida.",
				ERR_CAMPAIGN_SMS_MESSAGE_REQUIRED: "La campaña por SMS necesita un mensaje.",
				ERR_CAMPAIGN_SMS_NO_MEDIA: "La campaña por SMS no acepta adjuntos.",
				ERR_CAMPAIGN_SMS_TOO_LONG: "El mensaje de la campaña por SMS es demasiado largo.",
				ERR_CAMPAIGN_TEMPLATE_REQUIRED: "Seleccione una plantilla para la campaña.",
				ERR_CATALOG_CHANNEL_UNSUPPORTED: "Este canal no admite catálogo de productos.",
				ERR_CATALOG_DELETE_UNAVAILABLE: "No es posible eliminar productos en este catálogo.",
				ERR_CATALOG_DISCOVERY_FAILED: "No se pudo localizar el catálogo en Meta.",
				ERR_CATALOG_MESSAGE_UNSUPPORTED: "Esta conexión no admite el envío de productos del catálogo.",
				ERR_CATALOG_META_PERMISSION: "Sin permiso para acceder al catálogo en Meta.",
				ERR_CATALOG_MULTI_UNSUPPORTED: "Esta conexión no admite el envío de varios productos a la vez.",
				ERR_CATALOG_NOT_BUSINESS: "La cuenta de WhatsApp no es una cuenta comercial.",
				ERR_CATALOG_NOT_FOUND: "Catálogo no encontrado.",
				ERR_CATALOG_NO_CONNECTION: "No hay conexión disponible para el catálogo.",
				ERR_CATALOG_NO_PRODUCT_SELECTED: "Seleccione al menos un producto.",
				ERR_CATALOG_PRODUCT_NO_IMAGE: "El producto no tiene imagen.",
				ERR_CATALOG_PRODUCT_NO_RETAILER_ID: "El producto no tiene código (retailer ID).",
				ERR_CATALOG_PROVIDER_FAILURE: "Falló la comunicación con el proveedor del catálogo.",
				ERR_CATALOG_SEND_UNAVAILABLE: "Envío de productos no disponible en esta conexión.",
				ERR_CATALOG_SYNC_FAILED: "Falló la sincronización del catálogo.",
				ERR_CATALOG_SYNC_UNAVAILABLE: "Sincronización de catálogo no disponible en esta conexión.",
				ERR_CATALOG_TICKET_REQUIRED: "Indique el ticket para enviar el producto.",
				ERR_CATALOG_UPDATE_UNAVAILABLE: "No es posible editar productos en este catálogo.",
				ERR_CATALOG_WABA_NOT_CONFIGURED: "Cuenta de WhatsApp Business (WABA) no configurada.",
				ERR_CATALOG_WAPP_NOT_CONNECTED: "La conexión de WhatsApp no está conectada.",
				ERR_CATALOG_WRONG_CONNECTION: "El producto pertenece a otra conexión.",
				ERR_CHAT_MESSAGE_NOT_FOUND: "Mensaje del chat no encontrado.",
				ERR_CLOUDAPI_ACCOUNT_NOT_REGISTERED: "Número no registrado en la API Oficial (Cloud API).",
				ERR_CLOUDAPI_CONNECTION_NOT_FOUND: "Conexión de la API Oficial no encontrada.",
				ERR_CLOUDAPI_DISPLAY_NAME_NOT_APPROVED: "Meta aún no aprobó el nombre para mostrar.",
				ERR_CLOUDAPI_INVALID_CONFIG: "Configuración de la API Oficial inválida.",
				ERR_CLOUDAPI_INVALID_MEDIA_FORMAT: "Formato de multimedia no aceptado por la API Oficial.",
				ERR_CLOUDAPI_INVALID_MEDIA_MIME: "Tipo de archivo no aceptado por la API Oficial.",
				ERR_CLOUDAPI_MEDIA_TYPE_MISMATCH: "El tipo de multimedia no corresponde al esperado por la plantilla.",
				ERR_CLOUDAPI_RATE_LIMIT: "Límite de envíos de la API Oficial alcanzado. Intente de nuevo en unos instantes.",
				ERR_CLOUDAPI_SUBSCRIPTION: "Falló la suscripción a los eventos (webhook) de la API Oficial.",
				ERR_CONTACT_DATA_REQUIRED: "Ingrese al menos un dato de contacto (teléfono, correo o Instagram).",
				ERR_CONTACT_EMAIL_REQUIRED: "El contacto no tiene correo.",
				ERR_CONTACT_INSTAGRAM_REQUIRED: "El contacto no tiene Instagram.",
				ERR_CONTACT_NOT_FOUND: "Contacto no encontrado.",
				ERR_CONTACT_NOT_ON_WHATSAPP: "El número del contacto no está en WhatsApp.",
				ERR_CONTACT_NO_INSTAGRAM_ID: "El contacto no tiene ID de Instagram.",
				ERR_CONTACT_NO_PHONE_NUMBER: "El contacto no tiene número de teléfono.",
				ERR_DOCUMENTTEMPLATE_CONTENT_TOO_LARGE: "El contenido del modelo de documento es demasiado grande.",
				ERR_DOCUMENT_MISSING_VARIABLES: "Faltan variables para generar el documento.",
				ERR_EMAIL_CONNECTION_NOT_FOUND: "Conexión de correo no encontrada.",
				ERR_EMAIL_DELIVERY_REJECTED: "El servidor de correo rechazó el envío.",
				ERR_EMAIL_SETTING_ALREADY_EXISTS: "Ya existe una configuración de correo.",
				ERR_EMAIL_SETTING_NOT_FOUND: "Configuración de correo no encontrada.",
				ERR_EMPTY_CHAT_MESSAGE: "El mensaje no puede estar vacío.",
				ERR_FORBIDDENWORD_DUPLICATED: "Este término prohibido ya está registrado.",
				ERR_GROUPS_RESYNC_UNSUPPORTED: "Esta conexión no admite resincronizar grupos.",
				ERR_INSTAGRAM_INVALID_CONFIG: "Configuración de Instagram inválida.",
				ERR_INSTAGRAM_UNSUPPORTED_MEDIA: "Tipo de multimedia no compatible con Instagram.",
				ERR_INSTAGRAM_WINDOW_CLOSED: "La ventana de 24 h de Instagram expiró. Espere a que el contacto responda.",
				ERR_INVALID_ATTENDANCE_ALARM_MINUTES: "Minutos de la alarma de atención inválidos.",
				ERR_INVALID_OUT_OF_HOURS_INTERVAL: "Intervalo del mensaje fuera de horario inválido (0 a 1440 minutos).",
				ERR_INVALID_CONTACT_ID: "ID del contacto inválido.",
				ERR_INVALID_DATE_FILTER: "Filtro de fecha inválido.",
				ERR_INVALID_DATE_RANGE_FILTER: "Rango de fechas inválido.",
				ERR_INVALID_EMAIL_CONNECTION: "Conexión de correo inválida.",
				ERR_INVALID_MUTE_DURATION: "Duración del silencio inválida.",
				ERR_INVALID_PAYMENT_DATA: "Datos de pago inválidos.",
				ERR_INVALID_PENDING_STATUS: "Estado de pendiente inválido.",
				ERR_INVALID_SMS_CONNECTION: "Conexión de SMS inválida.",
				ERR_INVALID_SOLICITACAO_ID: "ID de la solicitud inválido.",
				ERR_INVALID_SOLICITACAO_STATUS: "Estado de la solicitud inválido.",
				ERR_INVALID_TICKET_ID: "ID del ticket inválido.",
				ERR_INVALID_UPDATED_AT_FILTER: "Filtro de fecha de actualización inválido.",
				ERR_INVALID_USER_ID: "ID del usuario inválido.",
				ERR_INVALID_WHATSAPP_ID: "ID de la conexión inválido.",
				ERR_MESSAGE_NOT_IN_SCOPE: "El mensaje no pertenece a este ticket.",
				ERR_MESSAGE_NO_TICKET: "El mensaje no está vinculado a un ticket.",
				ERR_NOT_INSTAGRAM_CONNECTION: "Esta conexión no es de Instagram.",
				ERR_NO_CATALOG_PRODUCT_FOUND: "Producto del catálogo no encontrado.",
				ERR_NO_DOCUMENTTEMPLATE_FOUND: "Modelo de documento no encontrado.",
				ERR_NO_FILENAME: "Nombre del archivo no informado.",
				ERR_NO_FILE_UPLOADED: "Ningún archivo enviado.",
				ERR_NO_FORBIDDENWORD_FOUND: "Término prohibido no encontrado.",
				ERR_NO_QUICKMESSAGE_MEDIA_FOUND: "Adjunto de la respuesta rápida no encontrado.",
				ERR_NO_SOLICITACAO_DESENVOLVIMENTO_FOUND: "Solicitud de desarrollo no encontrada.",
				ERR_NO_TAGPHRASE_FOUND: "Frase de etiqueta no encontrada.",
				ERR_NO_WHATSAPP_FOUND: "Conexión no encontrada.",
				ERR_PUBLIC_API_INVALID_TOKEN: "Token de la API pública inválido.",
				ERR_PUBLIC_API_NOT_CONFIGURED: "API pública no configurada.",
				ERR_PUBLIC_API_NO_TOKEN: "Token de la API pública no informado.",
				ERR_QUICKMESSAGE_MAX_MEDIAS: "Límite de adjuntos de la respuesta rápida alcanzado.",
				ERR_QUOTED_MSG_NOT_IN_CHAT: "El mensaje citado no pertenece a este chat.",
				ERR_SENDING_CATALOG_PRODUCT: "Error al enviar el producto del catálogo.",
				ERR_SENDING_CLOUDAPI_MSG_INVALID_CONNECTION: "Conexión de la API Oficial inválida para el envío.",
				ERR_SENDING_INSTAGRAM_MSG_INVALID_CONNECTION: "Conexión de Instagram inválida para el envío.",
				ERR_SENDING_WAPP_MSG_CONTACT_NOT_FOUND: "Contacto no encontrado para enviar el mensaje.",
				ERR_SMSBARATO_REQUEST_FAILED: "Falló la solicitud a SMS Barato.",
				ERR_SMSDEV_REQUEST_FAILED: "Falló la solicitud a SMSDev.",
				ERR_TAGPHRASE_DUPLICATED: "Esta frase ya está registrada.",
				ERR_TAGPHRASE_INVALID_PHRASE: "Frase inválida.",
				ERR_TEMPLATE_CREDIT_INVALID_CATEGORY: "Categoría de plantilla inválida.",
				ERR_TEMPLATE_HEADER_MEDIA_REQUIRED: "La plantilla exige un archivo multimedia en el encabezado.",
				ERR_TEMPLATE_MISSING_FIELDS: "Faltan campos obligatorios de la plantilla.",
				ERR_TEMPLATE_NOT_APPROVED: "Meta aún no aprobó la plantilla.",
				ERR_TEMPLATE_NOT_FOUND: "Plantilla no encontrada.",
				ERR_TEMPLATE_SYNC_META_LIST: "Falló la búsqueda de la lista de plantillas en Meta.",
				ERR_TEMPLATE_VARIABLES_MISMATCH: "Las variables informadas no corresponden a las de la plantilla.",
				ERR_TEMPLATE_WABA_MISMATCH: "La plantilla pertenece a otra cuenta de WhatsApp Business.",
				ERR_TEST_EMAIL_REQUIRED: "Ingrese un correo para la prueba.",
				ERR_TICKET_NOT_FOUND: "Ticket no encontrado.",
				ERR_TICKET_OR_CONTACT_REQUIRED: "Indique el ticket o el contacto.",
				ERR_TICKET_REQUIRED: "Indique el ticket.",
				ERR_TRANSFER_USER_REQUIRED: "Seleccione el usuario para transferir.",
				ERR_WABA_CONNECTION_NOT_FOUND: "Conexión de WhatsApp Business (WABA) no encontrada.",
				ERR_WABA_NOT_CONFIGURED: "Cuenta de WhatsApp Business (WABA) no configurada.",
				ERR_WABA_OR_WHATSAPP_REQUIRED: "Indique la cuenta WABA o la conexión.",
				ERR_WAPP_NOT_CLOUDAPI: "Esta conexión no es de la API Oficial.",
				ERR_WAPP_NOT_FOUND: "Conexión de WhatsApp no encontrada.",
				ERR_WAPP_VALIDATION_ABORTED: "Validación del número cancelada.",
				ERR_WHATSAPP_CONNECTION_EXISTS: "Ya existe una conexión con este número.",
				ERR_WHATSAPP_NAME_REQUIRED: "Ingrese el nombre de la conexión.",
				ERR_WITIME_REQUEST_FAILED: "Falló la solicitud a Witime.",
    ERR_MEDIA_URL_REQUIRED:
      "No fue posible identificar la figurita seleccionada.",
    ERR_STICKER_REMOVED_FROM_LIBRARY:
      "Esta figurita ya fue eliminada de la biblioteca.",
    ERR_MESSAGES_REPORT_INVALID_PERIOD:
      "Informe un período válido en el informe (fecha inicial y fecha final).",
    ERR_MESSAGES_REPORT_TERM_TOO_SHORT:
      "Escriba al menos 3 caracteres en el término de búsqueda.",
    ERR_AI_CREDIT_NOT_ENABLED:
      "El cobro de créditos de IA no está habilitado para tu empresa.",
    ERR_AI_CREDIT_COMPANY_NOT_LINKED:
      "Esta empresa todavía no está vinculada a iaHub, así que no hay adónde enviar el crédito. Vincúlala en Configuración → Créditos de IA.",
    ERR_AI_CREDIT_INVALID_VALUE:
      "Valor de recarga de créditos de IA inválido.",
    ERR_AI_CREDIT_INVALID_SETTING:
      "Configuración de créditos de IA inválida.",
    ERR_AI_CREDIT_INVALID_RANGE:
      "El crédito mínimo no puede ser mayor que el crédito máximo.",
    ERR_AI_CREDIT_TOPUP_NOT_FOUND:
      "Recarga de créditos de IA no encontrada.",
    ERR_AI_CREDIT_TOPUP_NOT_PAID:
      "Esta recarga todavía no fue pagada: no hay crédito para enviar a iaHub.",
    ERR_AI_HUB_NOT_CONFIGURED:
      "iaHub no está configurado en este entorno (AI_HUB_BASE_URL y AI_HUB_RESELLER_KEY en el .env del backend).",
    ERR_AI_HUB_UNAUTHORIZED:
      "iaHub rechazó la clave del revendedor. Revisa AI_HUB_RESELLER_KEY.",
    ERR_AI_HUB_UNAVAILABLE:
      "No fue posible comunicarse con iaHub ahora. Intenta de nuevo en unos instantes.",
    ERR_AI_HUB_COMPANY_NOT_FOUND:
      "Empresa no encontrada en este revendedor de iaHub.",
    ERR_AI_HUB_RESELLER_CONFLICT:
      "Esa empresa de iaHub ya pertenece a otro revendedor.",
    ERR_AI_HUB_AGENT_NOT_FOUND:
      "Agente no encontrado en iaHub. Revisa el ID del agente — un carácter de más o de menos ya impide que la IA responda.",
    ERR_PROMPT_AGENT_OTHER_HUB_COMPANY:
      "Esta empresa se cobra con créditos de IA y el agente elegido pertenece a otra empresa de iaHub: su consumo no saldría del saldo de esta empresa. Usa un agente de la empresa vinculada.",
    ERR_AI_CREDIT_AGENT_MISMATCH:
      "No se puede cobrar esta empresa vinculada a esa empresa de iaHub: el consumo de IA se descuenta de la empresa dueña del agente, y hay prompts con agente de otra empresa.",
    ERR_AI_CREDIT_HUB_COMPANY_IN_USE:
      "Esa empresa de iaHub ya está vinculada a otra empresa del CRM.",
    ERR_AI_CREDIT_LINK_HAS_BALANCE:
      "La empresa anterior en iaHub tiene saldo comprado; el vínculo no se cambió.",
    ERR_TEMPLATE_CREDIT_INSUFFICIENT:
      "Saldo de créditos de plantilla insuficiente. Recarga en Finanzas para seguir enviando plantillas.",
    ERR_TEMPLATE_CREDIT_NOT_ENABLED:
      "El cobro de plantillas no está habilitado para tu empresa.",
    ERR_TEMPLATE_CREDIT_INVALID_VALUE:
      "Valor de recarga inválido.",
    ERR_TEMPLATE_CREDIT_ADJUST_BELOW_ZERO:
      "El ajuste dejaría el saldo negativo.",
    ERR_TEMPLATE_CREDIT_REASON_REQUIRED:
      "Informa el motivo del ajuste de saldo.",
    ERR_TICKET_CLOSE_WITHOUT_INTERACTION:
      "No has interactuado con el contacto en esta atención.",
    ERR_TICKET_CLOSE_WITHOUT_INTERACTION_BLOCKED:
      "No es posible finalizar esta atención: aún no has interactuado con el contacto.",
    ERR_TICKET_CLOSE_ASK_COMPLETION_MESSAGE:
      "Confirma si el mensaje de conclusión debe enviarse antes de finalizar la atención.",
    ERR_NO_OTHER_WHATSAPP:
      "Debe haber al menos un WhatsApp predeterminado.",
    ERR_NO_DEF_WAPP_FOUND:
      "No hay WhatsApp conectado. Por favor, conecte al menos un número de WhatsApp en la página de conexiones.",
    ERR_NO_BAILEYS_WAPP_FOUND:
      "No hay ninguna conexión de WhatsApp (código QR) disponible para validar números. Conecte un WhatsApp en la página de conexiones.",
    ERR_WAPP_NOT_INITIALIZED:
      "Esta sesión de WhatsApp no se ha inicializado. Comprueba la página de conexiones.",
    ERR_WAPP_CHECK_CONTACT:
      "No se pudo verificar el contacto de WhatsApp. Comprueba la página de conexiones",
    ERR_WAPP_INVALID_CONTACT: 
      "Este no es un número de WhatsApp válido.",
    ERR_CHECK_NUMBER:
      "El número proporcionado no está registrado en WhatsApp o no existe.",
    ERR_MEDIA_MIMETYPE_NOT_FOUND:
      "No se pudo identificar el tipo de archivo multimedia.",
    ERR_INVALID_MIMETYPE:
      "Tipo de archivo inválido.",
    ERR_IMPORT_CONTACTS_FAILED:
      "Error al cargar los contactos de WhatsApp. Inténtalo de nuevo más tarde.",
    ERR_WHATSAPP_NOT_CONNECTED:
      "Esta conexión de WhatsApp no está conectada. Verifica la página de conexiones.",
    ERR_NO_CONTACTS_SYNCED_YET:
      "No fue posible leer la agenda del teléfono en esta conexión ahora. Inténtalo de nuevo en unos minutos; si continúa, importa los contactos desde una hoja de cálculo o agrégalos con \"Agregar Contacto\".",
    ERR_IMPORT_NO_FILE:
      "No se envió ningún archivo. Selecciona una planilla CSV, XLS o XLSX.",
    ERR_IMPORT_INVALID_FILE_TYPE:
      "Tipo de archivo no soportado. Sube una planilla CSV, XLS o XLSX.",
    ERR_IMPORT_TOO_MANY_ROWS:
      "La planilla tiene demasiadas filas. Divídela en archivos de máximo 5000 filas.",
    ERR_WAPP_DOWNLOAD_MEDIA:
      "No se pudo descargar medios de WhatsApp. Comprueba la página de conexiones.",
    ERR_INVALID_CREDENTIALS:
      "Error de autenticación. Por favor, inténtalo de nuevo.",
    ERR_SENDING_WAPP_MSG:
      "Error al enviar mensaje de WhatsApp. Comprueba la página de conexiones.",
    ERR_CONTACT_NOT_IN_CONNECTION:
      "Este contacto no pertenece a la conexión actual. Verifica si la conexión de WhatsApp es la misma que se usó para iniciar la conversación.",
    ERR_GROUP_NOT_IN_CONNECTION:
      "Este grupo no pertenece a la conexión actual. Usa una conexión de WhatsApp que forme parte del grupo.",
    ERR_WAPP_NOT_CONNECTED:
      "La conexión de WhatsApp está desconectada. Verifica la página de conexiones y reconecta.",
    ERR_WAPP_NOT_RESPONDING:
      "La conexión de WhatsApp no está respondiendo. El mensaje no se envió; espera a que la conexión vuelva y envíalo de nuevo.",
    ERR_WAPP_RECIPIENT_NO_DEVICES:
      "WhatsApp no encontró ningún dispositivo de este contacto (número sin WhatsApp o identificador desactualizado). El mensaje no se envió.",
    ERR_CLOUDAPI_GROUP_UNSUPPORTED:
      "Cloud API no admite envíos a grupos.",
    ERR_DELETE_WAPP_MSG: 
      "No se pudo eliminar el mensaje de WhatsApp.",
    ERR_EDITING_WAPP_MSG:
      "No se pudo editar el mensaje de WhatsApp.",
    ERR_MESSAGE_NOT_FOUND:
      "Mensaje no encontrado.",
    ERR_CANNOT_EDIT_MESSAGE_NOT_FROM_ME:
      "Solo puedes editar mensajes enviados por ti.",
    ERR_CANNOT_EDIT_DELETED_MESSAGE:
      "Los mensajes eliminados no se pueden editar.",
    ERR_MESSAGE_TOO_OLD_TO_EDIT:
      "Este mensaje ya no se puede editar (límite de 15 minutos).",
    ERR_CANNOT_EDIT_MEDIA_MESSAGE:
      "Los mensajes multimedia no se pueden editar.",
    ERR_MESSAGE_BODY_REQUIRED:
      "El cuerpo del mensaje es obligatorio.",
    ERR_INVALID_REACTION:
      "Reacción inválida.",
    ERR_OTHER_OPEN_TICKET: 
      "Ya hay un ticket abierto para este contacto.",
    ERR_SESSION_EXPIRED:
      "Sesión expirada. Por favor, inicia sesión.",
    ERR_COMPANY_BLOCKED:
      "Tu suscripción ha vencido. Accede a Finanzas y regulariza el pago para seguir usando el sistema.",
    ERR_COMPANY_INACTIVE:
      "Esta empresa está inactiva. Ponte en contacto con el soporte para más información.",
    ERR_LICENSE_INVALID:
      "La licencia de uso de esta empresa no es válida. Ponte en contacto con Empsis para regularizarla.",
    ERR_LICENSE_CHECK_DISABLED:
      "La validación de licencia no está activa en esta instalación.",
    ERR_STORAGE_USAGE_RUNNING:
      "El cálculo de almacenamiento ya está en ejecución. Espera a que termine.",
    ERR_COMPANY_EMPSIS_TOKEN_REQUIRED:
      "Informa el token de Empsis de la empresa. Usa el botón Generar token si no tienes uno.",
    ERR_EMPSIS_TOKEN_MISSING_FIELDS:
      "Informa CNPJ, usuario y contraseña de Empsis para generar el token.",
    ERR_EMPSIS_TOKEN_REFUSED:
      "Empsis rechazó la generación del token. Revisa CNPJ, usuario y contraseña.",
    ERR_EMPSIS_UNAVAILABLE:
      "Empsis no respondió. Inténtalo de nuevo en unos instantes.",
    ERR_EMPSIS_TOKEN_READONLY:
      "El token de Empsis no se puede escribir. Genera uno nuevo con el botón Generar y guardar.",
    ERR_SAME_PLAN:
      "La empresa ya está en este plan.",
    ERR_PLAN_QR_CONNECTION_NOT_ALLOWED:
      "El plan de la empresa no incluye conexión de WhatsApp por código QR.",
    ERR_PLAN_CHANGE_NOT_ALLOWED:
      "El cambio de plan no está disponible para esta empresa. Ponte en contacto con el soporte.",
    ERR_MP_LEGACY_SUBSCRIPTION_REQUIRES_CARD:
      "Tu suscripción actual usa el modelo antiguo de Mercado Pago y no permite cambiar el valor. Vuelve a registrar la tarjeta en Finanzas (sección Mi plan) para completar el cambio.",
    ERR_ADDON_CHANGE_ALREADY_PENDING:
      "Ya existe un cambio de add-ons pendiente. Completa el pago o cancélalo antes de solicitar otro.",
    ERR_ADDON_MIXED_CHANGE:
      "Agrega y elimina add-ons en operaciones separadas.",
    ERR_ADDON_INVALID_QUANTITY:
      "Cantidad de add-ons inválida.",
    ERR_ADDON_NOT_AN_UPGRADE:
      "El cambio solicitado no agrega ningún add-on.",
    ERR_ADDON_NOT_A_DOWNGRADE:
      "El cambio solicitado no elimina ningún add-on.",
    ERR_CHANGE_REQUEST_NOT_FOUND:
      "Cambio de plan no encontrado.",
    ERR_CHANGE_REQUEST_ALREADY_PAID:
      "El prorrateo de este cambio ya fue pagado — se aplicará automáticamente.",
    ERR_CHANGE_REQUEST_NOT_CANCELLABLE:
      "Este cambio ya no puede cancelarse.",
    ERR_CARD_TOKEN_REQUIRED:
      "Se requiere una tarjeta para esta operación.",
    ERR_INVOICE_WITHOUT_VALUE:
      "Esta factura no tiene valor de cobro.",
    ERR_CUSTOM_VALUE_INVALID:
      "Valores de personalización inválidos.",
    ERR_PLAN_WITHOUT_VALUE:
      "Este plan no tiene valor de cobro definido. Contacta al soporte.",
    ERR_COMPANY_WITHOUT_PLAN:
      "La empresa no tiene un plan asignado. Contacta al soporte.",
    ERR_SUBSCRIPTION_ALREADY_ACTIVE:
      "Ya existe una suscripción automática activa para esta empresa.",
    ERR_NO_ACTIVE_SUBSCRIPTION:
      "No hay suscripción automática activa para cancelar.",
    ERR_INVOICE_NOT_FOUND:
      "Factura no encontrada.",
    ERR_INVOICE_ALREADY_PAID:
      "Esta factura ya fue pagada.",
    ERR_MP_PLAN_NOT_SYNCED:
      "No se pudo sincronizar el plan con Mercado Pago. Inténtalo de nuevo en unos instantes.",
    ERR_MP_PIX_UNAVAILABLE:
      "El pago con Pix no está disponible en este momento. Usa tarjeta de crédito o contacta al soporte.",
    ERR_USER_CREATION_DISABLED:
      "La creación de usuarios ha sido deshabilitada por el administrador.",
    ERR_NO_PERMISSION: 
      "No tienes permiso para acceder a este recurso.",
    ERR_WAPP_TOKEN_IN_USE:
      "Este token ya está en uso por otra conexión.",
    ERR_WAPP_NAME_IN_USE:
      "Ya existe una conexión con este nombre en esta empresa.",
    ERR_DUPLICATED_CONTACT: 
      "Ya existe un contacto con este número.",
    ERR_CONTACT_SAVE_FAILED:
      "No se pudo guardar el contacto. Inténtalo de nuevo.",
    ERR_CONTACT_UPDATE_FAILED:
      "No se pudo actualizar el contacto. Inténtalo de nuevo.",
    ERR_NO_SETTING_FOUND: 
      "No se encontró ninguna configuración con esta ID.",
    ERR_NO_CONTACT_FOUND: 
      "No se encontró ningún contacto con esta ID.",
    ERR_NO_TICKET_FOUND: 
      "No se encontró ningún ticket con esta ID.",
    ERR_NO_USER_FOUND: 
      "No se encontró ningún usuario con esta ID.",
    ERR_TICKET_INACTIVE: 
      "Este ticket pertenece a una conexión eliminada y no puede reabrirse, transferirse ni responderse.",
    ERR_NO_WAPP_FOUND: 
      "No se encontró ningún WhatsApp con esta ID.",
    ERR_CREATING_MESSAGE: 
      "Error al crear mensaje en la base de datos.",
    ERR_CREATING_TICKET: 
      "Error al crear ticket en la base de datos.",
    ERR_FETCH_WAPP_MSG:
      "Error al obtener mensaje de WhatsApp, puede que sea muy antiguo.",
    ERR_QUEUE_COLOR_ALREADY_EXISTS:
      "Este color ya está en uso, elige otro.",
    ERR_WAPP_GREETING_REQUIRED:
      "El saludo es obligatorio cuando hay más de una cola.",
    ERR_CHANNEL_SINGLE_QUEUE_ONLY:
      "Este tipo de canal permite solo una cola.",
    ERR_QUEUE_HAS_PROMPTS:
      "No se puede eliminar la cola. Hay prompts asociados a esta cola. Por favor, reasigna o elimina los prompts antes de eliminar esta cola.",
    ERR_NO_TICKETNOTE_FOUND:
      "No se encontró ninguna nota de ticket con esta ID.",
    ERR_NO_HELP_FOUND:
      "No se encontró ninguna ayuda con esta ID.",
    ERR_NO_SCHEDULE_FOUND:
      "No se encontró ningún agendamiento con esta ID.",
    ERR_QUEUE_NOT_FOUND:
      "No se encontró ninguna cola con esta ID.",
    ERR_NO_DIALOG_FOUND:
      "No se encontró ninguna integración con esta ID.",
    ERR_NO_PROMPT_FOUND:
      "No se encontró ningún prompt con esta ID.",
    ERR_NO_PLAN_FOUND:
      "No se encontró ningún plan con esta ID.",
    ERR_NO_KANBAN_BOARD_FOUND:
      "No se encontró ningún tablero Kanban con esta ID.",
    ERR_NO_KANBAN_CARD_FOUND:
      "No se encontró ninguna tarjeta Kanban con esta ID.",
    ERR_NO_KANBAN_COLUMN_FOUND:
      "No se encontró ninguna columna Kanban con esta ID.",
    ERR_KANBAN_CARD_DUPLICATE_CONTACT:
      "Ya existe una tarjeta de este contacto. Confirma para crearla de todos modos.",
    ERR_KANBAN_CARD_DUPLICATE_CONTACT_BLOCKED:
      "Ya existe una tarjeta de este contacto — la creación de tarjetas duplicadas está bloqueada en esta empresa.",
    ERR_NO_MESSAGE_FOUND:
      "No se encontró ningún mensaje con esta ID.",
    ERR_NO_COMPANY_FOUND:
      "No se encontró ninguna empresa con esta ID.",
    ERR_COMPANY_INVALID_CNPJ:
      "CNPJ inválido. Ingrese un CNPJ válido.",
    ERR_COMPANY_CNPJ_ALREADY_EXISTS:
      "Ya existe una empresa registrada con este CNPJ.",
    ERR_COMPANY_NAME_ALREADY_EXISTS:
      "Ya existe una empresa registrada con este nombre.",
    ERR_COMPANY_INVALID_NAME:
      "Nombre de empresa inválido. Ingrese al menos 2 caracteres.",
    ERR_COMPANY_INVALID_EMAIL:
      "Ingrese un correo electrónico válido.",
    ERR_USER_EMAIL_ALREADY_EXISTS:
      "Este correo electrónico ya está en uso. Inicie sesión o use otro correo.",
    ERR_COMPANY_INVALID_PASSWORD:
      "Ingrese una contraseña con al menos 5 caracteres.",
    ERR_NO_CONTACTLISTITEM_FOUND:
      "No se encontró ningún elemento de lista de contactos con esta ID.",
    ERR_NO_CONTACTLIST_FOUND:
      "No se encontró ninguna lista de contactos con esta ID.",
    ERR_NO_QUICKMESSAGE_FOUND:
      "No se encontró ningún mensaje rápido con esta ID.",
    ERR_NO_TAG_FOUND:
      "No se encontró ninguna etiqueta con esta ID.",
    ERR_NO_FILE_FOUND:
      "No se encontró ningún archivo con esta ID.",
    ERR_NO_RATING_FOUND:
      "No se encontró ninguna calificación con esta ID.",
    ERR_NO_CHAT_FOUND:
      "No se encontró ningún chat con esta ID.",
    ERR_NO_CLIENTE_FOUND:
      "No se encontró ningún cliente con esta ID.",
    ERR_COMMENT_REQUIRES_CONTENT_OR_MEDIA:
      "El comentario requiere contenido o medios.",
    ERR_NO_COMMENT_FOUND:
      "No se encontró ningún comentario con esta ID.",
    ERR_NO_BAILEYS_DATA_FOUND:
      "No se encontraron datos de Baileys con esta ID.",
    ERR_NO_CAMPAIGN_FOUND:
      "No se encontró ninguna campaña con esta ID.",
    ERR_NO_ANNOUNCEMENT_FOUND:
      "No se encontró ningún anuncio con esta ID.",
    ERR_USER_NOT_FOUND:
      "Usuario no encontrado.",
    ERR_NO_SUPER:
      "No tienes permiso de super administrador.",
    ERR_QUEUE_INVALID_COLOR: "Ingresa un color válido para la cola.",
    ERR_QUEUE_INVALID_NAME: "El nombre de la cola debe tener al menos 2 caracteres.",
    ERR_QUEUE_NAME_ALREADY_EXISTS: "Ya existe una cola con este nombre.",
    ERR_QUEUE_LIMIT_REACHED: "Se alcanzó el límite de colas de tu plan.",
    ERR_QUICKMESSAGE_INVALID_NAME: "El atajo y el mensaje deben tener al menos 3 caracteres.",
    ERR_QUICKMESSAGE_REQUIRED: "Completa el atajo y el mensaje.",
    ERR_PROMPT_NAME_INVALID: "Ingresa el nombre del prompt.",
    ERR_PROMPT_AIHUB_AGENTID_REQUIRED: "Ingresa el ID del agente de iaHub.",
    ERR_PROMPT_COOLDOWN_INVALID: "Ingresa un número de minutos igual o mayor que cero.",
    ERR_PROMPT_COOLDOWN_MAX: "El tiempo máximo de pausa es de 10080 minutos (7 días).",
    ERR_TICKETNOTE_INVALID_NAME: "La nota debe tener al menos 3 caracteres.",
    ERR_MEDIA_REDOWNLOAD_FAILED: "No se pudo descargar el archivo multimedia nuevamente. Inténtalo más tarde.",
    ERR_TRANSCRIPTION_DISABLED: "La transcripción de audios está desactivada. El administrador puede configurar la clave de OpenAI en Configuración → Opciones.",
    ERR_TRANSCRIPTION_NOT_RETRYABLE: "Esta transcripción no se puede rehacer ahora: ya se rehízo o está en curso.",
    ERR_INSTAGRAM_STORY_EXPIRED: "La historia caducó en Instagram (las historias están disponibles por 24h).",
    ERR_INSTAGRAM_MEDIA_UNAVAILABLE: "Instagram ya no entrega este archivo.",
    ERR_INSTAGRAM_REEL_NO_FILE: "Instagram no entrega el archivo del reel; usa \"Abrir en Instagram\".",
    ERR_WHATSAPP_ID_REQUIRED: "Selecciona una conexión.",
    ERR_WHATSAPP_LIMIT_REACHED: "Se alcanzó el límite de conexiones de tu plan.",
    ERR_USER_LIMIT_REACHED: "Se alcanzó el límite de usuarios de tu plan.",
    ERR_CONTACT_NOT_GROUP: "Este contacto no es un grupo.",
    ERR_GROUP_CONNECTION_NOT_FOUND: "No se pudo encontrar la conexión de este grupo.",
    ERR_SYSTEM_ALERTS_CONNECTION_REQUIRED: "Selecciona la conexión que enviará las alertas.",
    ERR_SYSTEM_ALERTS_NUMBERS_REQUIRED: "Ingresa al menos un número de destino válido.",
    ERR_PAIRING_INVALID_NUMBER: "Número inválido. Ingresa código de país + código de área + número, solo dígitos (ej.: 5511999998888).",
    ERR_PAIRING_BAILEYS_ONLY: "El inicio de sesión por número solo está disponible para conexiones Baileys.",
    ERR_ADMIN_ONLY: "Acceso denegado. Solo los administradores pueden acceder a este recurso.",
    ERR_FORWARD_MESSAGE_FAILED: "No se pudo reenviar el mensaje.",
    ERR_PROFILE_NOT_FOUND: "Perfil no encontrado.",
    ERR_PROFILE_NAME_REQUIRED: "Ingresa el nombre del perfil.",
    ERR_PROFILE_NAME_ALREADY_EXISTS: "Ya existe un perfil con este nombre en esta empresa. Elige otro nombre.",
    ERR_SCHEDULE_CONNECTION_INVALID: "La conexión seleccionada no pertenece a la empresa.",
    ERR_SCHEDULE_INVALID_DATE: "Fecha/hora del agendamiento inválida.",
    ERR_SCHEDULE_IN_PAST: "No se permite agendar mensajes en el pasado (tolerancia de 2 minutos).",
    ERR_FORBIDDEN_OTHER_COMPANY: "Este registro pertenece a otra empresa.",
    ERR_CAMPAIGN_DELETE_IN_PROGRESS: "No se permite eliminar una campaña en curso.",
    ERR_CAMPAIGN_UPDATE_NOT_ALLOWED: "Solo se pueden editar campañas inactivas, programadas o canceladas.",
    ERR_CAMPAIGN_INVALID_NAME: "El nombre de la campaña debe tener al menos 3 caracteres.",
    ERR_CAMPAIGN_REQUIRED: "Ingresa el nombre de la campaña.",
    ERR_PEDIDO_NOT_FOUND: "Pedido no encontrado.",
    ERR_PEDIDO_ITEMS_REQUIRED: "El pedido debe contener al menos un ítem.",
    ERR_PEDIDO_DELETE_NOT_ALLOWED: "No se pueden eliminar pedidos ya entregados o enviados.",
    ERR_INVALID_RESET_TOKEN: "Verifica el token ingresado.",
    ERR_CONTACTLIST_INVALID_NAME: "El nombre de la lista debe tener al menos 3 caracteres.",
    ERR_CONTACTLIST_REQUIRED: "Ingresa el nombre de la lista.",
    ERR_CONTACTLISTITEM_INVALID_NAME: "El nombre del contacto debe tener al menos 3 caracteres.",
    ERR_CONTACTLISTITEM_REQUIRED: "Ingresa el nombre del contacto.",
    ERR_FORBIDDENWORD_INVALID_TERM: "El término debe tener al menos 2 caracteres.",
    ERR_FORBIDDENWORD_REQUIRED: "Ingresa el término.",
    ERR_TAGPHRASE_REQUIRED: "Ingresa la frase.",
    ERR_TAGPHRASE_TAG_REQUIRED: "Selecciona la etiqueta.",
    ERR_ANNOUNCEMENT_REQUIRED: "Ingresa el título y el texto del informativo.",
    ERR_DOCUMENTTEMPLATE_INVALID_NAME: "El nombre de la plantilla debe tener al menos 2 caracteres.",
    ERR_DOCUMENTTEMPLATE_REQUIRED: "Ingresa el nombre y el contenido de la plantilla.",
    ERR_HELP_INVALID_NAME: "El título debe tener al menos 3 caracteres.",
    ERR_HELP_REQUIRED: "Ingresa el título.",
    ERR_RATING_NAME_ALREADY_EXISTS: "Ya existe un registro con este nombre.",
    ERR_PLAN_INVALID_NAME: "El nombre del plan debe tener al menos 2 caracteres.",
    ERR_PLAN_NAME_ALREADY_EXISTS: "Ya existe un plan con este nombre.",
    ERR_MP_CANCEL_FAILED: "No se pudo cancelar la suscripción en Mercado Pago. Inténtalo de nuevo en unos instantes.",
    ERR_MP_PAYMENT_FAILED: "No se pudo procesar el pago en Mercado Pago. Revisa los datos e inténtalo de nuevo.",
    ERR_MP_PREFERENCE_FAILED: "No se pudo iniciar el pago en Mercado Pago. Inténtalo de nuevo en unos instantes.",
    ERR_MP_SUBSCRIPTION_FAILED: "No se pudo crear la suscripción en Mercado Pago. Revisa los datos de la tarjeta e inténtalo de nuevo.",
    ERR_MP_SUBSCRIPTION_UPDATE_FAILED: "No se pudo actualizar la suscripción en Mercado Pago. Inténtalo de nuevo en unos instantes.",
    ERR_SUBSCRIPTION_INVALID_DATA: "Datos de pago incompletos o inválidos.",
      },
  toasts: {
    genericFallback: "No se pudo completar tu solicitud en este momento. Inténtalo de nuevo en unos instantes.",
    genericUnavailable: "Estamos restableciendo la conexión. Inténtalo de nuevo en unos instantes.",
  },
  connectionSelectDialog: {
    title: "Seleccionar conexión",
    noConnections: "No hay conexiones activas disponibles. Conecta un canal para iniciar la atención.",
    automatic: "Automático",
    systemDefault: "Predeterminado del sistema",
    whatsappOfficial: "WhatsApp Oficial",
    officialBadge: "OFICIAL",
    email: "Correo",
  },
  pagination: {
    currentPage: "Página actual",
    currentPageHint: "Página actual — escribe un número entre 1 y {{total}} y presiona Enter",
  },
  errorBoundary: {
    title: "¡Ups! Algo salió mal",
    message: "Ocurrió un error inesperado. Por favor, inténtalo de nuevo o vuelve a la página de inicio.",
    goHome: "Ir a la página de inicio",
    reload: "Recargar página",
  },
  locationPreview: {
    openInMaps: "Haz clic para abrir en Google Maps",
  },
  phoneFormat: {
    notFound: "Número no encontrado",
  },
  ticketsConference: {
    title: "Revisión de tickets",
    subtitle: "Tickets finalizados/concluidos",
    filters: {
      search: "Buscar por contacto",
      queue: "Cola",
      user: "Responsable",
      campaign: "Campaña",
      allQueues: "Todas",
      allCampaigns: "Todas",
      allTags: "Todas",
    },
    table: {
      contact: "Contacto",
      queue: "Cola",
      user: "Responsable",
      finishedAt: "Finalizado el",
      checked: "Revisado",
      noQueue: "Sin cola",
      empty: "No se encontraron tickets finalizados.",
      allLoaded: "Se cargaron todos los tickets.",
    },
    actions: {
      openChat: "Abrir chat",
      check: "Marcar como revisado",
      uncheck: "Desmarcar como revisado",
    },
    toasts: {
      updated: "Revisión actualizada con éxito.",
      openChatError: "No fue posible abrir el chat de este ticket.",
    },
  },
  connectionsDiag: {
    title: "Diagnóstico de Conexiones",
    subtitle: "Vista general de todas las conexiones de WhatsApp del sistema",
    numberValue: "Número: {{number}}",
    errors: {
      invalidPassword: "Contraseña inválida",
      loadConnections: "Error al cargar las conexiones",
      connection: "Error de conexión",
      sendMessage: "Error al enviar el mensaje",
      autoTest: "Error al ejecutar la autoprueba",
    },
    status: {
      connected: "CONECTADO",
    },
    login: {
      subtitle: "Ingrese la contraseña para acceder al panel",
      password: "Contraseña",
      submit: "Entrar",
    },
    buttons: {
      testing: "Probando...",
      autoTest: "Autoprueba general",
    },
    stats: {
      connected: "Conectadas",
      disconnected: "Desconectadas",
    },
    table: {
      session: "Sesión",
      number: "Número",
      battery: "Batería",
      updatedAt: "Actualizado",
      action: "Acción",
      default: "Predeterminado",
    },
    session: {
      active: "Activa",
      inactive: "Inactiva",
    },
    tooltips: {
      sendTest: "Enviar mensaje de prueba",
      notConnected: "La conexión no está conectada",
    },
    autoTest: {
      title: "Autoprueba de todas las conexiones",
      description: "Envía un mensaje de prueba por cada conexión conectada y genera un informe",
      numberLabel: "Número de destino para todas las pruebas",
      numberHelper: "Todas las conexiones enviarán un mensaje a este número",
      running: "Ejecutando autoprueba...",
      runningHint: "Enviando un mensaje de prueba por cada conexión. Esto puede tardar algunos minutos.",
      report: "Informe de la autoprueba",
      totalDuration: "Duración total: {{duration}}",
      summary: {
        total: "Total: {{value}}",
        success: "Éxito: {{value}}",
        errors: "Errores: {{value}}",
        skipped: "Omitidas: {{value}}",
        tested: "Probadas: {{value}}",
      },
      details: "Detalles por conexión:",
      start: "Iniciar autoprueba",
      again: "Probar de nuevo",
    },
    testDialog: {
      title: "Enviar mensaje de prueba",
      connection: "Conexión",
      number: "Número de destino",
      numberHelper: "Número con código de país (ej.: 5542998232794)",
      message: "Mensaje (opcional)",
      messageHelper: "Deje en blanco para usar el mensaje de prueba predeterminado",
      messagePlaceholder: "Mensaje personalizado...",
      sending: "Enviando...",
      send: "Enviar prueba",
    },
  },
  profiles: {
    deleteAlert: "Eliminar perfil: {{name}}",
    buttons: {
      add: "Agregar Perfil",
    },
    toasts: {
      deleted: "¡Perfil eliminado con éxito!",
      deleteError: "Error al eliminar el perfil",
    },
    confirmDelete: {
      title: "Confirmar eliminación",
      message: "¿Está seguro de que desea eliminar el perfil \"{{name}}\"?",
    },
    validation: {
      required: "Campo obligatorio",
    },
    modal: {
      addTitle: "Nuevo Perfil",
      editTitle: "Editar Perfil",
      searchPlaceholder: "Buscar menú o filtro",
      name: "Nombre del Perfil",
      nothingFound: "No se encontró ningún menú o filtro para \"{{term}}\".",
      allowedMenus: "Menús Permitidos",
      selectAll: "Seleccionar todos",
      kanbanBoards: "Flujos Kanban Permitidos",
      ownCardsOnly: "Kanban: mostrar solo las tarjetas creadas por el propio usuario",
      boardFallback: "Tablero #{{id}}",
      permissions: {
        view: "Ver",
        create: "Crear",
        edit: "Editar",
        delete: "Eliminar",
      },
      ticketFilters: "Filtros de Tickets",
      create: "Crear",
    },
    menus: {
      dashboard: "Tablero",
      ticketRatings: "Evaluaciones de Atención",
      tickets: "Tickets",
      ticketsFullHistory: "Tickets - Ver el historial completo del contacto",
      ticketsCall: "Tickets - Hacer y contestar llamadas",
      pendingMessages: "Mensajes Pendientes",
      ticketsConference: "Conferencia de Tickets",
      messagesReport: "Informe de Mensajes",
      monitoring: "Monitoreo",
      internalChat: "Chat Interno",
      flows: "Flujos",
      kanbanEditComments: "Kanban - Editar Comentarios",
      kanbanCardInactivityTime: "Kanban - Configurar Tiempo de Inactividad de las Tarjetas",
      quickMessages: "Respuestas Rápidas",
      documentTemplates: "Modelos de Documentos",
      contacts: "Contactos",
      usageReport: "Informe de Uso",
      customers: "Clientes",
      agenda: "Agenda",
      schedules: "Agendamientos",
      tags: "Etiquetas",
      tagPhrases: "Frases que generan Etiqueta",
      forbiddenWordsRegister: "Términos Prohibidos - Registro",
      forbiddenWordsReport: "Términos Prohibidos - Informe",
      development: "Desarrollo",
      campaigns: "Campañas",
      campaignsList: "Listado de Campañas",
      campaignsContactLists: "Campañas - Listas de Contactos",
      campaignsSettings: "Campañas - Configuraciones",
      announcements: "Anuncios",
      openai: "Open.ai",
      integrations: "Integraciones",
      connectionsView: "Conexiones - Solo visualizar",
      connectionsManage: "Conexiones - Gestionar (agregar, código QR, editar y eliminar)",
      messageTemplates: "Plantillas de Mensaje",
      catalog: "Catálogo de Productos",
      files: "Lista de Archivos",
      queues: "Colas y Chatbot",
      users: "Usuarios",
      api: "API",
      billing: "Financiero",
      profiles: "Perfiles de Usuario",
      settings: "Configuraciones",
      tasks: "Tareas",
      orders: "Pedidos",
      help: "Ayuda",
    },
    filters: {
      showAll: "Filtro: Todos (ver todos los tickets)",
      queues: "Filtro: Colas",
      whatsapps: "Filtro: WhatsApps",
      followupUser: "Filtro: Usuario (Follow-up)",
    },
  },
  queueOptions: {
    title: "Opciones",
    optionTitlePlaceholder: "Título de la opción",
    optionMessagePlaceholder: "Escribe el texto de la opción",
    untitled: "Título no definido",
  },
  facebookSdk: {
    errors: {
      loadFailed: "Error al cargar el SDK de Facebook",
      noAuthCode: "Facebook no devolvió un código de autorización. Verifica que la app esté configurada para 'response_type=code'.",
      loginCancelled: "Inicio de sesión cancelado o no autorizado por el usuario.",
      startFailed: "Error al iniciar Facebook Login",
    },
  },
  clienteQuickCreateModal: {
    title: "Nuevo Cliente",
    subtitle: "Registro rápido — completa los datos principales.",
    personTypes: {
      company: "Persona jurídica",
      individual: "Persona física",
    },
    fields: {
      legalName: "Razón social",
      nickname: "Apodo",
      areaCode: "Código de área",
    },
    sections: {
      contact: "Contacto",
      address: "Dirección",
      commercial: "Comercial",
      customFields: "Campos personalizados",
    },
    buttons: {
      create: "Crear Cliente",
    },
    toasts: {
      nameRequired: "Ingresa el nombre del cliente.",
      personTypeRequired: "Selecciona el tipo de persona.",
      missingFields: "Completa los campos obligatorios: {{fields}}",
      missingCustomFields: "Completa los campos personalizados obligatorios: {{fields}}",
      created: "¡Cliente creado con éxito!",
      networkUnstable: "No fue posible guardar el cliente ahora (conexión inestable). Intenta de nuevo en unos instantes.",
    },
  },
  clienteCustomFieldsForm: {
    selectPlaceholder: "Selecciona...",
  },
  forbiddenWords: {
    title: "Términos prohibidos",
    searchPlaceholder: "Buscar",
    table: {
      term: "Término",
      replacement: "Sustitución",
    },
    confirmationModal: {
      deleteTitle: "Eliminar término",
      deleteMessage: "¿Estás seguro de que deseas eliminar este término?",
    },
    toasts: {
      deleted: "Término eliminado con éxito.",
    },
    modal: {
      title: {
        add: "Agregar término",
        edit: "Editar término",
      },
      form: {
        term: "Término / palabra",
        replacement: "Sustitución sugerida (opcional)",
      },
      pluralHint: "Las palabras registradas también se reconocen en plural.",
      toasts: {
        saved: "Término guardado con éxito.",
      },
    },
  },
  forbiddenWordsReport: {
    title: "Informe de uso de términos prohibidos",
    fields: {
      term: "Término",
      user: "Agente",
      occurrences: "Ocurrencias",
      ticket: "Ticket",
    },
    total: "Total de ocurrencias en el período: {{total}}",
    byTerm: "Por término",
    byUser: "Por agente",
    details: "Detalle (últimas ocurrencias)",
    noOccurrences: "No hay ocurrencias en el período.",
  },
  tagPhrases: {
    title: "Frases que generan etiqueta",
    searchPlaceholder: "Buscar",
    fields: {
      phrase: "Frase",
      tag: "Etiqueta aplicada",
      match: "Coincidencia",
    },
    match: {
      exact: "Frase exacta",
      contains: "Contiene la frase",
    },
    status: {
      active: "Activa",
      inactive: "Inactiva",
    },
    confirmationModal: {
      deleteTitle: "Eliminar frase",
      deleteMessage: "¿Estás seguro de que deseas eliminar esta frase? Los contactos ya marcados conservan la etiqueta.",
    },
    toasts: {
      deleted: "Frase eliminada con éxito.",
    },
    modal: {
      title: {
        add: "Agregar frase",
        edit: "Editar frase",
      },
      hints: {
        exact: "La etiqueta se aplica cuando el mensaje del cliente es exactamente esta frase, sin nada más.",
        contains: "La etiqueta se aplica cuando el mensaje del cliente contiene esta frase, aunque esté junto a otro texto.",
        general: "En cualquiera de los modos se ignoran mayúsculas, minúsculas y acentos. La etiqueta se agrega al contacto y a la atención en la que llegó el mensaje, sin quitar las etiquetas que ya existan.",
      },
      toasts: {
        saved: "Frase guardada con éxito.",
      },
    },
  },
  pedidos: {
    title: "Pedidos",
    searchPlaceholder: "Buscar pedido...",
    buttons: {
      new: "Nuevo Pedido",
    },
    empty: "No se encontraron pedidos",
    itemsCount: "{{count}} ítem",
    itemsCount_plural: "{{count}} ítems",
    tooltips: {
      view: "Ver",
      delete: "Eliminar",
    },
    confirmationModal: {
      deleteTitle: "Eliminar Pedido",
      deleteMessage: "¿Estás seguro de que deseas eliminar este pedido? Esta acción no se puede deshacer.",
    },
    toasts: {
      deleted: "Pedido eliminado con éxito",
    },
    status: {
      pendente: "Pendiente",
      confirmado: "Confirmado",
      em_producao: "En Producción",
      enviado: "Enviado",
      entregue: "Entregado",
      cancelado: "Cancelado",
    },
    modal: {
      title: {
        add: "Nuevo Pedido",
        edit: "Editar Pedido",
      },
      sections: {
        orderData: "Datos del Pedido",
        items: "Ítems del Pedido",
        totals: "Totales",
      },
      fields: {
        client: "Cliente",
        orderDate: "Fecha del Pedido",
        deliveryDate: "Fecha de Entrega",
        orderType: "Tipo de Pedido",
        orderTypePlaceholder: "Ej.: Venta, Presupuesto, Servicio",
        paymentMethod: "Forma de Pago",
        paymentMethodPlaceholder: "Ej.: Contado, Tarjeta, Boleto bancario",
        subtotal: "Subtotal",
        discount: "Descuento",
        surcharge: "Recargo (Flete, Tasas)",
        total: "Valor Total",
      },
      items: {
        code: "Código",
        quantity: "Cant.",
        unit: "Unid.",
        unitPrice: "Valor Unit.",
      },
      buttons: {
        addItem: "Agregar Ítem",
        update: "Actualizar",
      },
      toasts: {
        minOneItem: "El pedido debe tener al menos un ítem",
        selectClient: "Selecciona un cliente",
        addItem: "Agrega al menos un ítem al pedido",
        fillDescriptions: "Completa la descripción de todos los ítems",
        updated: "Pedido actualizado con éxito",
        created: "Pedido creado con éxito",
      },
    },
  },
  solicitacoesDesenvolvimento: {
    title: "Desarrollo",
    count: "{{count}} solicitud",
    count_plural: "{{count}} solicitudes",
    filters: {
      search: "Búsqueda",
      searchPlaceholder: "Contacto, teléfono u observación",
    },
    empty: "No se encontraron solicitudes.",
    cardTitle: "#{{id}} - Ticket #{{ticketId}}",
    cardMeta: "Usuario: {{user}} | Creada el: {{date}}",
    noContact: "Sin contacto",
    noPhone: "Sin teléfono",
    noNotes: "Sin observación",
    toasts: {
      statusUpdated: "Estado actualizado con éxito.",
      contactNotResolved: "No fue posible identificar ni crear el contacto para abrir el chat.",
    },
    fields: {
      ticket: "Ticket",
      contact: "Contacto",
      notes: "Observación",
    },
    details: {
      title: "Detalles de la solicitud de desarrollo",
      loadError: "No fue posible cargar los detalles.",
      fullNotes: "Observación completa",
      createdAt: "Creada el",
      finalizedAt: "Finalizada el",
      lastMessages: "Últimos mensajes capturados",
      noTicket: "Ticket no disponible para cargar los mensajes.",
      noMarkedMessages: "No hay mensajes marcados en esta solicitud.",
    },
    preview: {
      title: "Validar solicitud de desarrollo",
      notesPlaceholder: "Describe la solicitud. Si la dejas vacía, usaremos la observación automática.",
      lastMessages: "Últimos 10 mensajes intercambiados",
      noMessages: "No se encontraron mensajes para este ticket.",
      sender: {
        system: "Sistema",
        agent: "Agente",
        customer: "Cliente",
      },
      media: "[multimedia]",
      confirm: "Confirmar y guardar",
    },
  },
  printPage: {
    noData: "No se encontraron datos.",
    sheetName: "Informe",
    fileName: "informe",
  },
  messageReceiptsModal: {
    noParticipants: "Ningún participante",
    statusLabel: "Estado del mensaje",
    status: {
      pending: "Pendiente",
      read: "Leído",
      delivered: "Entregado",
      sent: "Enviado",
    },
    summary: {
      read: "Leyeron",
      delivered: "Recibieron",
      played: "Escucharon",
      pending: "Pendientes",
    },
    tabs: {
      read: "Leyeron ({{count}})",
      delivered: "Recibieron ({{count}})",
      played: "Escucharon ({{count}})",
    },
  },
  cloudApiWindowBanner: {
    expired: "Expirado",
    windowOpen: "Ventana abierta: {{time}}",
    officialApi: "API Oficial",
    windowClosed: "Ventana de 24 h cerrada. Envía una plantilla para iniciar la conversación.",
    noApprovedTemplates: "Ninguna plantilla aprobada",
  },
  contactNotes: {
    toasts: {
      added: "¡Observación agregada con éxito!",
      deleted: "¡Observación eliminada con éxito!",
    },
    deleteModal: {
      title: "Eliminar registro",
      message: "¿Realmente deseas eliminar este registro?",
    },
  },
  contactSearchModal: {
    title: "Seleccionar contacto",
    searchLabel: "Buscar contacto",
  },
  queueSelectDialog: {
    title: "¿En qué cola abrir el ticket?",
  },
  forbiddenWordWarning: {
    title: "Atención al término utilizado",
    usingWord: "Estás usando la palabra",
    replaceWith: ", sustitúyela por",
    avoid: ". Evita usarla en los mensajes al cliente.",
    replace: "Sustituir",
    sendAnyway: "Enviar de todos modos",
  },
  commentThread: {
    reply: "Respuesta",
    mediaAttached: "[archivo multimedia adjunto]",
    title: "Hilo de comentarios — @{{username}}",
    post: "Publicación:",
    viewOnInstagram: "ver en Instagram",
    postId: "Publicación {{id}}",
    empty: "Aún no hay comentarios en este hilo.",
  },
  announcementsPopover: {
    referralText: "{{name}} hizo una recomendación para este cliente",
    dateUnavailable: "Fecha no disponible",
    announcementsDivider: "ANUNCIOS",
  },
  createKanbanCardModal: {
    toasts: {
      loadBoardsError: "Error al cargar los tableros Kanban",
      selectBoardAndColumn: "Selecciona un tablero y una columna",
      ticketNotFound: "Ticket no encontrado",
      requiredFieldsMissing: "Campos obligatorios sin completar: {{fields}}",
      cardCreated: "¡Tarjeta creada con éxito en el Kanban!",
    },
    followUpSource: "crear la tarjeta",
    duplicate: {
      withDetails: "Ya existe una tarjeta de este contacto: \"{{title}}\" (#{{id}}) en {{board}} / {{column}}{{createdBy}}.",
      untitled: "sin título",
      createdBy: ", creada por {{name}}",
      simple: "Ya existe una tarjeta de este contacto.",
      blockedHint: "Elige otro tablero u otra columna.",
      warnHint: "Haz clic en Crear Tarjeta para crearla de todos modos.",
    },
    info: {
      ticket: "Ticket:",
      contact: "Contacto:",
      number: "Número:",
      noName: "Sin nombre",
    },
    form: {
      title: "Título de la tarjeta",
      description: "Descripción de la tarjeta",
      descriptionRequired: "Obligatoria en este tablero",
      addDefaultDescription: "Agregar descripción predeterminada: \"{{description}}\"",
      client: "Cliente",
      clientPlaceholder: "Escribe para buscar un cliente...",
      clientNotFound: "No se encontró ningún cliente",
      newClient: "Crear nuevo cliente",
      board: "Tablero Kanban",
      selectBoard: "Selecciona un tablero",
      column: "Columna",
      selectColumn: "Selecciona una columna",
      boardFields: "Campos del tablero",
    },
    customField: {
      required: "Este campo es obligatorio",
      noOptions: "No hay opciones disponibles",
      selectAtLeastOne: "(selecciona al menos una opción)",
    },
  },
  imobilizadoAutocomplete: {
    availability: "{{available}} de {{total}} disponible(s)",
    noOptions: "No se encontró ningún activo",
    minChars: "Escribe al menos {{min}} letras para buscar",
    loading: "Buscando en Empsis...",
  },
  followUpPrompt: {
    title: "¿Crear un nuevo seguimiento?",
    question: "Después de {{source}}, ¿deseas crear un nuevo seguimiento ahora?",
    confirm: "Sí, crear",
    sources: {
      default: "esta acción",
      registerCliente: "registrar el cliente",
    },
    popupBlocked: {
      title: "Ventana emergente bloqueada",
      message: "El navegador bloqueó el panel de seguimientos. Haz clic en \"Intentar de nuevo\" para abrir la ventana.",
      tryAgain: "Intentar de nuevo",
    },
  },
  campaignReport: {
    title: "Informe de {{name}}",
    campaignFallback: "Campaña",
    statusLine: "Estado: {{status}} {{delivered}} de {{total}}",
    unnamedContact: "Contacto sin nombre",
    currentStatus: "Estado actual: {{status}}.",
    cards: {
      targetContacts: "Contactos objetivo",
      confirmationRequested: "Confirmaciones solicitadas",
      confirmed: "Confirmaciones",
      delivered: "Entregados",
      completedAt: "Conclusión",
    },
    sendStatuses: {
      success: "Éxito",
      error: "Error",
      waiting: "En espera",
    },
    table: {
      title: "Detalles de envío por contacto",
      ariaLabel: "detalles de envío de la campaña",
      contact: "Contacto",
      number: "Número",
      sendStatus: "Estado de envío",
      statusDescription: "Descripción del estado",
      empty: "No se encontraron registros de envío para esta campaña.",
    },
  },
  messagesReport: {
    title: "Informe de Mensajes",
    noUser: "Sin responsable",
    noQueue: "Sin cola",
    hint: "Los filtros son acumulativos; en \"Etiquetas del contacto\" se incluye la conversación cuyo contacto tenga cualquiera de las etiquetas elegidas. El agente es el responsable del ticket en el momento de la consulta; los mensajes enviados por otro operador aparecen bajo el responsable actual y, cuando está disponible, la firma de quien escribió se muestra en la columna Agente.",
    buttons: {
      clearFilters: "Limpiar filtros",
      exporting: "Exportando...",
    },
    filters: {
      term: "Término (mensaje o transcripción)",
      all: "Todas",
      sent: "Enviados",
      received: "Recibidos",
      user: "Agente (responsable del ticket)",
      typeMinChars: "Escribe al menos {{min}} caracteres",
      noContacts: "No se encontraron contactos",
      contactTags: "Etiquetas del contacto",
      queue: "Cola",
      whatsapp: "Conexión",
      includeDeleted: "Incluir eliminados",
    },
    totals: {
      total: "Total: {{value}}",
      received: "Recibidos: {{value}}",
      sent: "Enviados: {{value}}",
    },
    directionLabels: {
      sent: "Enviado",
      received: "Recibido",
    },
    table: {
      dateTime: "Fecha/Hora",
      direction: "Dirección",
      contact: "Contacto",
      user: "Agente",
      message: "Mensaje",
      queueConnection: "Cola / Conexión",
      inGroup: "en el grupo:",
      typedBy: "escribió:",
      openAtMessage: "Abrir la conversación en este mensaje",
      empty: "No se encontraron mensajes para los filtros seleccionados.",
    },
    export: {
      number: "Número",
      group: "Grupo",
      groupAuthor: "Autor (grupo)",
      signature: "Firma",
      queue: "Cola",
      whatsapp: "Conexión",
      transcription: "Transcripción",
      deleted: "Eliminado",
      ticket: "Ticket",
      fileName: "informe-mensajes-{{start}}-a-{{end}}",
      sheetName: "Mensajes",
    },
    pagination: {
      rowsPerPage: "Filas por página",
      displayedRows: "{{from}}-{{to}} de {{total}}",
    },
    toasts: {
      openFailed: "No fue posible abrir la conversación de este mensaje.",
      nothingToExport: "No hay mensajes para exportar con los filtros actuales.",
      exportLimited: "Exportación limitada a 5.000 mensajes. Ajusta el período o los filtros para exportar el resto.",
    },
  },
  tabAlert: {
    newMessage: "Nuevo mensaje",
    newMessages: "Nuevos mensajes",
  },
  templateCreditManager: {
    categories: {
      MARKETING: "Marketing",
      UTILITY: "Utilidad",
      AUTHENTICATION: "Autenticación",
    },
    txTypes: {
      purchase: "Recarga",
      manual_adjust: "Ajuste manual",
      debit: "Débito",
      refund: "Reembolso",
    },
    rates: {
      title: "Precios por categoría de plantilla",
      fieldLabel: "{{category}} (R$ por envío)",
      save: "Guardar precios",
      hint: "Precio 0 = envío sin cobro (incluso para empresas habilitadas). Define los precios antes de habilitar el cobro de las empresas.",
    },
    companies: {
      title: "Cobro de plantillas por empresa",
      billingEnabled: "Cobro habilitado",
      balance: "Saldo",
      companyDisabled: "(empresa desactivada)",
      adjustBalance: "Ajustar saldo",
      statement: "Extracto",
      empty: "No se encontraron empresas.",
    },
    adjustDialog: {
      title: "Ajustar saldo — {{name}}",
      hint: "Saldo actual: {{balance}}. Usa un valor negativo para quitar créditos.",
      amount: "Monto del ajuste (R$)",
      reason: "Motivo (obligatorio)",
      adjusting: "Ajustando...",
    },
    historyDialog: {
      title: "Extracto — {{name}}",
      category: "Categoría",
      template: "Plantilla",
      source: "Origen",
      amount: "Monto",
      balanceAfter: "Saldo posterior",
      empty: "No hay movimientos registrados.",
    },
    toasts: {
      ratesSaved: "Precios actualizados.",
      balanceAdjusted: "Saldo ajustado.",
    },
  },
  aiCreditManager: {
    topupStatus: {
      awaiting_payment: "Esperando pago",
      pending: "Procesando",
      credited: "Acreditado",
      failed: "Falló",
      cancelled: "Cancelada",
      reversed: "Reembolsada",
      reversalPending: "Reembolso pendiente",
      reversedAmount: "reembolsado {{amount}}",
    },
    toasts: {
      hubSyncError: "Guardado en el CRM, pero iaHub no se actualizó (el margen y el aviso de saldo siguen como estaban): {{error}}",
      settingsSaved: "Configuración de créditos de IA guardada.",
      billingEnabled: "Cobro de IA activado (prepago).",
      billingDisabled: "Cobro de IA desactivado (cortesía).",
      linkUpdated: "Vínculo con iaHub actualizado.",
      topupCredited: "Recarga acreditada en iaHub.",
      topupNotAccepted: "iaHub todavía no aceptó la recarga.",
    },
    confirmLinkChange: {
      defaultDetails: "La empresa anterior en iaHub tiene saldo comprado.",
      message: "Ese saldo se queda en la empresa anterior (que vuelve a cortesía) y las próximas recargas irán a la nueva. ¿Cambiar de todos modos?",
    },
    alerts: {
      notConfigured: "<strong>iaHub no está configurado en este entorno.</strong> Define <code>AI_HUB_BASE_URL</code> y <code>AI_HUB_RESELLER_KEY</code> en el .env del backend — sin ellas no es posible vincular empresas ni acreditar recargas.",
      zeroMarkup: "<strong>Margen en 0%.</strong> El revendedor {{name}} no tiene margen en iaHub: el consumo de IA de los clientes se está cobrando a precio de costo. Define el margen por llamada abajo.",
      outOfSync: "El límite de aviso de saldo o la URL de notificación del revendedor en iaHub son distintos de este CRM. Haz clic en <strong>Guardar</strong> para sincronizar.",
      hubError: "No fue posible comunicarse con iaHub ahora: {{error}}",
    },
    settings: {
      title: "Cobro de IA de este entorno",
      titleWithReseller: "Cobro de IA de este entorno — revendedor {{name}}",
      markup: "Margen por llamada (%)",
      minCredit: "Crédito mínimo",
      maxCredit: "Crédito máximo",
      lowBalanceAlert: "Avisar por debajo de (R$)",
      hint: "La recarga es 1:1: {{amount}} pagados se convierten en {{amount}} de crédito. El margen se suma al costo de la API en cada llamada de IA y queda guardado en el revendedor de iaHub — el cliente no lo ve.",
      hintWithReseller: "La recarga es 1:1: {{amount}} pagados se convierten en {{amount}} de crédito. El margen se suma al costo de la API en cada llamada de IA y queda guardado en el revendedor {{name}} de iaHub — el cliente no lo ve.",
      noReseller: "Sin conexión con iaHub, el margen no se puede leer ni modificar.",
    },
    pending: {
      title: "Recargas y reembolsos que no llegaron a iaHub",
      hint: "El dinero entró y el crédito no salió — o el pago fue reembolsado y el crédito sigue ahí. El sistema reenvía automáticamente cada hora; usa el botón para forzarlo ahora.",
      status: "Situación",
      credit: "Crédito",
      attempts: "Intentos",
      action: "Acción",
      resend: "Reenviar",
      resending: "Enviando...",
    },
    companies: {
      title: "Empresas",
      hint: "Activado = prepago (el cliente recarga y la IA se detiene cuando el saldo llega a cero). Desactivado = cortesía (la casa paga; el consumo se mide, pero nunca se bloquea).",
      billing: "Cobro",
      balance: "Saldo",
      updatedAt: "Actualizado",
      prepaid: "Prepago",
      courtesy: "Cortesía",
      agentOtherCompany: "\"{{prompts}}\" usa un agente de \"{{company}}\" — el consumo se descuenta allí",
      agentMissing: "\"{{prompts}}\" usa un agente inexistente en este revendedor",
      notLinked: "no vinculada",
      blocked: "bloqueada",
      link: "Vincular",
      empty: "No se encontraron empresas.",
    },
    hubCompany: "Empresa en iaHub",
    linkDialog: {
      title: "Vincular {{name}} a iaHub",
      noLink: "Sin vínculo",
      notConfirmed: "(no confirmada)",
      agentOwner: "dueña del agente de esta empresa",
      hint: "La recarga de esta empresa acredita el saldo de la empresa elegida aquí, y el hub descuenta el consumo de la empresa dueña del agente — para cobrar, ambas deben ser la misma.",
      noAgents: "Esta empresa no tiene prompts con agentes de este iaHub.",
      agentOf: "\"{{prompts}}\": agente de \"{{company}}\"",
      agentOfUnknown: "\"{{prompts}}\": agente de una empresa no encontrada en este revendedor",
      saveLink: "Guardar vínculo",
      saveAndCharge: "Guardar y cobrar",
    },
  },
  clienteCustomFieldsManager: {
    types: {
      text: "Texto",
      number: "Número",
      date: "Fecha",
      select: "Selección única",
      multiselect: "Selección múltiple",
      checkbox: "Casilla de verificación",
      textarea: "Área de texto",
      email: "Correo electrónico",
      phone: "Teléfono",
      cpf: "CPF",
      cnpj: "CNPJ",
      cep: "CEP",
    },
    addButton: "Agregar campo personalizado",
    table: {
      order: "Orden",
      label: "Etiqueta",
      fieldName: "Nombre del campo",
      inReport: "En el informe",
    },
    dialog: {
      editTitle: "Editar campo personalizado",
      newTitle: "Nuevo campo personalizado",
      fieldLabel: "Etiqueta del campo (como aparecerá en el formulario)",
      fieldName: "Nombre del campo (identificador interno)",
      fieldNameHelper: "Se convertirá automáticamente a un formato válido",
      fieldType: "Tipo de campo",
      orderIndex: "Orden de visualización",
      options: "Opciones (separadas por coma)",
      optionsHelper: "Ej.: Opción 1, Opción 2, Opción 3",
      defaultValue: "Valor predeterminado",
      required: "Campo obligatorio",
      includeInReport: "Incluir este campo en el informe de clientes",
    },
    confirmDelete: "¿Seguro que deseas eliminar este campo?",
    toasts: {
      loadError: "Error al cargar los campos personalizados",
      nameAndLabelRequired: "El nombre y la etiqueta son obligatorios",
      updated: "Campo actualizado correctamente",
      created: "Campo creado correctamente",
      saveError: "Error al guardar el campo personalizado",
      deleted: "Campo eliminado correctamente",
      deleteError: "Error al eliminar el campo",
    },
  },
  management: {
    restricted: "Esta pantalla está restringida al administrador de la plataforma.",
    tabs: {
      billing: "Facturación",
      usage: "Uso del sistema",
    },
  },
  billingManager: {
    tabs: {
      companies: "Por empresa",
      statement: "Estado de cuenta",
    },
    all: "Todas",
    companyDisabled: "(empresa desactivada)",
    notDueYet: "Por vencer",
    days: "{{count}} día",
    days_plural: "{{count}} días",
    daysOverdue: "{{count}} día de atraso",
    daysOverdue_plural: "{{count}} días de atraso",
    subscriptionStatus: {
      active: "Activa",
      paymentFailed: "Cobro fallido",
      cancelled: "Cancelada",
      paused: "Pausada",
      pending: "Pendiente",
    },
    paymentStatus: {
      approved: "Recibido",
      pending: "En espera",
      rejected: "Rechazado",
      cancelled: "Cancelado",
      refunded: "Reembolsado",
    },
    methods: {
      creditCard: "Tarjeta",
      other: "Otros",
    },
    types: {
      oneTime: "Único",
      recurring: "Suscripción",
    },
    columns: {
      plan: "Plan",
      dueDate: "Vencimiento",
      status: "Situación",
      subscription: "Suscripción",
      lastCharge: "Último cobro",
      lastPayment: "Último pago",
      method: "Método",
      value: "Monto",
      balance: "Saldo",
      periodBalance: "Saldo del período",
      mpPaymentId: "ID de Mercado Pago",
      origin: "Origen",
      daysOverdue: "Días de atraso",
      entries: "Movimientos",
      cardShare: "% del total",
    },
    origin: {
      invoice: "Factura",
      invoiceNumber: "Factura #{{id}}",
      companyDueDate: "Vencimiento de la empresa",
    },
    companies: {
      title: "Facturación de las empresas",
      filter: "Filtro",
      filters: {
        overdue: "Vencidas",
        blocked: "Bloqueadas",
        subscriptionActive: "Suscripción activa",
        subscriptionFailed: "Suscripción con fallo",
      },
      showInactive: "Ver inactivas ({{total}})",
      perMonth: "{{value}}/mes",
      situation: {
        blocked: "Bloqueada",
        gracePeriod: "En período de gracia",
        upToDate: "Al día",
      },
      amountDiverges: "Suscripción en {{subscriptionAmount}} pero el plan cuesta {{planAmount}} — el suscriptor mantiene el valor anterior hasta volver a suscribirse",
      lastCharge: {
        approved: "aprobado",
        rejected: "rechazado",
      },
      paymentStatus: {
        approved: "Aprobado",
        rejected: "Rechazado",
        pending: "Pendiente",
        cancelled: "Cancelado",
        refunded: "Reembolsado",
      },
      empty: "No se encontraron empresas para el filtro seleccionado.",
    },
    detail: {
      fileFallback: "detalle",
      entries: "{{count}} movimiento",
      entries_plural: "{{count}} movimientos",
      clients: "{{count}} cliente",
      clients_plural: "{{count}} clientes",
      empty: "Ningún movimiento compone este valor.",
      byClient: "Por cliente",
      details: "Detalles",
    },
    statement: {
      periods: {
        thisMonth: "Este mes",
        lastMonth: "Mes pasado",
        last7: "Últimos 7 días",
        last30: "Últimos 30 días",
        thisYear: "Este año",
        custom: "Personalizado",
      },
      cardHint: "haz clic para ver el desglose",
      periodRange: "{{start}} al {{end}}",
      periodSubtitle: "Período del {{period}}",
      currentPositionSubtitle: "Posición actual — independiente del período filtrado",
      export: {
        period: "{{start}}_a_{{end}}",
        statementFile: "estado_de_cuenta",
        receivablesFile: "por_cobrar",
      },
      period: "Período",
      cards: {
        received: {
          title: "Recibido en el período",
          caption: "{{total}} pago(s) — {{period}}",
        },
        awaiting: {
          title: "Esperando pago",
          caption: "{{total}} cobro(s) generado(s) y no pagado(s)",
        },
        pending: {
          title: "Por vencer (por cobrar)",
          caption: "{{total}} factura(s) abierta(s) — posición actual",
        },
        overdue: {
          title: "Vencido",
          caption: "{{total}} cobro(s) vencido(s) — posición actual",
        },
      },
      failedSummary: "{{total}} intento(s) rechazado(s) en el período, que suman {{amount}}.",
      failedTitle: "Intentos rechazados",
      viewWhich: "Ver cuáles",
      tabs: {
        statement: "Estado de cuenta del período",
        pending: "Por vencer ({{total}})",
        overdue: "Vencidos ({{total}})",
      },
      statusFilter: {
        approved: "Solo recibidos",
        all: "Todas las transacciones",
        pending: "En espera",
        rejected: "Rechazados",
        refunded: "Reembolsados",
      },
      order: "Orden",
      orderOptions: {
        asc: "Más antiguos primero",
        desc: "Más recientes primero",
      },
      totalShown: "Total mostrado ({{count}} movimiento)",
      totalShown_plural: "Total mostrado ({{count}} movimientos)",
      noTransactions: "No hay transacciones en el período seleccionado.",
      dueFilter: {
        all: "Todas (posición actual)",
        period: "Solo las que vencen en el período",
      },
      estimatedValue: "valor estimado según la composición del plan",
      totalCharges: "Total ({{count}} cobro)",
      totalCharges_plural: "Total ({{count}} cobros)",
      nothingOverdue: "Nada vencido en el filtro seleccionado.",
      nothingPending: "Nada por vencer en el filtro seleccionado.",
    },
  },
  companyStorage: {
    title: "Almacenamiento de archivos",
    subtitle: "Espacio en disco ocupado por los archivos de cada empresa. No depende del período filtrado.",
    column: "Almacenamiento",
    diskTotal: "Total en disco",
    attributed: "Asignado a las empresas",
    unattributed: "Sin vínculo",
    files: "{{count}} archivo",
    files_plural: "{{count}} archivos",
    attributedHint: "Los archivos usados por más de una empresa (como las fotos de perfil) cuentan en el total de cada una, pero aquí solo una vez.",
    unattributedHint: "Archivos en el disco a los que ningún registro de la base de datos apunta, por lo que no se sabe de qué empresa son (p. ej.: la copia del archivo subido en envíos por WhatsApp, audio convertido, medios de mensajes eliminados).",
    updatedAt: "Actualizado el {{date}}",
    neverCalculated: "Aún no calculado. Haz clic en Recalcular.",
    running: "Calculando...",
    runningHint: "El cálculo se ejecuta en segundo plano y puede tardar unos minutos.",
    refresh: "Recalcular",
    refreshStarted: "Cálculo iniciado. La pantalla se actualiza sola al terminar.",
    lastError: "El último cálculo falló: {{error}}",
    ranking: "Empresas que más espacio ocupan",
    rankingShowing: "{{shown}} de {{total}} empresas con archivos",
    noFiles: "Ningún archivo",
    loadError: "No se pudo cargar el almacenamiento.",
    categories: {
      messages: "Mensajes",
      profilePics: "Fotos de perfil",
      quickMessages: "Respuestas rápidas",
      internalChat: "Chat interno",
      campaigns: "Campañas y agendamientos",
      others: "Otros",
    },
  },
  clientUsageManager: {
    health: {
      ativo: "Activo",
      atencao: "Atención",
      inativo: "Inactivo",
    },
    periods: {
      last7: "Últimos 7 días",
      last30: "Últimos 30 días",
      last90: "Últimos 90 días",
      custom: "Personalizado",
    },
    situations: {
      todos: "Todas las situaciones",
      ativo: "Activos",
      atencao: "Atención",
      inativo: "Inactivos",
    },
    idle: {
      never: "nunca lo usó",
      today: "hoy",
    },
    dueDate: {
      none: "sin vencimiento",
      due: "vence el {{date}}",
    },
    search: "Buscar cliente",
    volumePeriod: "Período del volumen",
    situation: "Situación",
    showDisabled: "Ver desactivadas ({{total}})",
    clearFilters: "Limpiar filtros",
    legend: "Situación: verde hasta 2 días sin actividad, amarillo de 3 a 7, rojo más de 7 — cuenta la actividad más reciente entre mensajes e inicio de sesión. En \"tickets\", el par es abiertos/finalizados en el período.",
    columns: {
      client: "Cliente",
      lastMessage: "Último mensaje",
      lastLogin: "Último inicio de sesión",
      connections: "Conexiones",
      users: "Usuarios",
      volume: "Volumen en el período",
      plan: "Plan",
    },
    companyDisabled: "empresa desactivada",
    since: "desde {{date}}",
    contacts: "{{total}} contactos",
    sentAt: "{{date}} env.",
    receivedAt: "{{date}} rec.",
    loginEstimated: "Estimado: este usuario aún no ha iniciado sesión desde que se creó el registro de inicio de sesión.",
    noUser: "ningún usuario",
    connectionsCaption: "límite {{limit}} · {{drops}} caídas",
    noConnection: "sin conexión",
    usersCaption: "{{active}} activos 30d · {{online}} on",
    volumeLine: "{{sent}} env · {{received}} rec",
    ticketsCaption: "tickets {{created}}/{{finished}} · {{active}} abiertos",
    noPlan: "sin plan",
    empty: "No se encontraron clientes para el filtro seleccionado.",
  },
  financeiro: {
    paymentStatus: {
      approved: "Aprobado",
      pending: "Pendiente",
      rejected: "Rechazado",
      cancelled: "Cancelado",
      refunded: "Reembolsado",
    },
    invoiceStatus: {
      paid: "Pagada",
      overdue: "Vencida",
      open: "Abierta",
    },
    toasts: {
      chargeFailed: "El cobro de tu suscripción falló: {{reason}}",
      subscriptionCancelled: "Suscripción cancelada. Tu licencia sigue siendo válida hasta el vencimiento actual.",
    },
    license: {
      unavailable: "Estado de la licencia no disponible",
      noExpiration: "Licencia activa, sin vencimiento",
      overdue: "Licencia vencida hace {{count}} día",
      overdue_plural: "Licencia vencida hace {{count}} días",
      overdueDetail: "Venció el {{date}}. Paga la mensualidad para seguir usando el sistema.",
      dueToday: "La licencia vence hoy",
      dueDate: "Vencimiento: {{date}}",
      dueIn: "La licencia vence en {{count}} día",
      dueIn_plural: "La licencia vence en {{count}} días",
      upToDate: "Licencia al día",
      validUntil: "Válida hasta el {{date}}",
    },
    cancelModal: {
      title: "¿Cancelar la suscripción automática?",
      message: "Se cancelará el cobro mensual automático en tu tarjeta. Tu licencia sigue siendo válida hasta el vencimiento actual y podrás hacer pagos únicos (Pix o tarjeta) cuando quieras.",
    },
    plan: "Plan",
    planNamed: "Plan {{name}}",
    perMonth: "{{value}}/mes",
    autoRenewActive: "Renovación automática activa",
    monthlyCardDebit: "Cargo mensual en la tarjeta.",
    monthlyCardDebitEmail: "Cargo mensual en la tarjeta ({{email}}).",
    cancelRenewal: "Cancelar renovación",
    lastChargeDeclined: "El último cobro en la tarjeta fue rechazado y la licencia no se renovó. Paga la mensualidad abajo (Pix o tarjeta).",
    regularizeNow: "Regularizar ahora",
    payMonthlyFee: "Pagar mensualidad",
    pixOrCard: "Pix o tarjeta de crédito",
    preferAutoRenew: "Prefiero activar la renovación automática en la tarjeta →",
    nothingToDo: "Nada que hacer — tu licencia se renueva sola cada mes.",
    managePlan: "Administrar plan — usuarios y conexiones adicionales, cambio de plan",
    changePlan: "Cambiar de plan",
    invoicesAndHistory: "Facturas e historial de pagos",
    invoicesAndHistoryOpen: "Facturas e historial de pagos ({{count}} abiertas)",
    invoices: "Facturas",
    table: {
      details: "Detalles",
      value: "Valor",
      dueDate: "Fecha venc.",
      action: "Acción",
      method: "Método",
    },
    pay: "PAGAR",
    paid: "PAGADA",
    loadMoreInvoices: "Cargar más facturas",
    paymentHistory: "Historial de pagos",
    noPayments: "Aún no hay pagos registrados.",
    paymentType: {
      recurring: "Suscripción",
      oneTime: "Único",
    },
    paymentMethod: {
      creditCard: "Tarjeta de crédito",
    },
  },
  subscription: {
    title: "Suscripción",
    licenseValidity: "Validez de la licencia",
    validUntil: "Tu licencia es válida hasta el {{date}}",
    noExpiration: "Sin vencimiento definido",
    billingEmail: "Correo de facturación",
    subscribeNow: "¡Suscríbete ahora!",
  },
  checkout: {
    statusDetail: {
      insufficientAmount: "La tarjeta no tiene límite disponible.",
      badCardNumber: "Número de tarjeta inválido.",
      badDate: "Fecha de vencimiento inválida.",
      badSecurityCode: "Código de seguridad inválido.",
      badOther: "Datos de la tarjeta inválidos.",
      callForAuthorize: "El banco solicitó autorización — llama al emisor de la tarjeta.",
      cardDisabled: "Tarjeta desactivada — contacta al emisor.",
      duplicatedPayment: "Se detectó un pago duplicado.",
      highRisk: "Pago rechazado por el análisis antifraude.",
      maxAttempts: "Se alcanzó el límite de intentos — intenta más tarde.",
      otherReason: "Pago rechazado por el emisor de la tarjeta.",
      default: "Pago rechazado. Verifica los datos o intenta con otra tarjeta.",
    },
    brickErrors: {
      cardNumberEmpty: "Ingresa el número de la tarjeta.",
      cardNumberIncomplete: "Número de tarjeta incompleto.",
      cardNumberInvalid: "Tarjeta inválida — revisa el número ingresado.",
      expirationDateEmpty: "Ingresa la fecha de vencimiento de la tarjeta.",
      expirationDateIncomplete: "Fecha de vencimiento incompleta.",
      expirationDateInvalid: "Fecha de vencimiento inválida.",
      securityCodeEmpty: "Ingresa el código de seguridad.",
      securityCodeIncomplete: "Código de seguridad incompleto.",
      securityCodeInvalid: "Código de seguridad inválido.",
      cardholderNameEmpty: "Ingresa el nombre del titular como aparece en la tarjeta.",
      emailEmpty: "Ingresa el correo electrónico.",
      emailInvalid: "Correo electrónico inválido.",
      identificationNumberEmpty: "Ingresa el CPF/CNPJ del titular.",
      identificationNumberInvalid: "CPF/CNPJ inválido.",
      identificationTypeEmpty: "Selecciona el tipo de documento.",
      paymentMethodNotFound: "No reconocemos la marca de esta tarjeta.",
      installmentsEmpty: "Selecciona el número de cuotas.",
      critical: "No se pudo procesar el formulario de pago. Recarga la página e intenta de nuevo.",
      generic: "Datos de la tarjeta inválidos. Revisa la información e intenta de nuevo.",
    },
    title: {
      templateCredit: "Comprar créditos de plantilla",
      aiCredit: "Comprar créditos de IA",
      addon: "Pagar add-ons del plan",
      renewal: "Renovar licencia",
    },
    hint: {
      templateCredit: "Pix o tarjeta de crédito — los créditos se suman a tu saldo en cuanto se apruebe el pago",
      aiCredit: "Pix o tarjeta de crédito — los créditos de IA se suman a tu saldo en cuanto se apruebe el pago",
      addon: "Pix o tarjeta de crédito — habilita los add-ons contratados hasta el final del ciclo",
      renewal: "Pix o tarjeta de crédito — renueva tu licencia por 1 mes",
    },
    toasts: {
      approvedTemplateCredit: "¡Pago aprobado! Tus créditos de plantilla fueron agregados.",
      approvedAiCredit: "¡Pago aprobado! Tus créditos de IA fueron agregados.",
      approvedAddon: "¡Pago aprobado! Tus add-ons fueron habilitados.",
      approvedRenewal: "¡Pago aprobado! Tu licencia fue renovada.",
      processing: "Pago en proceso. Te avisaremos cuando se confirme.",
      subscriptionActivated: "¡Suscripción activada! La renovación se hará automáticamente cada mes en tu tarjeta.",
    },
    pixUnavailableSupport: "El pago con Pix no está disponible en este momento. Contacta al soporte para regularizar la mensualidad.",
    pixUnavailableCard: "El pago con Pix no está disponible en este momento. Completa el pago con tarjeta de crédito en el formulario de abajo.",
    brickBlocked: "Tu navegador bloqueó el formulario de tarjeta de Mercado Pago (bloqueador de anuncios o protección contra rastreo). Desactiva la extensión para esta página y recarga para pagar con tarjeta.",
    unavailableTitle: "Pago no disponible",
    missingPublicKey: "La clave pública de Mercado Pago (REACT_APP_MP_PUBLIC_KEY) no está configurada. Contacta al soporte.",
    tabs: {
      payInvoice: "Pagar factura",
      autoSubscription: "Suscripción automática",
    },
    invoiceError: "No se pudo generar la factura de renovación para esta empresa. Verifica el plan contratado o contacta al soporte.",
    noOpenInvoice: "No hay facturas abiertas para pagar.",
    invoiceDue: "{{detail}} — vencimiento {{date}}",
    payWithPix: "Pagar con Pix (código QR)",
    subscriptionActiveChip: "Suscripción activa",
    subscriptionAlreadyActive: "Tu suscripción ya está activa en la tarjeta. La renovación es automática cada mes. Para cambiar de tarjeta, cancela la suscripción en la pantalla Financiero y vuelve a suscribirte.",
    subscriptionAlreadyActiveEmail: "Tu suscripción ya está activa en la tarjeta ({{email}}). La renovación es automática cada mes. Para cambiar de tarjeta, cancela la suscripción en la pantalla Financiero y vuelve a suscribirte.",
    autoDebit: "Cargo mensual automático en la tarjeta de crédito",
    autoDebitPlan: "Cargo mensual automático en la tarjeta de crédito — plan {{plan}}",
    perMonth: "{{value}}/mes",
    autoRenewInfo: "Cuando Mercado Pago confirme el cargo, tu licencia se renueva sola. Cancela cuando quieras.",
    payPixMeanwhile: "Mientras tanto, puedes pagar la factura de este mes con Pix en la pestaña \"{{tab}}\".",
    noPlanValue: "La empresa no tiene un plan con valor definido — contacta al soporte.",
    success: {
      licenseRenewed: "¡Tu licencia fue renovada hasta el {{date}}!",
      qrAlt: "Código QR de Pix",
      copied: "Copiado",
      copyPixCode: "Copiar código Pix",
      instructions: "Para finalizar, solo realiza el pago escaneando o pegando el código Pix de arriba :)",
    },
  },
  changePlanDialog: {
    changed: "Plan cambiado a {{plan}}. El nuevo valor se aplica a partir de la próxima renovación.",
    title: "Cambiar de plan",
    currentPlan: "Plan actual:",
    perMonth: "{{value}}/mes",
    newPlan: "Nuevo plan",
    planOption: "{{name}} — {{value}}/mes ({{users}} usuarios, {{connections}} conexiones)",
    newValueNote: "El período ya pagado continúa hasta el vencimiento actual. A partir de la próxima renovación, el valor pasa a ser",
    autoDebitUpdate: "El cargo automático en tu tarjeta se actualizará al nuevo valor — no necesitas volver a registrar la tarjeta.",
    confirm: "Confirmar cambio",
  },
  planAddons: {
    changeStatus: {
      pendingPayment: "Esperando el pago del prorrateo",
      applying: "Aplicando...",
      scheduled: "Reducción programada para el próximo ciclo",
      requiresNewCard: "Esperando que se vuelva a registrar la tarjeta",
    },
    toasts: {
      addonsApplied: "¡Add-ons contratados y habilitados!",
      payProrata: "Paga el prorrateo para habilitar los add-ons. Abriendo el pago...",
      downgradeScheduled: "Reducción programada: el valor y los límites actuales se mantienen hasta el final del ciclo.",
      requestCancelled: "Cambio pendiente cancelado.",
      subscriptionMigrated: "¡Suscripción migrada con éxito! Se aplicaron los cambios pendientes.",
    },
    unitPrice: "({{value}}/mes cada uno)",
    title: "Mi plan",
    planChip: "{{description}} — {{value}}/mes",
    limits: "Límites: {{users}} usuario(s) ({{usersInUse}} en uso) · {{connections}} conexión(es) ({{connectionsInUse}} en uso)",
    extraUsers: "Usuario(s) adicional(es)",
    extraConnections: "Conexión(es) adicional(es)",
    pending: {
      users: "{{count}} usuario",
      users_plural: "{{count}} usuarios",
      connections: "{{count}} conexión",
      connections_plural: "{{count}} conexiones",
      usersAndConnections: "{{users}} y {{connections}}",
      upgrade: "Adición de {{items}}",
      downgrade: "Reducción de {{items}}",
      newMonthlyFee: "nueva mensualidad {{value}}",
      effectiveFrom: "a partir del {{date}}",
      prorata: "(prorrateo: {{value}})",
    },
    payProrata: "Pagar prorrateo",
    replaceCard: "Volver a registrar la tarjeta",
    simulation: {
      newMonthlyFee: "Nueva mensualidad:",
      prorataNow: "Para habilitar ahora, paga el proporcional del {{count}} día restante del ciclo:",
      prorataNow_plural: "Para habilitar ahora, paga el proporcional de los {{count}} días restantes del ciclo:",
      noChargeNow: "Sin cobro ahora — los add-ons se habilitan al instante y el nuevo valor se aplica en la próxima renovación.",
      hireAndPay: "Contratar y pagar {{value}}",
      hireAddons: "Contratar add-ons",
      newMonthlyNextCycle: "Nueva mensualidad a partir del próximo ciclo:",
      noRefund: "(sin reembolso del período actual)",
      usageWarning: "Atención: el nuevo límite queda por debajo del uso actual — no se eliminará nada, pero se bloqueará la creación de nuevos elementos.",
      scheduleReduction: "Programar reducción",
    },
    undo: "Deshacer",
    replaceDialog: {
      title: "Volver a registrar la tarjeta de la suscripción",
      description: "Tu suscripción actual se creó con el modelo antiguo de Mercado Pago y no permite cambiar el valor. Registra la tarjeta para que creemos la nueva suscripción de {{value}}/mes — la antigua se cancela automáticamente, sin cobro duplicado.",
    },
  },
  templateCredit: {
    categories: {
      marketing: "Marketing",
      utility: "Utilidad",
      authentication: "Autenticación",
    },
    txTypes: {
      purchase: "Recarga",
      manualAdjust: "Ajuste",
      debit: "Débito",
      refund: "Reembolso",
    },
    title: "Créditos de plantilla (API oficial)",
    ratesIntro: "Cada envío de plantilla descuenta el valor de la categoría:",
    ratesUndefined: "precios aún no definidos",
    otherValue: "Otro valor",
    generating: "Generando...",
    buy: "Comprar créditos",
    showStatement: "Ver extracto",
    hideStatement: "Ocultar extracto",
    table: {
      template: "Plantilla",
      value: "Valor",
      balanceAfter: "Saldo después",
    },
    noMovements: "No hay movimientos registrados.",
  },
  aiCredit: {
    topupStatus: {
      awaitingPayment: "Esperando pago",
      pending: "Procesando",
      credited: "Acreditado",
      failed: "En verificación",
      cancelled: "Cancelada",
      reversed: "Reembolsada",
      withReversal: "{{label}} (reembolsado {{value}})",
    },
    title: "Créditos de IA",
    monthUsage: "{{calls}} interacciones de la IA este mes · {{value}} consumidos",
    consumptionInfo: "El saldo se consume según el uso del agente de IA.",
    stale: "(saldo de la última sincronización)",
    blockedTitle: "IA pausada por falta de saldo.",
    blockedHint: "Recarga para que el agente vuelva a responder.",
    lowBalance: "Saldo bajo. Al llegar a cero, el agente de IA deja de responder.",
    otherCreditValue: "Otro valor de crédito",
    generating: "Generando...",
    buy: "Comprar créditos",
    showUsage: "Ver consumo",
    hideUsage: "Ocultar consumo",
    usageByDay: "Consumo por día",
    table: {
      day: "Día",
      interactions: "Interacciones",
      consumption: "Consumo",
      status: "Situación",
      credit: "Crédito",
      paid: "Pagado",
    },
    noUsage: "No hay consumo en el período.",
    topups: "Recargas",
    noTopups: "No hay recargas registradas.",
  },
  attendanceMonitor: {
    title: "Monitoreo de atenciones",
    subtitle: "Medianas de espera y atención: mes actual hasta hoy",
    alarmsOn: "Alarmas: ON ({{minutes}} min)",
    alarmsOff: "Alarmas: OFF",
    autoRefreshOn: "Actualización automática: ON",
    autoRefreshOff: "Actualización automática: OFF",
    toasts: {
      loadError: "Error al cargar los datos de monitoreo",
      alarmsEnabled: "Alarmas activadas",
      alarmsDisabled: "Alarmas desactivadas",
      alarmsUpdateError: "Error al actualizar el estado de las alarmas",
      openTicketError: "Error al abrir la conversación",
    },
    summary: {
      queues: "Colas",
      waiting: "Esperando",
      attendants: "Agentes",
      online: "En línea",
      offline: "Desconectados",
      inService: "En atención",
      medianWait: "Mediana de espera",
      medianService: "Mediana de atención",
    },
    tabs: {
      inService: "En atención",
      waiting: "Esperando",
      all: "Todos",
      online: "En línea",
      offline: "Desconectados",
    },
    search: {
      attendantOrQueue: "Buscar agente o cola",
      queue: "Buscar cola",
      attendant: "Buscar agente",
    },
    alarmTickets: "Atenciones en alarma ({{total}})",
    sections: {
      queues: "Colas",
      attendants: "Agentes",
    },
    queueBadge: "Cola",
    emptyQueue: "No hay atenciones abiertas para esta cola.",
    emptyAttendant: "No hay atenciones abiertas para este agente.",
    waitingTooltip: "Tiempo esperando respuesta",
    queueTotal: "Total de atenciones en la cola:",
    attendantTotal: "Total de atenciones abiertas:",
    noQueues: "No se encontró ninguna cola",
    noAttendants: "No se encontró ningún agente",
    status: {
      online: "En línea",
      offline: "Desconectado",
    },
  },
  usageReport: {
    title: "Informe de uso del sistema",
    tabs: {
      general: "General",
      forwarding: "Reenvíos",
    },
    filters: {
      profile: "Perfil",
      user: "Usuario",
      senderUser: "Usuario de origen",
      receiverUser: "Usuario de destino",
      historyType: "Tipo de historial",
    },
    profiles: {
      admin: "Administrador",
    },
    buttons: {
      printGeneral: "Imprimir general",
      printDetailed: "Imprimir detallado",
      printForwarding: "Imprimir reenvíos",
    },
    periodLabel: "Período: {{period}}",
    periodRange: "{{from}} a {{to}}",
    invalidPeriod: "Período inválido",
    generatedAt: "Generado el: {{date}}",
    toasts: {
      invalidDates: "Ingresa fechas válidas en el formato correcto",
      dateRange: "La fecha inicial no puede ser posterior a la fecha final",
      detailsError: "Error al cargar los detalles de las relaciones",
      usersError: "Error al cargar la lista de usuarios",
      reportError: "Error al cargar el informe de uso del sistema",
      forwardingError: "Error al cargar el informe de reenvíos",
      detailedPrintError: "Error al generar la impresión detallada",
    },
    columns: {
      user: "Usuario",
      registrations: "Registros",
      totalContacts: "Total de contactos",
      orders: "Pedidos",
    },
    clickForDetails: "Haz clic para ver los detalles de {{type}}",
    chart: {
      contactsByUserType: "Contactos por usuario — {{type}}",
      totalContactsByUser: "Total de contactos por usuario",
    },
    emptyGeneral: "Selecciona un período y haz clic en Filtrar para generar el informe",
    emptyForwarding: "Selecciona un período y haz clic en Filtrar para generar el informe de reenvíos",
    files: {
      generalExcel: "informe-uso-general-{{from}}-{{to}}",
      generalSheet: "Informe general",
      forwardingExcel: "informe-reenvios-{{from}}-{{to}}",
      generalPrint: "Informe_Uso_General_{{from}}_{{to}}",
      detailedPrint: "Informe_Uso_Detallado_{{from}}_{{to}}",
      forwardingPrint: "Informe_Reenvios_{{from}}_{{to}}",
    },
    forwarding: {
      reportTitle: "Informe de reenvíos",
      types: {
        move: "Movimiento",
        copy: "Copia",
        create: "Creación",
      },
      createdTitle: "Creación de tarjetas",
      createdEmpty: "No se creó ninguna tarjeta en el período.",
      cardsCreated: "Tarjetas creadas",
      forwardedTitle: "Tarjetas reenviadas a otros usuarios",
      forwardedEmpty: "No se reenvió ninguna tarjeta a otro usuario en el período.",
      origin: "Origen",
      destination: "Destino",
      quantity: "Cantidad",
      totalAllDestinations: "Total (todos los destinos)",
      rowsPerPage: "Destinos por página",
      displayedRows: "{{from}}-{{to}} de {{total}} destinos",
    },
    print: {
      noData: "No hay datos disponibles para imprimir.",
      generalTitle: "Informe de uso - General",
      detailedTitle: "Informe de uso - Detallado por usuario",
      totalRecords: "Total de registros: {{total}}",
      noRecordsForFilters: "No se encontraron registros para los filtros seleccionados.",
      noTypeSummary: "Sin atenciones por tipo",
      unknownUser: "Usuario no identificado",
    },
    details: {
      contactDate: "Fecha de contacto",
      client: "Cliente",
      contactMethod: "Medio de contacto",
      contactMethodFull: "Medio de contacto",
      result: "Resultado",
      nextAction: "Próxima acción",
      nextActionDate: "Fecha próx. acción",
      reasons: "Motivos",
    },
    reasons: {
      followUp: "Seguimiento",
      meetings: "Reuniones",
      calls: "Llamadas",
      visits: "Visitas",
      emails: "Correos",
      quotes: "Presupuestos",
      negotiations: "Negociaciones",
      closings: "Cierres",
      afterSales: "Posventa",
      complaints: "Reclamos",
      referrals: "Referencias",
      others: "Otros",
    },
    modal: {
      title: "Detalle - {{user}} - {{type}}",
      totalRecords: "Total de registros:",
      emptyText: "No hay datos disponibles para el período seleccionado.",
      printSubtitle: "Período: {{period}} | Total: {{total}} | Impreso el: {{date}}",
    },
  },
    },
  },
};

export { messages };
